"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MindsetApiClient = exports.MindsetApiError = exports.parseMindsetCustomerConfiguration = void 0;
exports.isMindsetApiError = isMindsetApiError;
exports.createMindsetApiClient = createMindsetApiClient;
exports.parseMindsetIntegrationIdentity = parseMindsetIntegrationIdentity;
exports.parseMindsetRecordingCaptureStatus = parseMindsetRecordingCaptureStatus;
const partner_brands_1 = require("./partner-brands");
__exportStar(require("./partner-brands"), exports);
const account_auth_1 = require("./account-auth");
const integration_feature_policy_1 = require("./integration-feature-policy");
__exportStar(require("./integration-feature-policy"), exports);
const customer_configuration_1 = require("./customer-configuration");
const customer_sdk_release_1 = require("./customer-sdk-release");
const customer_integration_handoff_1 = require("./customer-integration-handoff");
__exportStar(require("./customer-sdk-release"), exports);
__exportStar(require("./customer-integration-handoff"), exports);
var customer_configuration_2 = require("./customer-configuration");
Object.defineProperty(exports, "parseMindsetCustomerConfiguration", { enumerable: true, get: function () { return customer_configuration_2.parseMindsetCustomerConfiguration; } });
const sdk_1 = require("@mindset/sdk");
/** A normalized error for every request failure emitted by this client. */
class MindsetApiError extends Error {
    constructor(options) {
        super(options.message);
        this.name = "MindsetApiError";
        this.kind = options.kind;
        this.code = options.code;
        this.status = options.status ?? null;
        this.requestId = options.requestId ?? null;
        this.details = redactSensitiveValue(options.details, []);
        this.attempts = options.attempts ?? 1;
        this.retryable = options.retryable ?? false;
        Object.setPrototypeOf(this, new.target.prototype);
    }
    toJSON() {
        return {
            name: this.name,
            kind: this.kind,
            code: this.code,
            message: this.message,
            status: this.status,
            requestId: this.requestId,
            attempts: this.attempts,
            retryable: this.retryable,
            ...(this.details === undefined ? {} : { details: this.details }),
        };
    }
}
exports.MindsetApiError = MindsetApiError;
function isMindsetApiError(error) {
    return error instanceof MindsetApiError;
}
const DEFAULT_TIMEOUT_MS = 10000;
const DEFAULT_MAX_RESPONSE_BYTES = 1048576;
const DEFAULT_RETRY = {
    maxAttempts: 3,
    initialDelayMs: 100,
    maxDelayMs: 1000,
    multiplier: 2,
    jitterRatio: 0.2,
};
const RETRYABLE_HTTP_STATUSES = new Set([408, 425, 429, 500, 502, 503, 504]);
const MESSAGE_REPORT_STATUSES = new Set([
    "OPEN",
    "REVIEWED",
    "DISMISSED",
    "ACTIONED",
]);
const V2_GROUP_CALL_STATUSES = [
    "INVITING",
    "RINGING",
    "ACTIVE",
    "ENDED",
    "CANCELLED",
    "EXPIRED",
];
const V2_GROUP_CALL_INVITATION_STATUSES = [
    "PENDING",
    "RINGING",
    "ACCEPTED",
    "DECLINED",
    "MISSED",
    "CANCELLED",
    "REMOVED",
];
const V2_SCHEDULED_CALL_STATUSES = [
    "SCHEDULED",
    "CANCELLED",
    "STARTED",
    "COMPLETED",
];
const V2_RECORDING_DECISION_STATUSES = [
    "PENDING",
    "APPROVED",
    "DECLINED",
    "REVOKED",
    "EXPIRED",
];
const V2_RECORDING_REQUEST_STATUSES = [
    "PENDING",
    "APPROVED",
    "PARTIAL",
    "DECLINED",
    "RECORDING",
    "LOCAL_SIDE_ONLY",
    "CONTINUING_WITHOUT_RECORDING",
    "CANCELLED",
    "STOPPED",
    "EXPIRED",
];
const V2_RECORDING_ASSET_STATUSES = [
    "RECORDING",
    "READY",
    "FAILED",
    "DELETED",
];
const V2_ATTACHMENT_KINDS = ["IMAGE", "VIDEO", "AUDIO", "FILE"];
const V2_ATTACHMENT_STATUSES = [
    "UPLOAD_PENDING",
    "UPLOADED",
    "SCANNING",
    "CLEAN",
    "BLOCKED",
    "FAILED",
    "COMMITTED",
    "DELETED",
];
const V2_ATTACHMENT_BYTE_LIMITS = {
    IMAGE: 10 * 1024 * 1024,
    VIDEO: 80 * 1024 * 1024,
    AUDIO: 16 * 1024 * 1024,
    FILE: 25 * 1024 * 1024,
};
const V2_ATTACHMENT_CONTENT_TYPES = {
    IMAGE: ["image/jpeg", "image/png", "image/webp", "image/heic", "image/heif"],
    VIDEO: ["video/mp4", "video/quicktime", "video/webm", "video/x-m4v"],
    AUDIO: ["audio/aac", "audio/m4a", "audio/mp4", "audio/mpeg", "audio/webm", "audio/wav"],
    FILE: [
        "application/pdf",
        "text/plain",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    ],
};
const NON_RETRYABLE_HTTP_ERROR_CODES = new Set([
    "CONCURRENT_CALL_QUOTA_EXCEEDED",
    "DEVICE_REGISTRATION_QUOTA_EXCEEDED",
    "DEVICE_PUSH_TOKEN_CONFLICT",
]);
class MindsetApiClient {
    async contactWidgetRequest(method, path, body, options) {
        if (!/^(?:contexts|sessions|session|messages|settings|requests|history|verification\/(?:config|start|verify)|call\/(?:start|end|join)|call|requests\/[A-Za-z0-9_-]+\/respond|recipient\/(?:history|settings|requests|requests\/[A-Za-z0-9_-]+\/respond))(?:\?[^#]*)?$/.test(path))
            throw new TypeError("Unsupported widget operation");
        return this.request(`/mindset/v1/tenants/${encodeIdentifier(this.tenantId, "tenantId")}/contact-widget/${path}`, method, body, { ...options, retry: false }, false);
    }
    async getAccountAuthConfig(options) {
        const value = await this.request(`${this.v2TenantPath}/account-auth/config`, "GET", undefined, options, true);
        try {
            return (0, account_auth_1.parseAccountAuthConfig)(value);
        }
        catch {
            throw invalidResponse("Mindset returned an invalid account authentication response");
        }
    }
    async accountAuthOperation(operation, body, options) {
        const operations = ["email/request", "email/verify", "mfa/verify", "security/status", "security/enrollment/request", "security/enrollment/verify", "security/enrollment/confirm", "security/disable", "security/recovery/rotate", "exchange-policy", "session-policy"];
        if (typeof operation !== "string" || !operations.includes(operation))
            throw new TypeError("Unsupported account authentication operation");
        const value = await this.request(`${this.v2TenantPath}/account-auth/${operation}`, "POST", body, options, false);
        try {
            return (0, account_auth_1.parseAccountAuthResult)(operation, value);
        }
        catch {
            throw invalidResponse("Mindset returned an invalid account authentication response");
        }
    }
    constructor(options) {
        this.baseUrl = normalizeBaseUrl(options.baseUrl);
        this.tenantId = requireIdentifier(options.tenantId, "tenantId");
        this.credential = options.credential;
        this.cloudRunIdentityToken = options.cloudRunIdentityToken;
        this.timeoutMs = normalizeTimeout(options.timeoutMs ?? DEFAULT_TIMEOUT_MS);
        this.retry = normalizeRetry(options.retry);
        this.maxResponseBytes = positiveInteger(options.maxResponseBytes ?? DEFAULT_MAX_RESPONSE_BYTES, "maxResponseBytes");
        this.fetchImplementation = options.fetch ?? defaultFetch;
    }
    async getTenantCapabilities(options) {
        const payload = await this.request(`/mindset/v1/tenants/${this.encodedTenantId}/capabilities`, "GET", undefined, options, true);
        const record = requireRecord(payload, "tenant capabilities response");
        if (!isRecord(record.tenant) || !isRecord(record.capabilities)) {
            throw invalidResponse("Mindset returned an invalid tenant capabilities response");
        }
        return record;
    }
    async startCall(input, options) {
        const { conversationId, idempotencyKey, ...rest } = input;
        const normalizedIdempotencyKey = idempotencyKey === undefined
            ? undefined
            : requireIdempotencyKey(idempotencyKey);
        const body = {
            ...rest,
            ...(normalizedIdempotencyKey
                ? { idempotencyKey: normalizedIdempotencyKey }
                : {}),
        };
        const payload = await this.request(`/mindset/v1/tenants/${this.encodedTenantId}/conversations/${encodeIdentifier(conversationId, "conversationId")}/calls`, "POST", body, options, normalizedIdempotencyKey !== undefined);
        return readCall(payload);
    }
    async getCall(callId, options) {
        const payload = await this.request(this.callPath(callId), "GET", undefined, options, true);
        return readCall(payload);
    }
    async listActiveCalls(userId, options = {}) {
        const limit = options.limit ?? 50;
        if (!Number.isInteger(limit) || limit < 1 || limit > 100) {
            throw new TypeError("limit must be an integer from 1 to 100");
        }
        const payload = await this.request(`/mindset/v1/tenants/${this.encodedTenantId}/users/${encodeIdentifier(userId, "userId")}/calls/active?limit=${limit}`, "GET", undefined, options, true);
        return readCalls(payload);
    }
    async listCallHistory(userId, input = {}, options) {
        const query = this.listQuery(input).toString();
        const payload = await this.request(`/mindset/v1/tenants/${this.encodedTenantId}/users/${encodeIdentifier(userId, "userId")}/calls/history${query ? `?${query}` : ""}`, "GET", undefined, options, true);
        return readCalls(payload);
    }
    async getV2AccountProfile(userId, options) {
        const normalizedUserId = requireIdentifier(userId, "userId");
        const payload = await this.request(this.v2AccountPath(normalizedUserId), "GET", undefined, options, true);
        return readV2AccountProfileResponse(payload, this.tenantId, normalizedUserId);
    }
    async checkV2HandleAvailability(userId, input, options) {
        const payload = await this.request(`${this.v2AccountPath(requireIdentifier(userId, "userId"))}/handle-availability`, "POST", input, options, true);
        const record = requireRecord(payload, "handle availability response");
        if (record.available === true && record.reason === null)
            return { available: true, reason: null };
        if (record.available === false && typeof record.reason === "string" &&
            record.reason.trim().length > 0 && record.reason.length <= 180) {
            return { available: false, reason: record.reason };
        }
        throw invalidResponse("Mindset returned an invalid handle availability response");
    }
    async completeV2Account(userId, input, options) {
        const normalizedUserId = requireIdentifier(userId, "userId");
        const payload = await this.request(`${this.v2AccountPath(normalizedUserId)}/complete`, "POST", input, options, false);
        return readV2AccountCompletion(payload, this.tenantId, normalizedUserId);
    }
    async searchV2Directory(userId, input, options) {
        const normalizedUserId = requireIdentifier(userId, "userId");
        const payload = await this.request(`${this.v2AccountPath(normalizedUserId)}/directory/search`, "POST", input, options, true);
        return readV2DirectoryProfiles(payload, this.tenantId);
    }
    async updateV2DirectoryVisibility(userId, input, options) {
        const normalizedUserId = requireIdentifier(userId, "userId");
        const payload = await this.request(`${this.v2AccountPath(normalizedUserId)}/directory-visibility`, "PATCH", input, options, false);
        return readV2AccountProfileResponse(payload, this.tenantId, normalizedUserId);
    }
    async syncV2DirectoryContacts(userId, input, options) {
        const normalizedUserId = requireIdentifier(userId, "userId");
        const payload = await this.request(`${this.v2AccountPath(normalizedUserId)}/directory-contacts`, "PUT", input, options, false);
        return readV2DirectoryContactSync(payload, this.tenantId, normalizedUserId);
    }
    async listV2Contacts(userId, options) {
        const normalizedUserId = requireIdentifier(userId, "userId");
        const payload = await this.request(`${this.v2AccountPath(normalizedUserId)}/contacts`, "GET", undefined, options, true);
        return readV2SavedContacts(payload, this.tenantId, normalizedUserId);
    }
    async saveV2Contact(userId, contactUserId, input, options) {
        const normalizedUserId = requireIdentifier(userId, "userId");
        const normalizedContactId = requireIdentifier(contactUserId, "contactUserId");
        const payload = await this.request(`${this.v2AccountPath(normalizedUserId)}/contacts/${encodeURIComponent(normalizedContactId)}`, "PUT", input, options, false);
        const record = requireRecord(payload, "v2 saved contact response");
        return readV2SavedContactValue(record.contact, this.tenantId, normalizedUserId);
    }
    async removeV2Contact(userId, contactUserId, options) {
        const normalizedUserId = requireIdentifier(userId, "userId");
        const normalizedContactId = requireIdentifier(contactUserId, "contactUserId");
        const payload = await this.request(`${this.v2AccountPath(normalizedUserId)}/contacts/${encodeURIComponent(normalizedContactId)}`, "DELETE", undefined, options, false);
        if (!isRecord(payload) ||
            payload.contractVersion !== sdk_1.MINDSET_ACCOUNTS_V2_CONTRACT_VERSION ||
            payload.tenantId !== this.tenantId ||
            payload.userId !== normalizedUserId ||
            typeof payload.contactUserId !== "string" ||
            typeof payload.removed !== "boolean") {
            throw invalidResponse("Mindset returned an invalid contact removal result");
        }
        return payload;
    }
    async listV2ContactAttempts(userId, limit = 100, options) {
        const normalizedUserId = requireIdentifier(userId, "userId");
        const payload = await this.request(`${this.v2AccountPath(normalizedUserId)}/contact-attempts?limit=${limit}`, "GET", undefined, options, true);
        return readV2ContactAttempts(payload, this.tenantId, normalizedUserId);
    }
    async updateV2WorkHours(userId, timeZone, options) {
        const normalizedUserId = requireIdentifier(userId, "userId");
        const payload = await this.request(`${this.v2AccountPath(normalizedUserId)}/work-hours`, "PATCH", { timeZone }, options, false);
        return readV2AccountProfileResponse(payload, this.tenantId, normalizedUserId);
    }
    async createV2ProfileAvatarUploadIntent(userId, input, options) {
        const normalizedUserId = requireIdentifier(userId, "userId");
        const payload = await this.request(`${this.v2AccountPath(normalizedUserId)}/avatar-upload-intents`, "POST", input, options, false);
        return readV2ProfileAvatarUploadIntent(payload, this.tenantId, normalizedUserId);
    }
    async getV2ProfileAvatarDownloadGrant(userId, assetId, options) {
        const normalizedUserId = requireIdentifier(userId, "userId");
        const payload = await this.request(`${this.v2AccountPath(normalizedUserId)}/avatar-assets/${encodeIdentifier(assetId, "assetId")}/download`, "GET", undefined, options, true);
        return readV2ProfileAvatarDownloadGrant(payload);
    }
    async finalizeV2ProfileAvatarUpload(userId, assetId, input, options) {
        const normalizedUserId = requireIdentifier(userId, "userId");
        const normalizedAssetId = encodeIdentifier(assetId, "assetId");
        const payload = await this.request(`${this.v2AccountPath(normalizedUserId)}/avatar-assets/${normalizedAssetId}/finalize`, "POST", input, options, false);
        return readV2ProfileAvatarAsset(payload, this.tenantId, normalizedUserId, assetId);
    }
    async listV2AccountCompanies(userId, options) {
        const normalizedUserId = requireIdentifier(userId, "userId");
        const payload = await this.request(`${this.v2AccountPath(normalizedUserId)}/companies`, "GET", undefined, options, true);
        return readV2CompanyList(payload, this.tenantId);
    }
    async createV2Company(input, options) {
        const payload = await this.request(`${this.v2TenantPath}/companies`, "POST", input, options, false);
        return readV2CompanyResponse(payload, this.tenantId);
    }
    async getV2Company(companyId, actorUserId, options) {
        const normalizedCompanyId = requireIdentifier(companyId, "companyId");
        const payload = await this.request(`${this.v2CompanyPath(normalizedCompanyId)}?actorUserId=${encodeURIComponent(requireIdentifier(actorUserId, "actorUserId"))}`, "GET", undefined, options, true);
        return readV2CompanyResponse(payload, this.tenantId, normalizedCompanyId);
    }
    async addV2CompanyMember(companyId, input, options) {
        const normalizedCompanyId = requireIdentifier(companyId, "companyId");
        const payload = await this.request(`${this.v2CompanyPath(normalizedCompanyId)}/members`, "POST", input, options, false);
        return readV2CompanyResponse(payload, this.tenantId, normalizedCompanyId);
    }
    async updateV2CompanyMember(companyId, memberUserId, input, options) {
        const normalizedCompanyId = requireIdentifier(companyId, "companyId");
        const payload = await this.request(`${this.v2CompanyPath(normalizedCompanyId)}/members/${encodeIdentifier(memberUserId, "memberUserId")}`, "PATCH", input, options, false);
        return readV2CompanyResponse(payload, this.tenantId, normalizedCompanyId);
    }
    // ---- Phase 2C team management (contracts §2) ------------------------------
    // The gateway overwrites `actorUserId` with the LOGIN before calling any of
    // these (contracts §0 defect 1), so the value that reaches the api is never
    // the act_pu-substituted `co:<companyId>` persona.
    async getCompanyTeam(companyId, input, options) {
        const normalizedCompanyId = requireIdentifier(companyId, "companyId");
        const payload = await this.request(`${this.v2CompanyPath(normalizedCompanyId)}/team?actorUserId=${encodeURIComponent(requireIdentifier(input.actorUserId, "actorUserId"))}`, "GET", undefined, options, true);
        return readCompanyTeamResponse(payload, normalizedCompanyId);
    }
    async getIntegrationFeaturePolicy(companyId, actorUserId, applicationId, options) {
        const app = requireIdentifier(applicationId, "applicationId");
        const payload = await this.request(`${this.v2CompanyPath(requireIdentifier(companyId, "companyId"))}/integration-applications/${encodeURIComponent(app)}/feature-policy?actorUserId=${encodeURIComponent(requireIdentifier(actorUserId, "actorUserId"))}`, "GET", undefined, options, true);
        try {
            return (0, integration_feature_policy_1.parseMindsetIntegrationFeaturePolicyResponse)(payload, app);
        }
        catch {
            throw invalidResponse("Invalid integration feature policy response");
        }
    }
    async updateIntegrationFeaturePolicy(companyId, actorUserId, applicationId, input, options) {
        const app = requireIdentifier(applicationId, "applicationId");
        const update = (0, integration_feature_policy_1.parseMindsetIntegrationFeaturePolicyUpdate)(input);
        const payload = await this.request(`${this.v2CompanyPath(requireIdentifier(companyId, "companyId"))}/integration-applications/${encodeURIComponent(app)}/feature-policy`, "PUT", { actorUserId: requireIdentifier(actorUserId, "actorUserId"), ...update }, { ...options, retry: false }, false);
        try {
            return (0, integration_feature_policy_1.parseMindsetIntegrationFeaturePolicyResponse)(payload, app);
        }
        catch {
            throw invalidResponse("Invalid integration feature policy response");
        }
    }
    async listIntegrationApplicationDrafts(companyId, actorUserId, options) {
        const scope = requireIdentifier(companyId, "companyId");
        const payload = requireRecord(await this.request(`${this.v2CompanyPath(scope)}/integration-applications?actorUserId=${encodeURIComponent(requireIdentifier(actorUserId, "actorUserId"))}`, "GET", undefined, options, true), "application drafts response");
        if (!Array.isArray(payload.applications) || payload.applications.length > 100)
            throw invalidResponse("Invalid application draft list");
        const drafts = payload.applications.map((draft) => readIntegrationApplicationDraft(draft, scope));
        if (new Set(drafts.map((draft) => draft.id)).size !== drafts.length)
            throw invalidResponse("Duplicate application drafts");
        return drafts;
    }
    async requestIntegrationProvisioning(companyId, actorUserId, applicationId, requestKey, options) {
        const scope = requireIdentifier(companyId, "companyId");
        const application = requireIdentifier(applicationId, "applicationId");
        if (!/^[A-Za-z0-9_-]{8,80}$/.test(requestKey))
            throw new TypeError("Invalid provisioning request key");
        const extraHeaders = Object.fromEntries(Object.entries(options?.headers ?? {}).filter(([key]) => key.toLowerCase() !== "idempotency-key"));
        const payload = requireRecord(await this.request(`${this.v2CompanyPath(scope)}/integration-applications/${encodeURIComponent(application)}/provisioning`, "POST", { actorUserId: requireIdentifier(actorUserId, "actorUserId") }, { ...options, retry: false, headers: { ...extraHeaders, "idempotency-key": requestKey } }, false), "provisioning response");
        const operation = readIntegrationProvisioning(payload.operation, scope);
        if (operation.applicationId !== application)
            throw invalidResponse("Out-of-scope provisioning application");
        return operation;
    }
    async refreshIntegrationCheckout(companyId, actorUserId, operationId, options) {
        const scope = requireIdentifier(companyId, "companyId"), operation = requireIdentifier(operationId, "operationId");
        const payload = requireRecord(await this.request(`${this.v2CompanyPath(scope)}/integration-subscriptions/checkouts/${encodeURIComponent(operation)}/refresh`, "POST", { actorUserId: requireIdentifier(actorUserId, "actorUserId") }, { ...options, retry: false }, false), "checkout response");
        if (!Object.keys(payload).every((key) => key === "status" || key === "checkoutUrl") ||
            !["pending", "open", "processing", "complete", "expired", "reconciliation_required"].includes(String(payload.status)) ||
            (payload.checkoutUrl !== null && typeof payload.checkoutUrl !== "string"))
            throw invalidResponse("Invalid checkout response");
        if (typeof payload.checkoutUrl === "string") {
            let url;
            try {
                url = new URL(payload.checkoutUrl);
            }
            catch {
                throw invalidResponse("Invalid checkout URL");
            }
            if (payload.status !== "open" || payload.checkoutUrl.length > 4096 || url.origin !== "https://checkout.stripe.com" || url.username || url.password)
                throw invalidResponse("Invalid checkout URL");
        }
        return { status: payload.status, checkoutUrl: payload.checkoutUrl };
    }
    async recoverIntegrationCheckout(companyId, actorUserId, operationId, providerSessionId, confirmExistingSession, options) {
        const scope = requireIdentifier(companyId, "companyId"), operation = requireIdentifier(operationId, "operationId");
        if (confirmExistingSession !== true || !/^cs_(test|live)_[A-Za-z0-9]+$/.test(providerSessionId) || providerSessionId.length > 255)
            throw new Error("Invalid checkout recovery request");
        const payload = requireRecord(await this.request(`${this.v2CompanyPath(scope)}/integration-subscriptions/checkouts/${encodeURIComponent(operation)}/recover`, "POST", { actorUserId: requireIdentifier(actorUserId, "actorUserId"), providerSessionId, confirmExistingSession }, { ...options, retry: false }, false), "checkout recovery");
        if (!hasExactKeys(payload, ["status"]) || !["attached", "already_attached"].includes(String(payload.status)))
            throw invalidResponse("Invalid checkout recovery response");
        return { status: payload.status };
    }
    async listIntegrationCheckoutPlans(companyId, actorUserId, options) {
        const scope = requireIdentifier(companyId, "companyId");
        const { environment: selected, ...requestOptions } = options ?? {};
        const environment = selected === undefined ? "sandbox" : selected;
        if (environment !== "sandbox" && environment !== "production")
            throw new TypeError("Invalid checkout environment");
        const query = new URLSearchParams({ actorUserId: requireIdentifier(actorUserId, "actorUserId") });
        if (selected !== undefined)
            query.set("environment", environment);
        const payload = requireRecord(await this.request(`${this.v2CompanyPath(scope)}/integration-subscriptions/checkouts/plans?${query}`, "GET", undefined, requestOptions, false), "checkout plans response");
        if (!Array.isArray(payload.plans) || payload.plans.length > 20)
            throw invalidResponse("Invalid checkout plans");
        const seen = new Set();
        return payload.plans.map((raw) => {
            const plan = readCheckoutPlan(raw), key = `${plan.environment}:${plan.planKey}:${plan.planVersion}`;
            if (plan.environment !== environment)
                throw invalidResponse("Out-of-scope checkout environment");
            if (seen.has(key))
                throw invalidResponse("Duplicate checkout plan");
            seen.add(key);
            return plan;
        });
    }
    async requestIntegrationCheckout(companyId, actorUserId, requestKey, checkout, options) {
        const scope = requireIdentifier(companyId, "companyId");
        if (!/^[A-Za-z0-9_-]{8,80}$/.test(requestKey) || !isRecord(checkout) || (checkout.environment !== "sandbox" && checkout.environment !== "production") ||
            typeof checkout.planKey !== "string" || !/^[a-z][a-z0-9-]{1,78}[a-z0-9]$/.test(checkout.planKey) ||
            !Number.isSafeInteger(checkout.planVersion) || checkout.planVersion < 1 ||
            (checkout.businessHandleQuantity !== undefined && !validBusinessHandleQuantity(checkout.businessHandleQuantity)) ||
            Object.keys(checkout).some((key) => !["environment", "planKey", "planVersion", "businessHandleQuantity"].includes(key)))
            throw new TypeError("Invalid checkout request");
        const extraHeaders = Object.fromEntries(Object.entries(options?.headers ?? {}).filter(([key]) => key.toLowerCase() !== "idempotency-key"));
        const payload = requireRecord(await this.request(`${this.v2CompanyPath(scope)}/integration-subscriptions/checkouts`, "POST", { actorUserId: requireIdentifier(actorUserId, "actorUserId"), checkout }, { ...options, retry: false, headers: { ...extraHeaders, "idempotency-key": requestKey } }, false), "checkout response");
        const result = readCheckoutOperation(payload.operation, scope);
        if (result.environment !== checkout.environment || result.planKey !== checkout.planKey || result.planVersion !== checkout.planVersion ||
            result.businessHandleQuantity !== checkout.businessHandleQuantity)
            throw invalidResponse("Out-of-scope checkout plan");
        return result;
    }
    async getCurrentIntegrationCheckout(companyId, actorUserId, options) {
        const scope = requireIdentifier(companyId, "companyId");
        const { environment: selected, ...requestOptions } = options ?? {};
        const environment = selected === undefined ? "sandbox" : selected;
        if (environment !== "sandbox" && environment !== "production")
            throw new TypeError("Invalid checkout environment");
        const query = new URLSearchParams({ actorUserId: requireIdentifier(actorUserId, "actorUserId") });
        if (selected !== undefined)
            query.set("environment", environment);
        const payload = requireRecord(await this.request(`${this.v2CompanyPath(scope)}/integration-subscriptions/checkouts/current?${query}`, "GET", undefined, requestOptions, false), "checkout response");
        if (payload.operation === null)
            return null;
        const result = readCheckoutOperation(payload.operation, scope);
        if (result.environment !== environment)
            throw invalidResponse("Out-of-scope checkout environment");
        if (result.state === "EXPIRED")
            throw invalidResponse("Invalid current checkout state");
        return result;
    }
    async getIntegrationCheckout(companyId, actorUserId, operationId, options) {
        const scope = requireIdentifier(companyId, "companyId"), operation = requireIdentifier(operationId, "operationId");
        const query = new URLSearchParams({ actorUserId: requireIdentifier(actorUserId, "actorUserId") });
        const payload = requireRecord(await this.request(`${this.v2CompanyPath(scope)}/integration-subscriptions/checkouts/${encodeURIComponent(operation)}?${query}`, "GET", undefined, options, false), "checkout response");
        const result = readCheckoutOperation(payload.operation, scope);
        if (result.id !== operation)
            throw invalidResponse("Out-of-scope checkout operation");
        return result;
    }
    async issueAndroidVerificationChallenge(companyId, actorUserId, applicationId, packageName, certificateSha256, options) {
        const scope = requireIdentifier(companyId, "companyId"), application = requireIdentifier(applicationId, "applicationId");
        if (typeof packageName === "string")
            packageName = packageName.trim();
        if (!isNonEmptyString(packageName) || !/^[A-Za-z][A-Za-z0-9_]*(?:\.[A-Za-z][A-Za-z0-9_]*)+$/.test(packageName) || packageName.length > 160 ||
            !/^(?:[0-9A-F]{2}:){31}[0-9A-F]{2}$/.test(certificateSha256))
            throw new TypeError("Invalid Android application identity");
        const payload = requireRecord(await this.request(`${this.v2CompanyPath(scope)}/integration-applications/${encodeURIComponent(application)}/android-verification-challenges`, "POST", { actorUserId: requireIdentifier(actorUserId, "actorUserId"), packageName, certificateSha256 }, { ...options, retry: false }, false), "Android challenge response");
        const challenge = requireRecord(payload.challenge, "Android challenge"), binding = requireRecord(challenge.binding, "Android binding");
        if (!hasExactKeys(payload, ["challenge", "requestHash"]) || typeof payload.requestHash !== "string" || !/^[A-Za-z0-9_-]{43}$/.test(payload.requestHash) ||
            !hasExactKeys(challenge, ["id", "binding", "nonce", "issuedAt", "expiresAt"]) || !isNonEmptyString(challenge.id) ||
            typeof challenge.nonce !== "string" || !/^[A-Za-z0-9_-]{43}$/.test(challenge.nonce) ||
            !isTimestamp(challenge.issuedAt) || !isTimestamp(challenge.expiresAt) || Date.parse(challenge.expiresAt) - Date.parse(challenge.issuedAt) !== 900000 ||
            !hasExactKeys(binding, ["tenantId", "companyId", "applicationId", "applicationRevision", "environment", "packageName", "certificateSha256"]) ||
            !isNonEmptyString(binding.tenantId) || binding.companyId !== scope || binding.applicationId !== application ||
            binding.packageName !== packageName || binding.certificateSha256 !== certificateSha256 ||
            typeof binding.applicationRevision !== "string" || !/^[a-f0-9]{64}$/.test(binding.applicationRevision) ||
            (binding.environment !== "sandbox" && binding.environment !== "production"))
            throw invalidResponse("Invalid Android challenge binding");
        return { requestHash: payload.requestHash, challenge: { id: challenge.id, nonce: challenge.nonce,
                issuedAt: challenge.issuedAt, expiresAt: challenge.expiresAt, binding: { tenantId: binding.tenantId,
                    companyId: scope, applicationId: application, applicationRevision: binding.applicationRevision,
                    environment: binding.environment, packageName, certificateSha256 } } };
    }
    async observeAndroidAssociation(companyId, actorUserId, challengeId, origin, options) {
        const scope = requireIdentifier(companyId, "companyId"), id = requireIdentifier(challengeId, "challengeId");
        const url = new URL(origin);
        if (origin.length > 2048 || origin !== url.origin || url.protocol !== "https:")
            throw new TypeError("Invalid association origin");
        const payload = requireRecord(await this.request(`${this.v2CompanyPath(scope)}/integration-applications/android-verification-challenges/${encodeURIComponent(id)}/association`, "POST", { actorUserId: requireIdentifier(actorUserId, "actorUserId"), origin }, { ...options, retry: false }, false), "Android association response");
        if (!hasExactKeys(payload, ["status", "challengeId", "origin", "packageName", "certificateSha256"]) ||
            payload.status !== "ASSOCIATED" || payload.challengeId !== id || payload.origin !== origin ||
            typeof payload.packageName !== "string" || payload.packageName.length > 160 ||
            !/^[A-Za-z][A-Za-z0-9_]*(?:\.[A-Za-z][A-Za-z0-9_]*)+$/.test(payload.packageName) ||
            typeof payload.certificateSha256 !== "string" || !/^(?:[0-9A-F]{2}:){31}[0-9A-F]{2}$/.test(payload.certificateSha256))
            throw invalidResponse("Invalid Android association observation");
        return { status: "ASSOCIATED", challengeId: id, origin, packageName: payload.packageName, certificateSha256: payload.certificateSha256 };
    }
    async revokeAndroidVerificationChallenge(companyId, actorUserId, challengeId, options) {
        const scope = requireIdentifier(companyId, "companyId"), id = requireIdentifier(challengeId, "challengeId");
        await this.request(`${this.v2CompanyPath(scope)}/integration-applications/android-verification-challenges/${encodeURIComponent(id)}/revoke`, "POST", { actorUserId: requireIdentifier(actorUserId, "actorUserId") }, { ...options, retry: false }, false);
    }
    async listAndroidVerificationChallenges(companyId, actorUserId, applicationId, options) {
        const scope = requireIdentifier(companyId, "companyId"), application = requireIdentifier(applicationId, "applicationId");
        const payload = requireRecord(await this.request(`${this.v2CompanyPath(scope)}/integration-applications/${encodeURIComponent(application)}/android-verification-challenges?actorUserId=${encodeURIComponent(requireIdentifier(actorUserId, "actorUserId"))}`, "GET", undefined, options, false), "Android verification response");
        if (!hasExactKeys(payload, ["challenges"]) || !Array.isArray(payload.challenges) || payload.challenges.length > 50)
            throw invalidResponse("Invalid Android verification list");
        return payload.challenges.map((value) => {
            if (!isRecord(value) || !hasExactKeys(value, ["id", "packageName", "certificateSha256", "issuedAt", "expiresAt", "consumedAt", "revokedAt", "status"]) ||
                !isNonEmptyString(value.id) || !isNonEmptyString(value.packageName) || value.packageName.length > 160 ||
                typeof value.certificateSha256 !== "string" || !/^(?:[0-9A-F]{2}:){31}[0-9A-F]{2}$/.test(value.certificateSha256) ||
                !isTimestamp(value.issuedAt) || !isTimestamp(value.expiresAt) || Date.parse(value.expiresAt) - Date.parse(value.issuedAt) !== 900000 ||
                (value.consumedAt !== null && !isTimestamp(value.consumedAt)) || (value.revokedAt !== null && !isTimestamp(value.revokedAt)) ||
                !["PENDING", "EXPIRED", "CONSUMED", "REVOKED"].includes(String(value.status)))
                throw invalidResponse("Invalid Android verification status");
            if (value.revokedAt ? value.status !== "REVOKED" : value.consumedAt ? value.status !== "CONSUMED" : !["PENDING", "EXPIRED"].includes(String(value.status)))
                throw invalidResponse("Inconsistent Android verification status");
            return { id: value.id, packageName: value.packageName, certificateSha256: value.certificateSha256,
                issuedAt: value.issuedAt, expiresAt: value.expiresAt, consumedAt: value.consumedAt, revokedAt: value.revokedAt,
                status: value.status };
        });
    }
    async issueIntegrationDomainChallenge(companyId, actorUserId, applicationId, origin, requestKey, options) {
        const scope = requireIdentifier(companyId, "companyId");
        const application = requireIdentifier(applicationId, "applicationId");
        if (!/^[A-Za-z0-9_-]{8,80}$/.test(requestKey))
            throw new TypeError("Invalid domain challenge request key");
        const normalizedOrigin = new URL(origin);
        if (origin.length > 2048 || normalizedOrigin.protocol !== "https:" || normalizedOrigin.username || normalizedOrigin.password ||
            normalizedOrigin.search || normalizedOrigin.hash || normalizedOrigin.pathname !== "/")
            throw new TypeError("Invalid verification origin");
        const extraHeaders = Object.fromEntries(Object.entries(options?.headers ?? {}).filter(([key]) => key.toLowerCase() !== "idempotency-key"));
        const payload = requireRecord(await this.request(`${this.v2CompanyPath(scope)}/integration-applications/${encodeURIComponent(application)}/domain-challenges`, "POST", { actorUserId: requireIdentifier(actorUserId, "actorUserId"), origin }, { ...options, retry: false, headers: { ...extraHeaders, "idempotency-key": requestKey } }, false), "domain challenge response");
        const challenge = readIntegrationDomainChallenge(payload.challenge);
        if (challenge.applicationId !== application || challenge.origin !== normalizedOrigin.origin)
            throw invalidResponse("Out-of-scope domain challenge");
        return challenge;
    }
    async registerIntegrationHostAccessPolicy(companyId, actorUserId, applicationId, requestKey, policy, options) {
        const scope = requireIdentifier(companyId, "companyId"), application = requireIdentifier(applicationId, "applicationId");
        if (!/^[A-Za-z0-9_-]{8,80}$/.test(requestKey) || !isRecord(policy) ||
            Object.keys(policy).some((key) => !["endpoint", "apiKey", "expectedVersion"].includes(key)) ||
            typeof policy.apiKey !== "string" || !/^[A-Za-z0-9_-]{43,128}$/.test(policy.apiKey) ||
            !Number.isInteger(policy.expectedVersion) || policy.expectedVersion < 0 || policy.expectedVersion > 1000)
            throw new TypeError("Invalid host access policy registration");
        const endpoint = readHostAccessEndpoint(policy.endpoint);
        const headers = Object.fromEntries(Object.entries(options?.headers ?? {}).filter(([key]) => key.toLowerCase() !== "idempotency-key"));
        const payload = requireRecord(await this.request(`${this.v2CompanyPath(scope)}/integration-applications/${encodeURIComponent(application)}/host-access-policies`, "POST", { actorUserId: requireIdentifier(actorUserId, "actorUserId"), policy: { ...policy, endpoint } }, { ...options, retry: false, headers: { ...headers, "idempotency-key": requestKey } }, false), "host access policy response");
        const result = readIntegrationHostAccessPolicy(payload.policy, application);
        if (result.endpoint !== endpoint || result.version !== policy.expectedVersion + 1)
            throw invalidResponse("Out-of-scope host access policy");
        return result;
    }
    async getCurrentIntegrationHostAccessPolicy(companyId, actorUserId, applicationId, options) {
        const scope = requireIdentifier(companyId, "companyId"), application = requireIdentifier(applicationId, "applicationId");
        const query = new URLSearchParams({ actorUserId: requireIdentifier(actorUserId, "actorUserId") });
        const payload = requireRecord(await this.request(`${this.v2CompanyPath(scope)}/integration-applications/${encodeURIComponent(application)}/host-access-policies/current?${query}`, "GET", undefined, options, true), "current host access policy response");
        return payload.policy === null ? null : readIntegrationHostAccessPolicy(payload.policy, application);
    }
    async verifyIntegrationHostAccessPolicy(companyId, actorUserId, policyId, options) {
        const scope = requireIdentifier(companyId, "companyId"), id = requireIdentifier(policyId, "policyId");
        const payload = requireRecord(await this.request(`${this.v2CompanyPath(scope)}/integration-applications/host-access-policies/${encodeURIComponent(id)}/verify`, "POST", { actorUserId: requireIdentifier(actorUserId, "actorUserId") }, { ...options, retry: false }, false), "host policy verification response");
        if (Object.keys(payload).length !== 2 || payload.status !== "verified" || payload.policyId !== id)
            throw invalidResponse("Invalid host policy verification response");
        return { status: "verified", policyId: id };
    }
    async verifyIntegrationDomainChallenge(companyId, actorUserId, challengeId, options) {
        const scope = requireIdentifier(companyId, "companyId");
        const id = requireIdentifier(challengeId, "challengeId");
        const payload = requireRecord(await this.request(`${this.v2CompanyPath(scope)}/integration-applications/domain-challenges/${encodeURIComponent(id)}/verify`, "POST", { actorUserId: requireIdentifier(actorUserId, "actorUserId") }, { ...options, retry: false }, false), "domain verification response");
        const challenge = readIntegrationDomainChallenge(payload.challenge);
        if (challenge.id !== id || !["verified", "pending", "expired", "unavailable", "aborted", "revoked"].includes(String(payload.status)) ||
            (payload.status === "verified" && challenge.state !== "VERIFIED") || (payload.status === "revoked" && challenge.state !== "REVOKED"))
            throw invalidResponse("Invalid domain verification result");
        return { status: payload.status, challenge };
    }
    async getCurrentIntegrationDomainChallenge(companyId, actorUserId, applicationId, origin, options) {
        const scope = requireIdentifier(companyId, "companyId");
        const application = requireIdentifier(applicationId, "applicationId");
        const normalized = new URL(origin);
        if (origin.length > 2048 || normalized.protocol !== "https:" || normalized.username || normalized.password || normalized.search || normalized.hash || normalized.pathname !== "/")
            throw new TypeError("Invalid verification origin");
        const payload = requireRecord(await this.request(`${this.v2CompanyPath(scope)}/integration-applications/${encodeURIComponent(application)}/domain-challenges/current?actorUserId=${encodeURIComponent(requireIdentifier(actorUserId, "actorUserId"))}&origin=${encodeURIComponent(origin)}`, "GET", undefined, options, true), "current domain challenge response");
        if (payload.challenge === null)
            return null;
        const challenge = readIntegrationDomainChallenge(payload.challenge);
        if (challenge.applicationId !== application || challenge.origin !== normalized.origin || challenge.state === "REVOKED")
            throw invalidResponse("Out-of-scope current domain challenge");
        return challenge;
    }
    async getIntegrationProvisioning(companyId, actorUserId, operationId, options) {
        const scope = requireIdentifier(companyId, "companyId");
        const id = requireIdentifier(operationId, "operationId");
        const payload = requireRecord(await this.request(`${this.v2CompanyPath(scope)}/integration-applications/provisioning/${encodeURIComponent(id)}?actorUserId=${encodeURIComponent(requireIdentifier(actorUserId, "actorUserId"))}`, "GET", undefined, options, true), "provisioning response");
        const operation = readIntegrationProvisioning(payload.operation, scope);
        if (operation.id !== id)
            throw invalidResponse("Out-of-scope provisioning operation");
        return operation;
    }
    async getIntegrationSdkRelease(companyId, actorUserId, applicationId, options) {
        const scope = requireIdentifier(companyId, "companyId"), application = requireIdentifier(applicationId, "applicationId");
        const payload = await this.request(`${this.v2CompanyPath(scope)}/integration-applications/${encodeURIComponent(application)}/sdk-release?actorUserId=${encodeURIComponent(requireIdentifier(actorUserId, "actorUserId"))}`, "GET", undefined, options, true);
        try {
            return (0, customer_sdk_release_1.parseMindsetCustomerSdkReleaseResponse)(payload);
        }
        catch {
            throw invalidResponse("Invalid SDK release");
        }
    }
    async getIntegrationCustomerHandoff(companyId, actorUserId, applicationId, options) {
        const scope = requireIdentifier(companyId, "companyId"), application = requireIdentifier(applicationId, "applicationId");
        const payload = await this.request(`${this.v2CompanyPath(scope)}/integration-applications/${encodeURIComponent(application)}/integration-handoff?actorUserId=${encodeURIComponent(requireIdentifier(actorUserId, "actorUserId"))}`, "GET", undefined, options, true);
        try {
            return (0, customer_integration_handoff_1.parseMindsetCustomerIntegrationHandoffResponse)(payload);
        }
        catch {
            throw invalidResponse("Invalid customer integration handoff");
        }
    }
    async createIntegrationSdkDownload(companyId, actorUserId, applicationId, input, options) {
        const { releaseId, assetId } = input;
        const scope = requireIdentifier(companyId, "companyId"), application = requireIdentifier(applicationId, "applicationId");
        if (!/^[0-9a-f]{64}$/.test(releaseId) || assetId !== "typescript-bundle")
            throw new TypeError("Invalid SDK download request");
        const payload = await this.request(`${this.v2CompanyPath(scope)}/integration-applications/${encodeURIComponent(application)}/sdk-release/download`, "POST", { actorUserId: requireIdentifier(actorUserId, "actorUserId"), releaseId, assetId }, options, true);
        try {
            return (0, customer_sdk_release_1.parseMindsetCustomerSdkDownloadResponse)(payload, { releaseId, assetId });
        }
        catch {
            throw invalidResponse("Invalid SDK download");
        }
    }
    async getIntegrationSdkConfiguration(companyId, actorUserId, applicationId, options) {
        const scope = requireIdentifier(companyId, "companyId");
        const application = requireIdentifier(applicationId, "applicationId");
        const payload = requireRecord(await this.request(`${this.v2CompanyPath(scope)}/integration-applications/${encodeURIComponent(application)}/sdk-configuration?actorUserId=${encodeURIComponent(requireIdentifier(actorUserId, "actorUserId"))}`, "GET", undefined, options, true), "SDK configuration response");
        let configuration;
        try {
            configuration = (0, customer_configuration_1.parseMindsetCustomerConfiguration)(payload.configuration);
        }
        catch {
            throw invalidResponse("Invalid SDK configuration");
        }
        if (configuration.applicationId !== application)
            throw invalidResponse("Out-of-scope SDK configuration");
        return configuration;
    }
    async getCurrentIntegrationProvisioning(companyId, actorUserId, applicationId, options) {
        const scope = requireIdentifier(companyId, "companyId");
        const application = requireIdentifier(applicationId, "applicationId");
        const payload = requireRecord(await this.request(`${this.v2CompanyPath(scope)}/integration-applications/${encodeURIComponent(application)}/provisioning/current?actorUserId=${encodeURIComponent(requireIdentifier(actorUserId, "actorUserId"))}`, "GET", undefined, options, true), "current provisioning response");
        if (payload.operation === null)
            return null;
        const operation = readIntegrationProvisioning(payload.operation, scope);
        if (operation.applicationId !== application)
            throw invalidResponse("Out-of-scope current provisioning operation");
        return operation;
    }
    async listIntegrationAudit(companyId, actorUserId, query = {}, options) {
        const scope = requireIdentifier(companyId, "companyId");
        const limit = query.limit ?? 50;
        if (!Number.isInteger(limit) || limit < 1 || limit > 50 ||
            (query.before === undefined) !== (query.beforeId === undefined) ||
            (query.before !== undefined && (!isTimestamp(query.before) || !isNonEmptyString(query.beforeId))))
            throw new TypeError("Invalid audit pagination");
        const cursor = query.before === undefined ? "" : `&before=${encodeURIComponent(query.before)}&beforeId=${encodeURIComponent(query.beforeId)}`;
        const response = requireRecord(await this.request(`${this.v2CompanyPath(scope)}/integration-applications/activity?actorUserId=${encodeURIComponent(requireIdentifier(actorUserId, "actorUserId"))}&limit=${limit}${cursor}`, "GET", undefined, options, true), "integration audit response");
        if (!Array.isArray(response.events) || response.events.length > limit)
            throw invalidResponse("Invalid integration audit page");
        const events = response.events.map((event) => {
            if (!isRecord(event) || event.companyId !== scope || !isNonEmptyString(event.id) ||
                !isNonEmptyString(event.actorUserId) || !isNonEmptyString(event.resourceId) ||
                !isNonEmptyString(event.action) || event.action.length > 48 || !isTimestamp(event.occurredAt)) {
                throw invalidResponse("Invalid or out-of-scope integration audit event");
            }
            return { id: event.id, companyId: scope, actorUserId: event.actorUserId, resourceId: event.resourceId, action: event.action, occurredAt: event.occurredAt };
        });
        if (new Set(events.map((event) => event.id)).size !== events.length)
            throw invalidResponse("Duplicate integration audit events");
        let previous = query.before === undefined ? null : { time: Date.parse(query.before), id: query.beforeId };
        for (const event of events) {
            const time = Date.parse(event.occurredAt);
            if (previous && (time > previous.time || (time === previous.time && event.id >= previous.id))) {
                throw invalidResponse("Integration audit page did not advance in order");
            }
            previous = { time, id: event.id };
        }
        const last = events.at(-1);
        if (response.nextCursor === null)
            return { events, nextCursor: null };
        const next = response.nextCursor;
        if (!last || events.length !== limit || !isRecord(next) || next.beforeId !== last.id || !isTimestamp(next.before) ||
            Date.parse(next.before) !== Date.parse(last.occurredAt))
            throw invalidResponse("Invalid integration audit cursor");
        return { events, nextCursor: { before: next.before, beforeId: last.id } };
    }
    async registerIntegrationApplicationDraft(companyId, actorUserId, requestKey, application, options) {
        const scope = requireIdentifier(companyId, "companyId");
        if (!/^[A-Za-z0-9_-]{8,80}$/.test(requestKey))
            throw new TypeError("Invalid application registration request key");
        if (application.identity !== undefined)
            parseMindsetIntegrationIdentity(application.identity, application.webOrigins);
        const extraHeaders = Object.fromEntries(Object.entries(options?.headers ?? {}).filter(([key]) => key.toLowerCase() !== "idempotency-key"));
        const payload = requireRecord(await this.request(`${this.v2CompanyPath(scope)}/integration-applications`, "POST", { actorUserId: requireIdentifier(actorUserId, "actorUserId"), application }, { ...options, retry: false, headers: { ...extraHeaders, "idempotency-key": requestKey } }, false), "application draft response");
        return readIntegrationApplicationDraft(payload.application, scope);
    }
    async replaceIntegrationApplicationOwnership(companyId, actorUserId, applicationId, requestKey, application, options) {
        const scope = requireIdentifier(companyId, "companyId");
        const id = requireIdentifier(applicationId, "applicationId");
        if (!/^[A-Za-z0-9_-]{8,80}$/.test(requestKey))
            throw new TypeError("Invalid application ownership request key");
        if (application.identity !== undefined)
            parseMindsetIntegrationIdentity(application.identity, application.webOrigins);
        const extraHeaders = Object.fromEntries(Object.entries(options?.headers ?? {}).filter(([key]) => key.toLowerCase() !== "idempotency-key"));
        const payload = requireRecord(await this.request(`${this.v2CompanyPath(scope)}/integration-applications/${encodeURIComponent(id)}/ownership`, "PATCH", { actorUserId: requireIdentifier(actorUserId, "actorUserId"), application }, { ...options, retry: false, headers: { ...extraHeaders, "idempotency-key": requestKey } }, false), "application ownership response");
        return readIntegrationApplicationDraft(payload.application, scope);
    }
    /**
     * Contract 2C section 2.4. P1 mounted the team-block variants of the two
     * member routes under /team/ so the legacy {company} responses that
     * 0.2.95 depends on keep their shape; these are the 2C surfaces that
     * return the refreshed team block.
     */
    async addCompanyTeamMember(companyId, input, options) {
        const normalizedCompanyId = requireIdentifier(companyId, "companyId");
        const payload = await this.request(`${this.v2CompanyPath(normalizedCompanyId)}/team/members`, "POST", input, options, false);
        return readCompanyTeamResponse(payload, normalizedCompanyId);
    }
    async updateCompanyTeamMember(companyId, memberUserId, input, options) {
        const normalizedCompanyId = requireIdentifier(companyId, "companyId");
        const normalizedMemberUserId = requireIdentifier(memberUserId, "memberUserId");
        const payload = await this.request(`${this.v2CompanyPath(normalizedCompanyId)}/team/members/${encodeURIComponent(normalizedMemberUserId)}`, "PATCH", input, options, false);
        return readCompanyTeamResponse(payload, normalizedCompanyId);
    }
    async createCompanyDepartment(companyId, input, options) {
        const normalizedCompanyId = requireIdentifier(companyId, "companyId");
        const payload = await this.request(`${this.v2CompanyPath(normalizedCompanyId)}/departments`, "POST", {
            actorUserId: requireIdentifier(input.actorUserId, "actorUserId"),
            name: requireIdentifier(input.name, "name"),
            ...(input.description === undefined
                ? {}
                : { description: input.description }),
        }, options, false);
        return readCompanyTeamResponse(payload, normalizedCompanyId);
    }
    async updateCompanyDepartment(companyId, departmentId, input, options) {
        const normalizedCompanyId = requireIdentifier(companyId, "companyId");
        const payload = await this.request(`${this.companyDepartmentPath(normalizedCompanyId, departmentId)}`, "PATCH", {
            actorUserId: requireIdentifier(input.actorUserId, "actorUserId"),
            ...(input.name === undefined ? {} : { name: input.name }),
            ...(input.description === undefined
                ? {}
                : { description: input.description }),
        }, options, false);
        return readCompanyTeamResponse(payload, normalizedCompanyId);
    }
    async deleteCompanyDepartment(companyId, departmentId, input, options) {
        const normalizedCompanyId = requireIdentifier(companyId, "companyId");
        const payload = await this.request(`${this.companyDepartmentPath(normalizedCompanyId, departmentId)}?actorUserId=${encodeURIComponent(requireIdentifier(input.actorUserId, "actorUserId"))}`, "DELETE", undefined, options, false);
        return readCompanyTeamResponse(payload, normalizedCompanyId);
    }
    async setCompanyDepartmentMembers(companyId, departmentId, input, options) {
        const normalizedCompanyId = requireIdentifier(companyId, "companyId");
        const payload = await this.request(`${this.companyDepartmentPath(normalizedCompanyId, departmentId)}/members`, "PUT", {
            actorUserId: requireIdentifier(input.actorUserId, "actorUserId"),
            memberUserIds: input.memberUserIds.map((userId) => requireIdentifier(userId, "memberUserIds")),
        }, options, false);
        return readCompanyTeamResponse(payload, normalizedCompanyId);
    }
    async grantCompanyDepartmentAnswerGrants(companyId, departmentId, input, options) {
        const normalizedCompanyId = requireIdentifier(companyId, "companyId");
        const payload = await this.request(`${this.companyDepartmentPath(normalizedCompanyId, departmentId)}/answer-grant`, "POST", {
            actorUserId: requireIdentifier(input.actorUserId, "actorUserId"),
            ...(input.note === undefined ? {} : { note: input.note }),
        }, options, false);
        const record = requireRecord(payload, "department answer-grant response");
        return {
            team: readCompanyTeamResponse(record, normalizedCompanyId),
            outcomes: readCompanyDepartmentGrantOutcomes(record.outcomes),
        };
    }
    async requestCompanyAnswerGrant(companyId, memberUserId, input, options) {
        const normalizedCompanyId = requireIdentifier(companyId, "companyId");
        const payload = await this.request(`${this.companyMemberPath(normalizedCompanyId, memberUserId)}/answer-grant`, "POST", {
            actorUserId: requireIdentifier(input.actorUserId, "actorUserId"),
            ...(input.note === undefined ? {} : { note: input.note }),
        }, options, false);
        return readCompanyTeamResponse(payload, normalizedCompanyId);
    }
    async decideCompanyAnswerGrant(companyId, memberUserId, input, options) {
        const normalizedCompanyId = requireIdentifier(companyId, "companyId");
        if (input.decision !== "APPROVE" && input.decision !== "DENY") {
            throw new TypeError("decision must be APPROVE or DENY");
        }
        const payload = await this.request(`${this.companyMemberPath(normalizedCompanyId, memberUserId)}/answer-grant/decision`, "POST", {
            actorUserId: requireIdentifier(input.actorUserId, "actorUserId"),
            decision: input.decision,
            ...(input.note === undefined ? {} : { note: input.note }),
        }, options, false);
        return readCompanyTeamResponse(payload, normalizedCompanyId);
    }
    async revokeCompanyAnswerGrant(companyId, memberUserId, input, options) {
        const normalizedCompanyId = requireIdentifier(companyId, "companyId");
        const payload = await this.request(`${this.companyMemberPath(normalizedCompanyId, memberUserId)}/answer-grant?actorUserId=${encodeURIComponent(requireIdentifier(input.actorUserId, "actorUserId"))}`, "DELETE", undefined, options, false);
        return readCompanyTeamResponse(payload, normalizedCompanyId);
    }
    async createCompanyMemberInvite(companyId, input, options) {
        const normalizedCompanyId = requireIdentifier(companyId, "companyId");
        const payload = await this.request(`${this.v2CompanyPath(normalizedCompanyId)}/member-invites`, "POST", {
            actorUserId: requireIdentifier(input.actorUserId, "actorUserId"),
            handle: requireIdentifier(input.handle, "handle"),
            displayName: requireIdentifier(input.displayName, "displayName"),
            role: input.role,
            ...(input.departmentIds === undefined
                ? {}
                : { departmentIds: input.departmentIds }),
            ...(input.requestAnswerGrant === undefined
                ? {}
                : { requestAnswerGrant: input.requestAnswerGrant }),
            ...(input.expiresInDays === undefined
                ? {}
                : { expiresInDays: input.expiresInDays }),
        }, options, 
        // NEVER retryable: a retry after an ambiguous failure would burn a seat
        // and mint a second code for the same human.
        false);
        return readCompanyMemberInviteResult(payload, normalizedCompanyId);
    }
    async regenerateCompanyMemberInvite(companyId, inviteId, input, options) {
        const normalizedCompanyId = requireIdentifier(companyId, "companyId");
        const payload = await this.request(`${this.companyMemberInvitePath(normalizedCompanyId, inviteId)}/regenerate`, "POST", { actorUserId: requireIdentifier(input.actorUserId, "actorUserId") }, options, false);
        return readCompanyMemberInviteResult(payload, normalizedCompanyId);
    }
    async cancelCompanyMemberInvite(companyId, inviteId, input, options) {
        const normalizedCompanyId = requireIdentifier(companyId, "companyId");
        const payload = await this.request(`${this.companyMemberInvitePath(normalizedCompanyId, inviteId)}?actorUserId=${encodeURIComponent(requireIdentifier(input.actorUserId, "actorUserId"))}`, "DELETE", undefined, options, false);
        return readCompanyTeamResponse(payload, normalizedCompanyId);
    }
    async claimCompanyMemberInvite(input, options) {
        const payload = await this.request(`${this.v2TenantPath}/member-invites/claim`, "POST", {
            userId: requireIdentifier(input.userId, "userId"),
            handle: requireIdentifier(input.handle, "handle"),
            claimCode: requireIdentifier(input.claimCode, "claimCode"),
        }, options, 
        // Single-use and attempt-capped: a retried claim burns an attempt.
        false);
        return readCompanyMemberInviteClaimResult(payload);
    }
    async listCompanyAudit(companyId, input, options) {
        const normalizedCompanyId = requireIdentifier(companyId, "companyId");
        const query = new URLSearchParams({
            actorUserId: requireIdentifier(input.actorUserId, "actorUserId"),
        });
        if (input.actingUserId !== undefined) {
            query.set("actingUserId", requireIdentifier(input.actingUserId, "actingUserId"));
        }
        if (input.action !== undefined)
            query.set("action", input.action);
        if (input.category !== undefined)
            query.set("category", input.category);
        if (input.since !== undefined)
            query.set("since", input.since);
        if (input.until !== undefined)
            query.set("until", input.until);
        if (input.cursor !== undefined)
            query.set("cursor", input.cursor);
        if (input.limit !== undefined)
            query.set("limit", String(input.limit));
        const payload = await this.request(`${this.v2CompanyPath(normalizedCompanyId)}/audit?${query.toString()}`, "GET", undefined, options, true);
        return readCompanyAuditPage(payload);
    }
    async putCompanyLinePreferences(companyId, input, options) {
        const normalizedCompanyId = requireIdentifier(companyId, "companyId");
        const payload = await this.request(`${this.v2CompanyPath(normalizedCompanyId)}/line-preferences`, "PUT", {
            actorUserId: requireIdentifier(input.actorUserId, "actorUserId"),
            muted: input.muted === true,
            disabledTypes: [...input.disabledTypes],
        }, options, false);
        return readCompanyTeamResponse(payload, normalizedCompanyId);
    }
    async partnerBrandAccess(actorUserId, options) {
        const result = await this.request(`${this.v2TenantPath}/superadmin/partner-brand-access?actorUserId=${encodeURIComponent(requireIdentifier(actorUserId, "actorUserId"))}`, "GET", undefined, options, true);
        if (!result || typeof result !== "object" || typeof result.allowed !== "boolean")
            throw new TypeError("Invalid platform access response");
        return result.allowed;
    }
    async listPartnerBrands(actorUserId, options) {
        return (0, partner_brands_1.parseMindsetPartnerBrands)(await this.request(`${this.v2TenantPath}/superadmin/partner-brands?actorUserId=${encodeURIComponent(requireIdentifier(actorUserId, "actorUserId"))}`, "GET", undefined, options, true), this.tenantId);
    }
    async updatePartnerBrand(companyId, input, options) {
        return (0, partner_brands_1.parseMindsetPartnerBrands)(await this.request(`${this.v2TenantPath}/superadmin/companies/${encodeURIComponent(requireIdentifier(companyId, "companyId"))}/partner-brand`, "PATCH", input, options, false), this.tenantId);
    }
    async listV2CompaniesForSuperadmin(actorUserId, options) {
        const payload = await this.request(`${this.v2TenantPath}/superadmin/companies?actorUserId=${encodeURIComponent(requireIdentifier(actorUserId, "actorUserId"))}`, "GET", undefined, options, true);
        return readV2CompanyList(payload, this.tenantId);
    }
    async updateV2CompanyPlan(companyId, input, options) {
        const normalizedCompanyId = requireIdentifier(companyId, "companyId");
        const payload = await this.request(`${this.v2TenantPath}/superadmin/companies/${encodeURIComponent(normalizedCompanyId)}/plan`, "PATCH", input, options, false);
        return readV2CompanyResponse(payload, this.tenantId, normalizedCompanyId);
    }
    async preflightV2CompanyCall(input, options) {
        const payload = await this.request(`${this.v2TenantPath}/company-calls/preflight`, "POST", input, options, true);
        return readV2CompanyCallPreflight(payload);
    }
    async reserveV2CompanyUsage(input, options) {
        const payload = await this.request(`${this.v2TenantPath}/company-usage/reservations`, "POST", input, options, true);
        return readV2CompanyUsageReservation(payload, this.tenantId);
    }
    async releaseV2CompanyUsage(input, options) {
        const payload = await this.request(`${this.v2TenantPath}/company-usage/reservations/release`, "POST", input, options, true);
        return readV2CompanyUsageReservation(payload, this.tenantId);
    }
    async bindV2CompanyUsageResource(input, options) {
        const payload = await this.request(`${this.v2TenantPath}/company-usage/reservations/bind`, "POST", input, options, true);
        return readV2CompanyUsageReservation(payload, this.tenantId);
    }
    async finalizeV2CompanyCallUsage(callId, input, options) {
        const payload = await this.request(`${this.v2TenantPath}/company-usage/calls/${encodeIdentifier(callId, "callId")}/finalize`, "POST", input, options, true);
        return readV2CompanyUsageReservation(payload, this.tenantId, true);
    }
    async planGroupCallInvites(conversationId, input, options) {
        const body = {
            actorUserId: requireIdentifier(input.actorUserId, "actorUserId"),
            kind: requireCallKind(input.kind),
            candidates: readGroupCallInviteCandidates(input.candidates),
            ...(input.maxInvitees === undefined
                ? {}
                : {
                    maxInvitees: boundedInteger(input.maxInvitees, "maxInvitees", 1, 16),
                }),
        };
        const payload = await this.request(`${this.conversationPath(conversationId)}/group-calls/invite-plan`, "POST", body, options, false);
        return readGroupCallInvitePlan(payload);
    }
    async createGroupCall(conversationId, input, options) {
        const normalizedConversationId = requireIdentifier(conversationId, "conversationId");
        const payload = await this.request(`${this.v2ConversationPath(normalizedConversationId)}/group-calls`, "POST", input, options, input.idempotencyKey !== undefined);
        return readV2GroupCall(payload, this.tenantId, {
            conversationId: normalizedConversationId,
        });
    }
    async listActiveGroupCalls(input, options) {
        const payload = await this.request(`${this.v2TenantPath}/group-calls?userId=${encodeIdentifier(input.userId, "userId")}`, "GET", undefined, options, true);
        if (!isRecord(payload) || !Array.isArray(payload.calls))
            throw new Error("Invalid group-call listing");
        return payload.calls.map((call) => {
            const value = readV2GroupCall({ call }, this.tenantId, {});
            if (!value.participants.some((person) => person.userId === input.userId))
                throw new Error("Group-call listing belongs to another user");
            return value;
        });
    }
    async getGroupCall(callId, input, options) {
        const normalizedCallId = requireIdentifier(callId, "callId");
        const payload = await this.request(`${this.v2GroupCallPath(normalizedCallId)}?userId=${encodeIdentifier(input.userId, "userId")}`, "GET", undefined, options, true);
        return readV2GroupCall(payload, this.tenantId, { callId: normalizedCallId });
    }
    async getCurrentCallRecording(callId, input, options) {
        const normalizedCallId = requireIdentifier(callId, "callId");
        const payload = await this.request(`${this.v2GroupCallPath(normalizedCallId)}/recording-requests/current?userId=${encodeIdentifier(input.userId, "userId")}`, "GET", undefined, options, true);
        return readCurrentV2RecordingRequest(payload, this.tenantId, normalizedCallId);
    }
    async respondToGroupCall(callId, input, options) {
        return this.mutateV2GroupCall(callId, "respond", input, options);
    }
    async joinGroupCall(callId, input, options) {
        const normalizedCallId = requireIdentifier(callId, "callId");
        const payload = await this.request(`${this.v2GroupCallPath(normalizedCallId)}/join`, "POST", input, options, true);
        return readV2GroupCallJoinResult(payload, this.tenantId, normalizedCallId, input.userId);
    }
    async leaveGroupCall(callId, input, options) {
        return this.mutateV2GroupCall(callId, "leave", input, options);
    }
    async endGroupCall(callId, input, options) {
        return this.mutateV2GroupCall(callId, "end", input, options);
    }
    async sendCallReaction(callId, input, options) {
        const normalizedCallId = requireIdentifier(callId, "callId");
        const payload = await this.request(`${this.v2GroupCallPath(normalizedCallId)}/reactions`, "POST", input, options, true);
        return readV2CallReaction(payload, this.tenantId, normalizedCallId);
    }
    async updateCallReactionPolicy(callId, input, options) {
        const normalizedCallId = requireIdentifier(callId, "callId");
        const payload = await this.request(`${this.v2GroupCallPath(normalizedCallId)}/reaction-policy`, "POST", input, options, true);
        return readV2CallReactionPolicy(payload, this.tenantId, normalizedCallId);
    }
    async getCurrentCallReactionEnableRequest(callId, input, options) {
        const normalizedCallId = requireIdentifier(callId, "callId");
        const payload = await this.request(`${this.v2GroupCallPath(normalizedCallId)}/reaction-enable-requests/current?userId=${encodeIdentifier(input.userId, "userId")}`, "GET", undefined, options, true);
        const record = requireRecord(payload, "current call reaction enable request");
        const count = record.pendingRequestCount;
        if (!hasExactKeys(record, ["request", "pendingRequestCount"]) ||
            typeof count !== "number" || !Number.isSafeInteger(count) || count < 0 ||
            (record.request === null) !== (count === 0)) {
            throw invalidResponse("Invalid current call reaction enable request");
        }
        const request = record.request === null ? null : readV2CallReactionEnableRequest({ request: record.request }, this.tenantId, normalizedCallId);
        if (request && request.status !== "PENDING") {
            throw invalidResponse("Current call reaction enable request is not pending");
        }
        return { request, pendingRequestCount: count };
    }
    async requestCallReactionsEnabled(callId, input, options) {
        const normalizedCallId = requireIdentifier(callId, "callId");
        const payload = await this.request(`${this.v2GroupCallPath(normalizedCallId)}/reaction-enable-requests`, "POST", input, options, input.idempotencyKey !== undefined);
        return readV2CallReactionEnableRequest(payload, this.tenantId, normalizedCallId);
    }
    async respondToCallReactionEnableRequest(callId, requestId, input, options) {
        const normalizedCallId = requireIdentifier(callId, "callId");
        const payload = await this.request(`${this.v2GroupCallPath(normalizedCallId)}/reaction-enable-requests/${encodeIdentifier(requestId, "requestId")}/respond`, "POST", input, options, true);
        return readV2CallReactionEnableRequest(payload, this.tenantId, normalizedCallId, requireIdentifier(requestId, "requestId"));
    }
    async requestCallRecording(callId, input, options) {
        const normalizedCallId = requireIdentifier(callId, "callId");
        const payload = await this.request(`${this.v2GroupCallPath(normalizedCallId)}/recording-requests`, "POST", input, options, input.idempotencyKey !== undefined);
        return readV2RecordingRequest(payload, this.tenantId, normalizedCallId);
    }
    async respondToCallRecording(callId, recordingRequestId, input, options) {
        return this.mutateV2RecordingRequest(callId, recordingRequestId, "respond", input, options);
    }
    async resolveCallRecording(callId, recordingRequestId, input, options) {
        return this.mutateV2RecordingRequest(callId, recordingRequestId, "resolve", input, options);
    }
    async stopCallRecording(callId, recordingRequestId, input, options) {
        return this.mutateV2RecordingRequest(callId, recordingRequestId, "stop", input, options);
    }
    async requestDirectCallRecording(callId, input, options) {
        const id = requireBoundedRecordingIdentifier(callId, "callId");
        assertDirectRecordingInput("create", input);
        const payload = await this.request(`${this.callPath(id)}/recording-requests`, "POST", input, options, input.idempotencyKey !== undefined);
        return readDirectRecordingRequest(payload, this.tenantId, id, "recording");
    }
    async getCurrentDirectCallRecording(callId, input, options) {
        const id = requireBoundedRecordingIdentifier(callId, "callId");
        assertDirectRecordingInput("current", input);
        const payload = await this.request(`${this.callPath(id)}/recording-requests/current?userId=${encodeIdentifier(input.userId, "userId")}`, "GET", undefined, options, true);
        return readDirectRecordingRequest(payload, this.tenantId, id, "recordingRequest");
    }
    async respondToDirectCallRecording(callId, recordingRequestId, input, options) {
        return this.mutateDirectRecordingRequest(callId, recordingRequestId, "respond", input, options);
    }
    async resolveDirectCallRecording(callId, recordingRequestId, input, options) {
        return this.mutateDirectRecordingRequest(callId, recordingRequestId, "resolve", input, options);
    }
    async stopDirectCallRecording(callId, recordingRequestId, input, options) {
        return this.mutateDirectRecordingRequest(callId, recordingRequestId, "stop", input, options);
    }
    async getDirectRecordingCaptureStatus(callId, recordingRequestId, input, options) {
        const id = requireBoundedRecordingIdentifier(callId, "callId");
        const requestId = requireBoundedRecordingIdentifier(recordingRequestId, "recordingRequestId");
        if (!isRecord(input) || !hasExactKeys(input, ["grant"]) ||
            typeof input.grant !== "string" || !/^[A-Za-z0-9_-]{43}$/.test(input.grant)) {
            throw new TypeError("Invalid recording capture capability");
        }
        const payload = await this.request(`${this.callPath(id)}/recording-captures/${encodeURIComponent(requestId)}/status`, "POST", { grant: input.grant }, { ...options, retry: false,
            timeoutMs: Math.min(options?.timeoutMs ?? this.timeoutMs, 2000) });
        return parseMindsetRecordingCaptureStatus(payload);
    }
    async listCallRecordings(userId, input = {}, options) {
        const limit = boundedInteger(input.limit ?? 50, "limit", 1, 100);
        const payload = await this.request(`${this.v2TenantPath}/users/${encodeIdentifier(userId, "userId")}/recordings?limit=${limit}`, "GET", undefined, options, true);
        return readV2RecordingAssetList(payload, this.tenantId, userId);
    }
    async createCallRecordingDownloadGrant(recordingAssetId, input, options) {
        const normalizedAssetId = requireIdentifier(recordingAssetId, "recordingAssetId");
        const payload = await this.request(`${this.v2TenantPath}/recordings/${encodeURIComponent(normalizedAssetId)}/download`, "POST", input, options, false);
        return readV2RecordingAssetDownloadGrant(payload, normalizedAssetId);
    }
    async createScheduledCall(conversationId, input, options) {
        const normalizedConversationId = requireIdentifier(conversationId, "conversationId");
        const payload = await this.request(`${this.v2ConversationPath(normalizedConversationId)}/scheduled-calls`, "POST", input, options, input.idempotencyKey !== undefined);
        return readV2ScheduledCall(payload, this.tenantId, {
            conversationId: normalizedConversationId,
        });
    }
    async listScheduledCalls(participantUserId, input = {}, options) {
        const query = v2ScheduledCallListQuery(input).toString();
        const payload = await this.request(`${this.v2TenantPath}/users/${encodeIdentifier(participantUserId, "participantUserId")}/scheduled-calls${query ? `?${query}` : ""}`, "GET", undefined, options, true);
        return readV2ScheduledCallList(payload, this.tenantId, participantUserId);
    }
    async updateScheduledCall(scheduledCallId, input, options) {
        return this.mutateV2ScheduledCall(scheduledCallId, "update", input, options);
    }
    async respondToScheduledCall(scheduledCallId, input, options) {
        return this.mutateV2ScheduledCall(scheduledCallId, "respond", input, options);
    }
    async startScheduledCall(scheduledCallId, input, options) {
        const normalizedScheduledCallId = requireIdentifier(scheduledCallId, "scheduledCallId");
        const payload = await this.request(`${this.v2ScheduledCallPath(normalizedScheduledCallId)}/start`, "POST", input, options, input.idempotencyKey !== undefined);
        return readV2GroupCall(payload, this.tenantId, {
            scheduledCallId: normalizedScheduledCallId,
        });
    }
    async getDisappearingMessagePolicy(conversationId, input, options) {
        const normalizedConversationId = requireIdentifier(conversationId, "conversationId");
        const payload = await this.request(`${this.v2ConversationPath(normalizedConversationId)}/disappearing-messages?userId=${encodeIdentifier(input.userId, "userId")}`, "GET", undefined, options, true);
        return readV2DisappearingMessagePolicy(payload, this.tenantId, normalizedConversationId);
    }
    async updateDisappearingMessagePolicy(conversationId, input, options) {
        const normalizedConversationId = requireIdentifier(conversationId, "conversationId");
        const payload = await this.request(`${this.v2ConversationPath(normalizedConversationId)}/disappearing-messages`, "POST", input, options, true);
        return readV2DisappearingMessagePolicy(payload, this.tenantId, normalizedConversationId);
    }
    async createAttachmentUploadIntent(conversationId, input, options) {
        const normalizedConversationId = requireIdentifier(conversationId, "conversationId");
        const payload = await this.request(`${this.v2ConversationPath(normalizedConversationId)}/attachments/upload-intents`, "POST", input, options, true);
        return readV2AttachmentUploadIntent(payload, this.tenantId, normalizedConversationId);
    }
    async finalizeAttachmentUpload(mediaId, input, options) {
        return this.mutateV2Attachment(mediaId, "finalize", input, options);
    }
    async requestAttachmentRecipientConsent(mediaId, input, options) {
        return this.mutateV2Attachment(mediaId, "consent-requests", input, options, input.idempotencyKey !== undefined);
    }
    async respondToAttachmentRecipientConsent(mediaId, input, options) {
        return this.mutateV2Attachment(mediaId, "consent/respond", input, options);
    }
    async commitAttachments(conversationId, input, options) {
        const normalizedConversationId = requireIdentifier(conversationId, "conversationId");
        const payload = await this.request(`${this.v2ConversationPath(normalizedConversationId)}/attachments/commit`, "POST", input, options, true);
        return readV2AttachmentCommit(payload, this.tenantId, normalizedConversationId);
    }
    async listConversationMedia(conversationId, input, options) {
        const normalizedConversationId = requireIdentifier(conversationId, "conversationId");
        const query = v2AttachmentMediaListQuery(input).toString();
        const payload = await this.request(`${this.v2ConversationPath(normalizedConversationId)}/media?${query}`, "GET", undefined, options, true);
        return readV2AttachmentMediaList(payload, this.tenantId, normalizedConversationId);
    }
    async getAttachmentDownloadGrant(mediaId, input, options) {
        const normalizedMediaId = requireIdentifier(mediaId, "mediaId");
        const query = v2AttachmentDownloadQuery(input).toString();
        const payload = await this.request(`${this.v2AttachmentPath(normalizedMediaId)}/download?${query}`, "GET", undefined, options, true);
        return readV2AttachmentDownloadGrant(payload, normalizedMediaId);
    }
    async respondToCall(input, options) {
        const { callId, ...body } = input;
        const payload = await this.request(`${this.callPath(callId)}/respond`, "POST", body, options, true);
        return readCall(payload);
    }
    async requestCallEscalation(input, options) {
        const { callId, ...body } = input;
        const payload = await this.request(`${this.callPath(callId)}/escalate`, "POST", body, options, true);
        return readCall(payload);
    }
    async respondToCallEscalation(input, options) {
        const { callId, ...body } = input;
        const payload = await this.request(`${this.callPath(callId)}/escalation/respond`, "POST", body, options, true);
        return readCall(payload);
    }
    async cancelCallEscalation(input, options) {
        const { callId, ...body } = input;
        const payload = await this.request(`${this.callPath(callId)}/escalation/cancel`, "POST", body, options, true);
        return readCall(payload);
    }
    async endCall(input, options) {
        const { callId, ...body } = input;
        const payload = await this.request(`${this.callPath(callId)}/end`, "POST", body, options, true);
        return readCall(payload);
    }
    async getCallJoinToken(input, options) {
        const { callId, ...body } = input;
        const payload = await this.request(`${this.callPath(callId)}/join`, "POST", body, options, false);
        return readJoinToken(payload);
    }
    async createRealtimeTicket(userId, options) {
        const payload = await this.request(`/mindset/v1/tenants/${this.encodedTenantId}/realtime/tickets`, "POST", { userId: requireIdentifier(userId, "userId") }, options, false);
        const ticket = requireRecord(payload, "realtime ticket response");
        if (!isNonEmptyString(ticket.ticket) ||
            !isNonEmptyString(ticket.expiresAt) ||
            !Number.isFinite(Date.parse(ticket.expiresAt))) {
            throw invalidResponse("Mindset returned an invalid realtime ticket response");
        }
        return ticket;
    }
    async mintRealtimeTicket(input, options) {
        const accountAuth = input.accountAuth;
        if (accountAuth !== undefined && (!isRecord(accountAuth) ||
            Object.keys(accountAuth).some(key => !["loginUserId", "authenticationSessionId", "securityVersion"].includes(key)) ||
            ![accountAuth.loginUserId, ...(accountAuth.authenticationSessionId === undefined ? [] : [accountAuth.authenticationSessionId])].every(id => typeof id === "string" && id.length > 0 && id.length <= 255 && id.trim() === id && !/[\u0000-\u001f\u007f]/.test(id)) ||
            (accountAuth.authenticationSessionId === undefined) !== (accountAuth.securityVersion === undefined) ||
            (accountAuth.securityVersion !== undefined && (!Number.isSafeInteger(accountAuth.securityVersion) || accountAuth.securityVersion < 0)))) {
            throw new TypeError("Invalid realtime account authentication");
        }
        const userId = requireIdentifier(input.userId, "userId");
        const userIds = input.userIds?.map((value, index) => requireIdentifier(value, `userIds[${index}]`));
        const payload = await this.request(`/mindset/v1/tenants/${this.encodedTenantId}/realtime/tickets`, "POST", { userId, ...(userIds ? { userIds } : {}), ...(accountAuth ? { accountAuth: { ...accountAuth } } : {}) }, options, false);
        const ticket = requireRecord(payload, "realtime ticket response");
        if (!isNonEmptyString(ticket.ticket) ||
            !isNonEmptyString(ticket.expiresAt) ||
            !Number.isFinite(Date.parse(ticket.expiresAt))) {
            throw invalidResponse("Mindset returned an invalid realtime ticket response");
        }
        return ticket;
    }
    async listLoginProfiles(userId, options) {
        const normalizedUserId = requireIdentifier(userId, "userId");
        const payload = await this.request(`${this.v2AccountPath(normalizedUserId)}/login-profiles`, "GET", undefined, options, true);
        const record = requireRecord(payload, "login profiles response");
        if (!Array.isArray(record.profiles)) {
            throw invalidResponse("Mindset returned an invalid login profiles response");
        }
        return record.profiles.map((entry) => readLoginProfile(entry));
    }
    async createCompanyPersona(companyId, input, options) {
        const normalizedCompanyId = requireIdentifier(companyId, "companyId");
        const body = {
            requestedByUserId: requireIdentifier(input.actorUserId, "actorUserId"),
            ...(input.handle === undefined ? {} : { handle: input.handle }),
        };
        const payload = await this.request(`${this.v2CompanyPath(normalizedCompanyId)}/persona`, "POST", body, options, false);
        const record = requireRecord(payload, "company persona response");
        if (isRecord(record.profile)) {
            return readLoginProfile(record.profile);
        }
        if (isRecord(record.persona)) {
            const persona = record.persona;
            if (!isNonEmptyString(persona.personaUserId) ||
                typeof persona.displayName !== "string") {
                throw invalidResponse("Mindset returned an invalid company persona response");
            }
            return {
                profileUserId: persona.personaUserId,
                kind: "COMPANY",
                displayName: persona.displayName,
                handle: isNonEmptyString(persona.handle) ? persona.handle : null,
                avatarUrl: isNonEmptyString(persona.avatarUrl)
                    ? persona.avatarUrl
                    : null,
                companyId: isNonEmptyString(persona.companyId)
                    ? persona.companyId
                    : normalizedCompanyId,
                companyName: persona.displayName,
                isActive: false,
                position: 0,
                notificationSettings: {
                    ringerEnabled: true,
                    notificationOnly: false,
                    disabledTypes: [],
                },
            };
        }
        return readLoginProfile(record);
    }
    async getNotificationSettings(profileUserId, options) {
        const normalizedUserId = requireIdentifier(profileUserId, "profileUserId");
        const payload = await this.request(`${this.v2AccountPath(normalizedUserId)}/notification-settings`, "GET", undefined, options, true);
        const record = requireRecord(payload, "notification settings response");
        return readProfileNotificationSettings(isRecord(record.notificationSettings) ? record.notificationSettings : record);
    }
    async putNotificationSettings(profileUserId, input, options) {
        const normalizedUserId = requireIdentifier(profileUserId, "profileUserId");
        const payload = await this.request(`${this.v2AccountPath(normalizedUserId)}/notification-settings`, "PUT", input, options, false);
        const record = requireRecord(payload, "notification settings response");
        return readProfileNotificationSettings(isRecord(record.notificationSettings) ? record.notificationSettings : record);
    }
    async registerDevice(input, options) {
        const payload = await this.request(`/mindset/v1/tenants/${this.encodedTenantId}/devices`, "POST", input, options, true);
        return readDeviceRegistration(payload);
    }
    async removeDevice(deviceId, options) {
        await this.request(`/mindset/v1/tenants/${this.encodedTenantId}/devices/${encodeIdentifier(deviceId, "deviceId")}`, "DELETE", undefined, options, true);
    }
    async removeUserDevice(userId, deviceId, options) {
        await this.request(`/mindset/v1/tenants/${this.encodedTenantId}/devices/${encodeIdentifier(deviceId, "deviceId")}?userId=${encodeIdentifier(userId, "userId")}`, "DELETE", undefined, options, true);
    }
    async deleteUserAccount(userId, options) {
        await this.request(`/mindset/v1/tenants/${this.encodedTenantId}/users/${encodeIdentifier(userId, "userId")}`, "DELETE", undefined, options, false);
    }
    async getUserProfile(userId, options) {
        const payload = await this.request(this.userProfilePath(userId), "GET", undefined, options, true);
        return readUserProfile(payload);
    }
    async updateUserProfile(userId, input, options) {
        const payload = await this.request(this.userProfilePath(userId), "POST", input, options, false);
        return readUserProfile(payload);
    }
    async getAccountSettings(userId, options) {
        const payload = await this.request(this.accountSettingsPath(userId), "GET", undefined, options, true);
        return readAccountSettings(payload);
    }
    async updateAccountSettings(userId, input, options) {
        const payload = await this.request(this.accountSettingsPath(userId), "POST", input, options, false);
        return readAccountSettings(payload);
    }
    async getContactDiscoverySettings(userId, options) {
        const payload = await this.request(this.contactDiscoveryPath(userId), "GET", undefined, options, true);
        return readContactDiscoverySettings(payload);
    }
    async updateContactDiscoverySettings(userId, input, options) {
        const payload = await this.request(this.contactDiscoveryPath(userId), "POST", input, options, false);
        return readContactDiscoverySettings(payload);
    }
    async resolveContacts(userId, input, options) {
        const payload = await this.request(`${this.contactDiscoveryPath(userId)}/resolve`, "POST", input, options, true);
        return readContactMatches(payload);
    }
    async resolveAddressBookContacts(userId, input, options) {
        const handles = uniqueContactDiscoveryHandles(input.handles);
        if (handles.length === 0)
            return [];
        const batchSize = readContactDiscoveryBatchSize(input.batchSize);
        const matchesByUserId = new Map();
        for (let index = 0; index < handles.length; index += batchSize) {
            const matches = await this.resolveContacts(userId, { handles: handles.slice(index, index + batchSize) }, options);
            for (const match of matches) {
                if (!matchesByUserId.has(match.userId)) {
                    matchesByUserId.set(match.userId, match);
                }
            }
        }
        return [...matchesByUserId.values()];
    }
    async createConversation(input, options) {
        const payload = await this.request(`/mindset/v1/tenants/${this.encodedTenantId}/conversations`, "POST", input, options, true);
        return readConversation(payload);
    }
    async getConversation(input, options) {
        const payload = await this.request(this.conversationPath(input.conversationId), "GET", undefined, options, true);
        return readConversation(payload);
    }
    async listUserConversations(userId, input = {}, options) {
        const query = this.listQuery(input).toString();
        const payload = await this.request(`/mindset/v1/tenants/${this.encodedTenantId}/users/${encodeIdentifier(userId, "userId")}/conversations${query ? `?${query}` : ""}`, "GET", undefined, options, true);
        return readConversations(payload);
    }
    async updateConversationOrganization(conversationId, input, options) {
        const payload = await this.request(`${this.conversationPath(conversationId)}/organization`, "POST", input, options, true);
        return readConversation(payload);
    }
    async listMessageFolders(userId, options) {
        const payload = await this.request(`/mindset/v1/tenants/${this.encodedTenantId}/users/${encodeIdentifier(userId, "userId")}/message-folders`, "GET", undefined, options, true);
        return readMessageFolders(payload);
    }
    async createMessageFolder(userId, input, options) {
        const payload = await this.request(`/mindset/v1/tenants/${this.encodedTenantId}/users/${encodeIdentifier(userId, "userId")}/message-folders`, "POST", input, options, true);
        return readMessageFolder(payload);
    }
    async updateMessageFolder(userId, folderId, input, options) {
        const payload = await this.request(`/mindset/v1/tenants/${this.encodedTenantId}/users/${encodeIdentifier(userId, "userId")}/message-folders/${encodeIdentifier(folderId, "folderId")}`, "PATCH", input, options, true);
        return readMessageFolder(payload);
    }
    async deleteMessageFolder(userId, folderId, options) {
        await this.request(`/mindset/v1/tenants/${this.encodedTenantId}/users/${encodeIdentifier(userId, "userId")}/message-folders/${encodeIdentifier(folderId, "folderId")}`, "DELETE", undefined, options, true);
    }
    async getConversationNotificationSettings(conversationId, input, options) {
        const query = new URLSearchParams({ userId: input.userId }).toString();
        const payload = await this.request(`${this.conversationPath(conversationId)}/notification-settings?${query}`, "GET", undefined, options, true);
        return readConversationNotificationSettings(payload);
    }
    async updateConversationNotificationSettings(conversationId, input, options) {
        const payload = await this.request(`${this.conversationPath(conversationId)}/notification-settings`, "POST", input, options, true);
        return readConversationNotificationSettings(payload);
    }
    async addConversationParticipants(conversationId, input, options) {
        const payload = await this.request(`${this.conversationPath(conversationId)}/participants`, "POST", input, options, true);
        return readConversation(payload);
    }
    async removeConversationParticipants(conversationId, input, options) {
        const payload = await this.request(`${this.conversationPath(conversationId)}/participants/remove`, "POST", input, options, true);
        return readConversation(payload);
    }
    async updateConversationParticipantRole(conversationId, input, options) {
        const payload = await this.request(`${this.conversationPath(conversationId)}/participants/role`, "POST", input, options, true);
        return readConversation(payload);
    }
    async leaveConversation(conversationId, input, options) {
        const payload = await this.request(`${this.conversationPath(conversationId)}/leave`, "POST", input, options, true);
        return readConversation(payload);
    }
    async updateConversationTitle(conversationId, input, options) {
        const payload = await this.request(`${this.conversationPath(conversationId)}/title`, "POST", input, options, true);
        return readConversation(payload);
    }
    async publishConversationTyping(conversationId, input, options) {
        const path = `${this.conversationPath(conversationId)}/typing`;
        let payload;
        try {
            payload = await this.request(path, "POST", input, options, false);
        }
        catch (error) {
            if (input.leaseId === undefined ||
                !isMindsetApiError(error) ||
                error.status !== 400) {
                throw error;
            }
            const { leaseId: _leaseId, ...legacyInput } = input;
            payload = await this.request(path, "POST", legacyInput, options, false);
        }
        const event = readConversationPresenceEvent(payload);
        const effectiveLeaseId = event.leaseId?.trim();
        return effectiveLeaseId
            ? event
            : {
                ...event,
                leaseId: legacyConversationTypingLeaseId(event.conversationId, event.actorUserId),
            };
    }
    async sendMessage(input, options) {
        const { conversationId, ...body } = input;
        const payload = await this.request(this.messagesPath(conversationId), "POST", body, options, true);
        return readMessage(payload);
    }
    async listMessages(conversationId, input = {}, options) {
        const params = this.listQuery(input);
        if (input.beforeId !== undefined) {
            if (!input.before)
                throw new TypeError("beforeId requires before");
            encodeIdentifier(input.beforeId, "beforeId");
            params.set("beforeId", input.beforeId);
        }
        if (input.query !== undefined)
            params.set("query", input.query);
        const query = params.toString();
        const payload = await this.request(`${this.messagesPath(conversationId)}${query ? `?${query}` : ""}`, "GET", undefined, options, true);
        return readMessages(payload);
    }
    async listMessageAttachments(conversationId, messageId, input = {}, options) {
        void input;
        const payload = await this.request(`${this.messagesPath(conversationId)}/${encodeIdentifier(messageId, "messageId")}/attachments`, "GET", undefined, options, true);
        return readMessageAttachments(payload);
    }
    async getMessageAttachmentUploadReadiness(conversationId, options) {
        const payload = await this.request(`${this.conversationPath(conversationId)}/attachments/uploads/readiness`, "GET", undefined, options, true);
        return readMessageAttachmentUploadReadiness(payload);
    }
    async requestMessageAttachmentUploadIntent(conversationId, input, options) {
        await this.request(`${this.conversationPath(conversationId)}/attachments/uploads`, "POST", input, options, false);
    }
    async markMessageReceipt(conversationId, messageId, input, options) {
        const payload = await this.request(`${this.messagesPath(conversationId)}/${encodeIdentifier(messageId, "messageId")}/receipts`, "POST", input, options, true);
        return readMessageReceipt(payload);
    }
    async listMessageReceipts(conversationId, messageId, input = {}, options) {
        void input;
        const payload = await this.request(`${this.messagesPath(conversationId)}/${encodeIdentifier(messageId, "messageId")}/receipts`, "GET", undefined, options, true);
        return readMessageReceipts(payload);
    }
    async deleteMessage(conversationId, messageId, input, options) {
        const payload = await this.request(`${this.messagesPath(conversationId)}/${encodeIdentifier(messageId, "messageId")}`, "DELETE", input, options, true);
        return readMessage(payload);
    }
    async editMessage(conversationId, messageId, input, options) {
        const payload = await this.request(`${this.messagesPath(conversationId)}/${encodeIdentifier(messageId, "messageId")}/edit`, "POST", input, options, true);
        return readMessage(payload);
    }
    async setMessageReaction(conversationId, messageId, input, options) {
        const payload = await this.request(`${this.messagesPath(conversationId)}/${encodeIdentifier(messageId, "messageId")}/reactions`, "POST", input, options, true);
        return readMessageReactionSnapshot(payload);
    }
    async removeMessageReaction(conversationId, messageId, input, options) {
        const payload = await this.request(`${this.messagesPath(conversationId)}/${encodeIdentifier(messageId, "messageId")}/reactions`, "DELETE", input, options, true);
        return readMessageReactionSnapshot(payload);
    }
    async listMessageReactions(conversationId, messageId, options) {
        const payload = await this.request(`${this.messagesPath(conversationId)}/${encodeIdentifier(messageId, "messageId")}/reactions`, "GET", undefined, options, true);
        return readMessageReactionSnapshot(payload);
    }
    async publishLiveReaction(conversationId, input, options) {
        const payload = await this.request(`${this.conversationPath(conversationId)}/live-reactions`, "POST", input, options, false);
        return readLiveReactionEvent(payload);
    }
    async getConsentSettings(userId, options) {
        const payload = await this.request(this.consentSettingsPath(userId), "GET", undefined, options, true);
        return readConsentSettingsResult(payload);
    }
    async updateConsentSettings(userId, input, options) {
        const payload = await this.request(this.consentSettingsPath(userId), "POST", input, options, false);
        return readConsentSetting(payload);
    }
    async getConsentContactSetting(userId, contactUserId, options) {
        const payload = await this.request(`${this.consentSettingsPath(userId)}/contacts/${encodeIdentifier(contactUserId, "contactUserId")}`, "GET", undefined, options, true);
        return readNullableConsentSetting(payload);
    }
    async updateConsentContactSetting(userId, contactUserId, input, options) {
        const payload = await this.request(`${this.consentSettingsPath(userId)}/contacts/${encodeIdentifier(contactUserId, "contactUserId")}`, "POST", input, options, false);
        return readConsentSetting(payload);
    }
    async listConsentRequests(userId, input = {}, options) {
        const params = new URLSearchParams();
        if (input.status !== undefined) {
            if (!CONSENT_REQUEST_STATUSES.has(input.status)) {
                throw new TypeError("status must be a valid consent request status");
            }
            params.set("status", input.status);
        }
        if (input.limit !== undefined) {
            if (!Number.isInteger(input.limit) ||
                input.limit < 1 ||
                input.limit > 200) {
                throw new TypeError("limit must be an integer from 1 to 200");
            }
            params.set("limit", String(input.limit));
        }
        const query = params.toString();
        const payload = await this.request(`/mindset/v1/tenants/${this.encodedTenantId}/users/${encodeIdentifier(userId, "userId")}/consent-requests${query ? `?${query}` : ""}`, "GET", undefined, options, true);
        return readConsentRequests(payload);
    }
    async getCurrentConsentRequest(conversationId, input, options) {
        const params = new URLSearchParams();
        params.set("requesterUserId", requireIdentifier(input.requesterUserId, "requesterUserId"));
        if (input.ownerUserId !== undefined) {
            params.set("ownerUserId", requireIdentifier(input.ownerUserId, "ownerUserId"));
        }
        if (input.kind !== undefined) {
            if (!CONSENT_REQUEST_KINDS.has(input.kind)) {
                throw new TypeError("kind must be a valid consent kind");
            }
            params.set("kind", input.kind);
        }
        const payload = await this.request(`${this.conversationPath(conversationId)}/consent-requests/current?${params.toString()}`, "GET", undefined, options, true);
        return readNullableConsentRequest(payload);
    }
    async respondToConsentRequest(requestId, input, options) {
        const payload = await this.request(`${this.consentRequestPath(requestId)}/respond`, "POST", input, options, false);
        return readConsentRequest(payload);
    }
    async revokeConsentRequest(requestId, input, options) {
        const payload = await this.request(`${this.consentRequestPath(requestId)}/revoke`, "POST", input, options, false);
        return readConsentRequest(payload);
    }
    async createVoicemailOffer(callId, input, options) {
        const payload = await this.request(`${this.callPath(callId)}/voicemail`, "POST", input, options, false);
        return readVoicemailOffer(payload);
    }
    async commitVoicemail(voicemailId, input, options) {
        const payload = await this.request(`${this.voicemailPath(voicemailId)}/commit`, "POST", input, options, false);
        return readVoicemail(payload);
    }
    async cancelVoicemail(voicemailId, input, options) {
        const payload = await this.request(`${this.voicemailPath(voicemailId)}/cancel`, "POST", input, options, false);
        return readVoicemail(payload);
    }
    async listVoicemails(userId, input = {}, options) {
        const params = this.listQuery(input);
        if (input.beforeId !== undefined) {
            if (!input.before)
                throw new TypeError("beforeId requires before");
            encodeIdentifier(input.beforeId, "beforeId");
            params.set("beforeId", input.beforeId);
        }
        const query = params.toString();
        const payload = await this.request(`/mindset/v1/tenants/${this.encodedTenantId}/users/${encodeIdentifier(userId, "userId")}/voicemails${query ? `?${query}` : ""}`, "GET", undefined, options, true);
        return readVoicemailList(payload);
    }
    async markVoicemailListened(voicemailId, input, options) {
        const payload = await this.request(`${this.voicemailPath(voicemailId)}/listened`, "POST", input, options, true);
        return readVoicemail(payload);
    }
    async deleteVoicemail(voicemailId, input, options) {
        const payload = await this.request(this.voicemailPath(voicemailId), "DELETE", input, options, true);
        return readVoicemail(payload);
    }
    async listVoicemailGreetings(userId, options) {
        const payload = await this.request(this.voicemailGreetingsPath(userId), "GET", undefined, options, true);
        return readVoicemailGreetings(payload);
    }
    async createVoicemailGreeting(userId, input, options) {
        const payload = await this.request(this.voicemailGreetingsPath(userId), "POST", input, options, false);
        return readVoicemailGreeting(payload);
    }
    async activateVoicemailGreeting(greetingId, input, options) {
        const payload = await this.request(`${this.voicemailGreetingPath(greetingId)}/activate`, "POST", input, options, false);
        return readVoicemailGreeting(payload);
    }
    async deleteVoicemailGreeting(greetingId, input, options) {
        const payload = await this.request(this.voicemailGreetingPath(greetingId), "DELETE", input, options, false);
        return readVoicemailGreeting(payload);
    }
    async reportMessage(conversationId, messageId, input, options) {
        const payload = await this.request(`${this.messagesPath(conversationId)}/${encodeIdentifier(messageId, "messageId")}/reports`, "POST", input, options, true);
        return readMessageReport(payload);
    }
    async listMessageReports(input = {}, options) {
        const params = this.messageReportListQuery(input);
        const query = params.toString();
        const payload = await this.request(`/mindset/v1/tenants/${this.encodedTenantId}/message-reports${query ? `?${query}` : ""}`, "GET", undefined, options, true);
        return readMessageReports(payload);
    }
    async reviewMessageReport(reportId, input, options) {
        const payload = await this.request(`/mindset/v1/tenants/${this.encodedTenantId}/message-reports/${encodeIdentifier(reportId, "reportId")}/review`, "POST", input, options, true);
        return readMessageReport(payload);
    }
    async reportContactDiscovery(reporterUserId, input, options) {
        const payload = await this.request(`${this.contactDiscoveryPath(reporterUserId)}/reports`, "POST", input, options, true);
        return readContactDiscoveryReport(payload);
    }
    async listContactDiscoveryReports(input = {}, options) {
        const params = this.messageReportListQuery(input);
        const query = params.toString();
        const payload = await this.request(`/mindset/v1/tenants/${this.encodedTenantId}/contact-discovery-reports${query ? `?${query}` : ""}`, "GET", undefined, options, true);
        return readContactDiscoveryReports(payload);
    }
    async reviewContactDiscoveryReport(reportId, input, options) {
        const payload = await this.request(`/mindset/v1/tenants/${this.encodedTenantId}/contact-discovery-reports/${encodeIdentifier(reportId, "reportId")}/review`, "POST", input, options, true);
        return readContactDiscoveryReport(payload);
    }
    async listSafetyReports(input = {}, options) {
        const request = safetyReportListRequest(input);
        const [messageReports, contactDiscoveryReports] = await Promise.all([
            this.listMessageReports(request, options),
            this.listContactDiscoveryReports(request, options),
        ]);
        const reports = createSafetyReportQueue(messageReports, contactDiscoveryReports);
        return {
            messageReports,
            contactDiscoveryReports,
            reports,
            total: reports.length,
        };
    }
    async reviewSafetyReport(kind, reportId, input, options) {
        if (kind === "message") {
            return {
                kind,
                report: await this.reviewMessageReport(reportId, input, options),
            };
        }
        if (kind === "contactDiscovery") {
            return {
                kind,
                report: await this.reviewContactDiscoveryReport(reportId, input, options),
            };
        }
        throw new TypeError("kind must be message or contactDiscovery");
    }
    async mutateV2GroupCall(callId, action, input, options) {
        const normalizedCallId = requireIdentifier(callId, "callId");
        const payload = await this.request(`${this.v2GroupCallPath(normalizedCallId)}/${action}`, "POST", input, options, true);
        return readV2GroupCall(payload, this.tenantId, { callId: normalizedCallId });
    }
    async mutateDirectRecordingRequest(callId, recordingRequestId, action, input, options) {
        const id = requireBoundedRecordingIdentifier(callId, "callId");
        const requestId = requireBoundedRecordingIdentifier(recordingRequestId, "recordingRequestId");
        assertDirectRecordingInput(action, input);
        const payload = await this.request(`${this.callPath(id)}/recording-requests/${encodeURIComponent(requestId)}/${action}`, "POST", input, options, true);
        return readDirectRecordingRequest(payload, this.tenantId, id, "recording", requestId);
    }
    async mutateV2RecordingRequest(callId, recordingRequestId, action, input, options) {
        const normalizedCallId = requireIdentifier(callId, "callId");
        const normalizedRequestId = requireIdentifier(recordingRequestId, "recordingRequestId");
        const payload = await this.request(`${this.v2GroupCallPath(normalizedCallId)}/recording-requests/${encodeURIComponent(normalizedRequestId)}/${action}`, "POST", input, options, true);
        return readV2RecordingRequest(payload, this.tenantId, normalizedCallId, normalizedRequestId);
    }
    async mutateV2ScheduledCall(scheduledCallId, action, input, options) {
        const normalizedScheduledCallId = requireIdentifier(scheduledCallId, "scheduledCallId");
        const payload = await this.request(`${this.v2ScheduledCallPath(normalizedScheduledCallId)}/${action}`, "POST", input, options, true);
        return readV2ScheduledCall(payload, this.tenantId, {
            scheduledCallId: normalizedScheduledCallId,
        });
    }
    async mutateV2Attachment(mediaId, action, input, options, retryableOperation = true) {
        const normalizedMediaId = requireIdentifier(mediaId, "mediaId");
        const payload = await this.request(`${this.v2AttachmentPath(normalizedMediaId)}/${action}`, "POST", input, options, retryableOperation);
        return readV2AttachmentMediaResponse(payload, this.tenantId, normalizedMediaId);
    }
    get encodedTenantId() {
        return encodeURIComponent(this.tenantId);
    }
    get v2TenantPath() {
        return `/mindset/v2/tenants/${this.encodedTenantId}`;
    }
    v2ConversationPath(conversationId) {
        return `${this.v2TenantPath}/conversations/${encodeIdentifier(conversationId, "conversationId")}`;
    }
    v2AccountPath(userId) {
        return `${this.v2TenantPath}/accounts/${encodeIdentifier(userId, "userId")}`;
    }
    v2CompanyPath(companyId) {
        return `${this.v2TenantPath}/companies/${encodeIdentifier(companyId, "companyId")}`;
    }
    /** Phase 2C paths hang off the existing company path (contracts §2). */
    companyDepartmentPath(companyId, departmentId) {
        return `${this.v2CompanyPath(companyId)}/departments/${encodeIdentifier(departmentId, "departmentId")}`;
    }
    companyMemberPath(companyId, memberUserId) {
        return `${this.v2CompanyPath(companyId)}/members/${encodeIdentifier(memberUserId, "memberUserId")}`;
    }
    companyMemberInvitePath(companyId, inviteId) {
        return `${this.v2CompanyPath(companyId)}/member-invites/${encodeIdentifier(inviteId, "inviteId")}`;
    }
    v2GroupCallPath(callId) {
        return `${this.v2TenantPath}/group-calls/${encodeIdentifier(callId, "callId")}`;
    }
    v2ScheduledCallPath(scheduledCallId) {
        return `${this.v2TenantPath}/scheduled-calls/${encodeIdentifier(scheduledCallId, "scheduledCallId")}`;
    }
    v2AttachmentPath(mediaId) {
        return `${this.v2TenantPath}/attachments/${encodeIdentifier(mediaId, "mediaId")}`;
    }
    callPath(callId) {
        return `/mindset/v1/tenants/${this.encodedTenantId}/calls/${encodeIdentifier(callId, "callId")}`;
    }
    conversationPath(conversationId) {
        return `/mindset/v1/tenants/${this.encodedTenantId}/conversations/${encodeIdentifier(conversationId, "conversationId")}`;
    }
    userProfilePath(userId) {
        return `/mindset/v1/tenants/${this.encodedTenantId}/users/${encodeIdentifier(userId, "userId")}/profile`;
    }
    accountSettingsPath(userId) {
        return `/mindset/v1/tenants/${this.encodedTenantId}/users/${encodeIdentifier(userId, "userId")}/settings`;
    }
    contactDiscoveryPath(userId) {
        return `/mindset/v1/tenants/${this.encodedTenantId}/users/${encodeIdentifier(userId, "userId")}/contact-discovery`;
    }
    messagesPath(conversationId) {
        return `${this.conversationPath(conversationId)}/messages`;
    }
    consentSettingsPath(userId) {
        return `/mindset/v1/tenants/${this.encodedTenantId}/users/${encodeIdentifier(userId, "userId")}/consent-settings`;
    }
    consentRequestPath(requestId) {
        return `/mindset/v1/tenants/${this.encodedTenantId}/consent-requests/${encodeIdentifier(requestId, "requestId")}`;
    }
    voicemailPath(voicemailId) {
        return `/mindset/v1/tenants/${this.encodedTenantId}/voicemails/${encodeIdentifier(voicemailId, "voicemailId")}`;
    }
    voicemailGreetingsPath(userId) {
        return `/mindset/v1/tenants/${this.encodedTenantId}/users/${encodeIdentifier(userId, "userId")}/voicemail-greetings`;
    }
    voicemailGreetingPath(greetingId) {
        return `/mindset/v1/tenants/${this.encodedTenantId}/voicemail-greetings/${encodeIdentifier(greetingId, "greetingId")}`;
    }
    listQuery(input) {
        const params = new URLSearchParams();
        if (input.limit !== undefined) {
            if (!Number.isInteger(input.limit) || input.limit < 1 || input.limit > 100) {
                throw new TypeError("limit must be an integer from 1 to 100");
            }
            params.set("limit", String(input.limit));
        }
        if (input.before !== undefined) {
            if (!Number.isFinite(Date.parse(input.before))) {
                throw new TypeError("before must be a valid timestamp");
            }
            params.set("before", input.before);
        }
        return params;
    }
    messageReportListQuery(input) {
        const params = this.listQuery(input);
        if (input.status !== undefined) {
            if (!MESSAGE_REPORT_STATUSES.has(input.status)) {
                throw new TypeError("status must be a valid message report status");
            }
            params.set("status", input.status);
        }
        return params;
    }
    async request(path, method, body, options = {}, retryableOperation = false) {
        if (options.signal?.aborted)
            throw abortedError();
        const controller = new AbortController();
        let timedOut = false;
        let attempts = 0;
        const timeoutMs = normalizeTimeout(options.timeoutMs ?? this.timeoutMs);
        const retry = resolveRetry(this.retry, options.retry, retryableOperation);
        const timeout = setTimeout(() => {
            timedOut = true;
            controller.abort();
        }, timeoutMs);
        const abortFromCaller = () => controller.abort();
        options.signal?.addEventListener("abort", abortFromCaller, { once: true });
        try {
            while (attempts < retry.maxAttempts) {
                attempts += 1;
                let phase = "credential";
                let response;
                try {
                    const [credential, cloudRunIdentityToken] = await waitForAbort(Promise.all([
                        this.resolveCredential(),
                        this.resolveCloudRunIdentityToken(),
                    ]), controller.signal);
                    const headers = {};
                    if (options.headers) {
                        for (const [name, value] of Object.entries(options.headers)) {
                            const normalized = name.trim().toLowerCase();
                            if (normalized === "authorization" ||
                                normalized === "accept" ||
                                normalized === "content-type" ||
                                normalized === "x-serverless-authorization") {
                                continue;
                            }
                            headers[normalized] = value;
                        }
                    }
                    headers.accept = "application/json";
                    if (body !== undefined)
                        headers["content-type"] = "application/json";
                    if (credential !== undefined) {
                        headers.authorization = `Bearer ${credential}`;
                    }
                    if (cloudRunIdentityToken !== undefined) {
                        headers["x-serverless-authorization"] =
                            `Bearer ${cloudRunIdentityToken}`;
                    }
                    phase = "fetch";
                    response = await waitForAbort(this.fetchImplementation(`${this.baseUrl}${path}`, {
                        method,
                        headers,
                        ...(body === undefined ? {} : { body: JSON.stringify(body) }),
                        signal: controller.signal,
                    }), controller.signal);
                    phase = "response";
                    const requestId = response.headers.get("x-request-id");
                    const contentLength = readContentLength(response.headers);
                    if (contentLength !== null &&
                        contentLength > this.maxResponseBytes) {
                        throw invalidResponse("Mindset returned a response larger than the configured limit", response.status, requestId);
                    }
                    const responseText = await waitForAbort(response.text(), controller.signal);
                    if (utf8Length(responseText) > this.maxResponseBytes) {
                        throw invalidResponse("Mindset returned a response larger than the configured limit", response.status, requestId);
                    }
                    const payload = parsePayload(responseText);
                    const sensitiveValues = [
                        credential,
                        cloudRunIdentityToken,
                        ...collectSensitiveValues(body),
                    ].filter((value) => Boolean(value));
                    if (!response.ok) {
                        throw readHttpError(response.status, requestId, payload, sensitiveValues);
                    }
                    if (payload === INVALID_JSON) {
                        throw invalidResponse("Mindset returned a response that was not valid JSON", response.status, requestId);
                    }
                    return payload;
                }
                catch (error) {
                    if (timedOut) {
                        throw timeoutError(timeoutMs, attempts, retryableOperation);
                    }
                    if (options.signal?.aborted || controller.signal.aborted) {
                        throw abortedError(attempts);
                    }
                    const normalized = normalizeRequestError(error, phase, response);
                    const failureIsRetryable = isRetryableFailure(normalized);
                    if (!failureIsRetryable ||
                        attempts >= retry.maxAttempts) {
                        throw withAttemptMetadata(normalized, attempts, retryableOperation && failureIsRetryable);
                    }
                    const retryAfterMs = parseRetryAfter(response?.headers.get("retry-after") ?? null);
                    const delayMs = retryAfterMs ?? retryDelay(retry, attempts);
                    await abortableDelay(delayMs, controller.signal);
                }
            }
        }
        catch (error) {
            if (timedOut) {
                throw timeoutError(timeoutMs, attempts, retryableOperation);
            }
            if (options.signal?.aborted || controller.signal.aborted) {
                throw abortedError(attempts);
            }
            if (error instanceof MindsetApiError)
                throw error;
            throw new MindsetApiError({
                kind: "network",
                code: "NETWORK_ERROR",
                message: "Unable to reach the Mindset API",
                attempts,
            });
        }
        finally {
            clearTimeout(timeout);
            options.signal?.removeEventListener("abort", abortFromCaller);
        }
    }
    async resolveCredential() {
        return resolveCredentialValue(this.credential, "Mindset tenant credential");
    }
    async resolveCloudRunIdentityToken() {
        return resolveCredentialValue(this.cloudRunIdentityToken, "Mindset Cloud Run identity token");
    }
}
exports.MindsetApiClient = MindsetApiClient;
function createMindsetApiClient(options) {
    return new MindsetApiClient(options);
}
function v2ScheduledCallListQuery(input) {
    const params = new URLSearchParams();
    if (input.statuses !== undefined) {
        if (!Array.isArray(input.statuses) ||
            input.statuses.length > 4 ||
            !input.statuses.every((status) => isEnumValue(status, V2_SCHEDULED_CALL_STATUSES)) ||
            new Set(input.statuses).size !== input.statuses.length) {
            throw new TypeError("statuses must contain unique v2 scheduled-call statuses");
        }
        if (input.statuses.length > 0) {
            params.set("statuses", input.statuses.join(","));
        }
    }
    if (input.startsAfter !== undefined) {
        if (!isTimestamp(input.startsAfter)) {
            throw new TypeError("startsAfter must be a valid timestamp");
        }
        params.set("startsAfter", input.startsAfter);
    }
    if (input.startsBefore !== undefined) {
        if (!isTimestamp(input.startsBefore)) {
            throw new TypeError("startsBefore must be a valid timestamp");
        }
        params.set("startsBefore", input.startsBefore);
    }
    if (input.startsAfter !== undefined &&
        input.startsBefore !== undefined &&
        Date.parse(input.startsAfter) >= Date.parse(input.startsBefore)) {
        throw new TypeError("startsAfter must be before startsBefore");
    }
    if (input.cursor !== undefined) {
        params.set("cursor", requireIdentifier(input.cursor, "cursor"));
    }
    if (input.limit !== undefined) {
        params.set("limit", String(boundedInteger(input.limit, "limit", 1, 100)));
    }
    return params;
}
function v2AttachmentMediaListQuery(input) {
    const params = new URLSearchParams({
        requesterUserId: requireIdentifier(input.requesterUserId, "requesterUserId"),
    });
    if (input.kind !== undefined) {
        if (!isEnumValue(input.kind, V2_ATTACHMENT_KINDS)) {
            throw new TypeError("kind must be IMAGE, VIDEO, AUDIO, or FILE");
        }
        params.set("kind", input.kind);
    }
    if (input.cursor !== undefined) {
        params.set("cursor", requireIdentifier(input.cursor, "cursor"));
    }
    if (input.limit !== undefined) {
        params.set("limit", String(boundedInteger(input.limit, "limit", 1, 100)));
    }
    return params;
}
function v2AttachmentDownloadQuery(input) {
    const params = new URLSearchParams({
        requesterUserId: requireIdentifier(input.requesterUserId, "requesterUserId"),
    });
    if (input.rendition !== undefined) {
        if (!isEnumValue(input.rendition, ["ORIGINAL", "THUMBNAIL"])) {
            throw new TypeError("rendition must be ORIGINAL or THUMBNAIL");
        }
        params.set("rendition", input.rendition);
    }
    return params;
}
const defaultFetch = async (url, init) => globalThis.fetch(url, init);
const INVALID_JSON = Symbol("INVALID_JSON");
function parsePayload(value) {
    if (value.trim().length === 0)
        return null;
    try {
        return JSON.parse(value);
    }
    catch {
        return INVALID_JSON;
    }
}
function readCall(payload) {
    const record = requireRecord(payload, "call response");
    if (!(0, sdk_1.isMindsetCallSession)(record.call)) {
        throw invalidResponse("Mindset returned an invalid call response");
    }
    return record.call;
}
function readCalls(payload) {
    const record = requireRecord(payload, "active calls response");
    if (!Array.isArray(record.calls)) {
        throw invalidResponse("Mindset returned an invalid active calls response");
    }
    return record.calls.map((call) => {
        if (!(0, sdk_1.isMindsetCallSession)(call)) {
            throw invalidResponse("Mindset returned an invalid active call");
        }
        return call;
    });
}
function readGroupCallInvitePlan(payload) {
    const record = requireRecord(payload, "group call invite-plan response");
    if (!(0, sdk_1.isMindsetGroupCallInvitePlan)(record.plan)) {
        throw invalidResponse("Mindset returned an invalid group call invite-plan response");
    }
    return record.plan;
}
function readV2AccountProfileResponse(payload, tenantId, userId) {
    const record = requireRecord(payload, "v2 account profile response");
    return readV2AccountProfileValue(record.profile, tenantId, userId);
}
function readV2AccountCompletion(payload, tenantId, userId) {
    const record = requireRecord(payload, "v2 account completion response");
    const profile = readV2AccountProfileValue(record.profile, tenantId, userId);
    const company = record.company === null
        ? null
        : readV2CompanyValue(record.company, tenantId, undefined);
    return { profile, company };
}
function readV2ProfileAvatarUploadIntent(payload, tenantId, userId) {
    if (!isRecord(payload) || !isRecord(payload.upload)) {
        throw invalidResponse("Mindset returned an invalid profile avatar upload intent");
    }
    if (payload.contractVersion !== sdk_1.MINDSET_PROFILE_AVATAR_V1_CONTRACT_VERSION ||
        payload.tenantId !== tenantId ||
        payload.userId !== userId ||
        typeof payload.assetId !== "string" ||
        payload.upload.method !== "PUT" ||
        typeof payload.upload.url !== "string" ||
        !isRecord(payload.upload.requiredHeaders) ||
        typeof payload.upload.expiresAt !== "string") {
        throw invalidResponse("Mindset returned an invalid or out-of-scope profile avatar upload intent");
    }
    return payload;
}
function readV2ProfileAvatarDownloadGrant(payload) {
    if (!isRecord(payload) ||
        payload.contractVersion !== sdk_1.MINDSET_PROFILE_AVATAR_V1_CONTRACT_VERSION ||
        typeof payload.url !== "string" ||
        typeof payload.expiresAt !== "string") {
        throw invalidResponse("Mindset returned an invalid profile avatar download grant");
    }
    return payload;
}
function readV2ProfileAvatarAsset(payload, tenantId, userId, assetId) {
    if (!isRecord(payload) ||
        payload.contractVersion !== sdk_1.MINDSET_PROFILE_AVATAR_V1_CONTRACT_VERSION ||
        payload.tenantId !== tenantId ||
        payload.userId !== userId ||
        payload.assetId !== assetId) {
        throw invalidResponse("Mindset returned an invalid profile avatar asset");
    }
    return payload;
}
function readV2AccountProfileValue(value, tenantId, userId) {
    if (!isRecord(value)) {
        throw invalidResponse("Mindset returned an invalid v2 account profile");
    }
    if (value.contractVersion !== sdk_1.MINDSET_ACCOUNTS_V2_CONTRACT_VERSION ||
        value.tenantId !== tenantId ||
        value.userId !== userId ||
        (value.accountType !== "PERSONAL" && value.accountType !== "BUSINESS") ||
        typeof value.handle !== "string" ||
        typeof value.displayName !== "string" ||
        !(value.directoryVisibility === undefined ||
            ["EVERYONE", "CUSTOM", "NOBODY"].includes(String(value.directoryVisibility))) ||
        !(value.directoryAudiences === undefined || Array.isArray(value.directoryAudiences)) ||
        !Number.isInteger(value.revision) ||
        value.revision < 1) {
        throw invalidResponse("Mindset returned an invalid or out-of-scope v2 account profile");
    }
    return {
        ...value,
        directoryVisibility: value.directoryVisibility ?? "EVERYONE",
        directoryAudiences: value.directoryAudiences ?? [],
    };
}
function readV2DirectoryProfiles(payload, tenantId) {
    const record = requireRecord(payload, "v2 directory response");
    if (record.contractVersion !== sdk_1.MINDSET_ACCOUNTS_V2_CONTRACT_VERSION ||
        !Array.isArray(record.profiles)) {
        throw invalidResponse("Mindset returned an invalid directory response");
    }
    const relationships = new Set([
        "DEVICE_CONTACT",
        "CONTACT",
        "MUTUAL",
        "FRIEND_OF_FRIEND",
        "BUSINESS",
        "PRIOR_CONTACT",
        "DIRECTORY",
    ]);
    return record.profiles.map((value) => {
        if (!isRecord(value) ||
            value.contractVersion !== sdk_1.MINDSET_ACCOUNTS_V2_CONTRACT_VERSION ||
            value.tenantId !== tenantId ||
            typeof value.userId !== "string" ||
            typeof value.handle !== "string" ||
            typeof value.displayName !== "string" ||
            !(value.avatarUrl === null || typeof value.avatarUrl === "string") ||
            !(value.highlight === null || typeof value.highlight === "string") ||
            typeof value.relationship !== "string" ||
            !relationships.has(value.relationship) ||
            typeof value.exactHandleMatch !== "boolean") {
            throw invalidResponse("Mindset returned an invalid directory profile");
        }
        return value;
    });
}
function readV2DirectoryContactSync(payload, tenantId, userId) {
    if (!isRecord(payload) ||
        payload.contractVersion !== sdk_1.MINDSET_ACCOUNTS_V2_CONTRACT_VERSION ||
        payload.tenantId !== tenantId ||
        payload.userId !== userId ||
        !Number.isInteger(payload.syncedCount) ||
        payload.syncedCount < 0 ||
        typeof payload.updatedAt !== "string") {
        throw invalidResponse("Mindset returned an invalid directory contact sync result");
    }
    return payload;
}
const V2_SAVED_CONTACT_LABELS = new Set([
    "FAVORITE",
    "BUSINESS",
    "BILL_COLLECTOR",
]);
function readV2SavedContacts(payload, tenantId, userId) {
    const record = requireRecord(payload, "v2 saved contacts response");
    if (record.contractVersion !== sdk_1.MINDSET_ACCOUNTS_V2_CONTRACT_VERSION ||
        !Array.isArray(record.contacts)) {
        throw invalidResponse("Mindset returned an invalid saved contacts response");
    }
    return record.contacts.map((value) => readV2SavedContactValue(value, tenantId, userId));
}
function readV2SavedContactValue(value, tenantId, userId) {
    if (!isRecord(value) ||
        value.contractVersion !== sdk_1.MINDSET_ACCOUNTS_V2_CONTRACT_VERSION ||
        value.tenantId !== tenantId ||
        value.userId !== userId ||
        typeof value.contactUserId !== "string" ||
        typeof value.handle !== "string" ||
        typeof value.displayName !== "string" ||
        !(value.avatarUrl === null || typeof value.avatarUrl === "string") ||
        !(value.highlight === null || typeof value.highlight === "string") ||
        !Array.isArray(value.labels) ||
        value.labels.some((label) => typeof label !== "string" || !V2_SAVED_CONTACT_LABELS.has(label)) ||
        typeof value.createdAt !== "string" ||
        typeof value.updatedAt !== "string") {
        throw invalidResponse("Mindset returned an invalid saved contact");
    }
    return value;
}
const V2_CONTACT_ATTEMPT_CHANNELS = new Set(["CALL", "MESSAGE"]);
const V2_CONTACT_ATTEMPT_DISPOSITIONS = new Set(["ALLOWED", "BLOCKED"]);
const V2_BILL_COLLECTOR_NOTICES = new Set([
    "REMOVE_FROM_CALLING_SYSTEM",
    "EMAIL_ONLY",
    "WRITTEN_ONLY",
    "DO_NOT_CONTACT_AT_WORK",
    "LEAVE_MESSAGE_ONLY",
]);
function readV2ContactAttempts(payload, tenantId, userId) {
    const record = requireRecord(payload, "v2 contact attempts response");
    if (record.contractVersion !== sdk_1.MINDSET_ACCOUNTS_V2_CONTRACT_VERSION ||
        !Array.isArray(record.attempts)) {
        throw invalidResponse("Mindset returned an invalid contact attempts response");
    }
    return record.attempts.map((value) => {
        if (!isRecord(value) ||
            value.contractVersion !== sdk_1.MINDSET_ACCOUNTS_V2_CONTRACT_VERSION ||
            value.tenantId !== tenantId ||
            value.userId !== userId ||
            typeof value.counterpartyUserId !== "string" ||
            typeof value.counterpartyDisplayName !== "string" ||
            typeof value.channel !== "string" ||
            !V2_CONTACT_ATTEMPT_CHANNELS.has(value.channel) ||
            typeof value.disposition !== "string" ||
            !V2_CONTACT_ATTEMPT_DISPOSITIONS.has(value.disposition) ||
            typeof value.notice !== "string" ||
            !V2_BILL_COLLECTOR_NOTICES.has(value.notice) ||
            typeof value.occurredAt !== "string") {
            throw invalidResponse("Mindset returned an invalid contact attempt");
        }
        return value;
    });
}
function readV2CompanyResponse(payload, tenantId, companyId) {
    const record = requireRecord(payload, "v2 company response");
    return readV2CompanyValue(record.company, tenantId, companyId);
}
function readV2CompanyList(payload, tenantId) {
    const record = requireRecord(payload, "v2 company list response");
    if (record.contractVersion !== sdk_1.MINDSET_ACCOUNTS_V2_CONTRACT_VERSION ||
        !Array.isArray(record.companies)) {
        throw invalidResponse("Mindset returned an invalid v2 company list response");
    }
    return record.companies.map((company) => readV2CompanyValue(company, tenantId, undefined));
}
function readV2CompanyValue(value, tenantId, companyId) {
    if (!isRecord(value)) {
        throw invalidResponse("Mindset returned an invalid v2 company");
    }
    if (value.contractVersion !== sdk_1.MINDSET_ACCOUNTS_V2_CONTRACT_VERSION ||
        value.tenantId !== tenantId ||
        typeof value.id !== "string" ||
        (companyId !== undefined && value.id !== companyId) ||
        typeof value.name !== "string" ||
        !Array.isArray(value.memberships) ||
        !isRecord(value.limits) ||
        !isRecord(value.usage)) {
        throw invalidResponse("Mindset returned an invalid or out-of-scope v2 company");
    }
    for (const membership of value.memberships) {
        if (!isRecord(membership) ||
            membership.companyId !== value.id ||
            typeof membership.userId !== "string" ||
            !COMPANY_ROLES.includes(String(membership.role))) {
            throw invalidResponse("Mindset returned an invalid v2 company membership");
        }
    }
    return value;
}
// ---- Phase 2C team management readers (contracts §2) -----------------------
// Deliberately tolerant: they assert the load-bearing invariants (the company
// identity, a member list with an id and a known role) and pass the rest
// through, so an additive api field never breaks the dashboard.
const COMPANY_ROLES = [
    "OWNER",
    "SUPER_ADMIN",
    "ADMIN",
    "MEMBER",
];
function readHostAccessEndpoint(value) {
    try {
        if (typeof value !== "string" || value.length > 2048 || /[\u0000-\u0020\u007f?#]/.test(value))
            throw new Error();
        const url = new URL(value);
        if (url.protocol !== "https:" || url.username || url.password || (url.port && url.port !== "443") ||
            !url.hostname.includes(".") || /^\d+$/.test(url.hostname.split(".").at(-1) ?? "") ||
            !url.hostname.split(".").every((label) => /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/.test(label)) ||
            [".localhost", ".local", ".internal", ".home.arpa"].some((suffix) => url.hostname.endsWith(suffix)))
            throw new Error();
        return url.href;
    }
    catch {
        throw new TypeError("Invalid host access policy endpoint");
    }
}
function readIntegrationHostAccessPolicy(value, applicationId) {
    const fields = ["id", "applicationId", "version", "endpoint", "state", "createdAt", "updatedAt", "verifiedAt", "verifiedUntil"];
    try {
        if (!isRecord(value) || Object.keys(value).some((key) => !fields.includes(key)) || !isNonEmptyString(value.id) || value.id.length > 255 ||
            value.applicationId !== applicationId || typeof value.version !== "number" || !Number.isInteger(value.version) || value.version < 1 || value.version > 1000 ||
            !["PENDING", "VERIFIED", "REVOKED"].includes(String(value.state)) || !isTimestamp(value.createdAt) || !isTimestamp(value.updatedAt) ||
            readHostAccessEndpoint(value.endpoint) !== value.endpoint ||
            (value.verifiedAt !== null && !isTimestamp(value.verifiedAt)) || (value.verifiedUntil !== null && !isTimestamp(value.verifiedUntil)) ||
            ((value.verifiedAt === null) !== (value.verifiedUntil === null)) ||
            (value.state === "PENDING" && value.verifiedAt !== null) || (value.state === "VERIFIED" && value.verifiedAt === null))
            throw new Error();
        if (typeof value.verifiedAt === "string" && typeof value.verifiedUntil === "string" &&
            (Date.parse(value.verifiedAt) < Date.parse(value.createdAt) || Date.parse(value.verifiedUntil) <= Date.parse(value.verifiedAt) ||
                Date.parse(value.verifiedUntil) - Date.parse(value.verifiedAt) > 3600000))
            throw new Error();
        return value;
    }
    catch {
        throw invalidResponse("Invalid host access policy metadata");
    }
}
function readIntegrationDomainChallenge(value) {
    if (!isRecord(value) || !isNonEmptyString(value.id) || !isNonEmptyString(value.applicationId) || !isNonEmptyString(value.origin) ||
        value.origin.length > 2048 || !["PENDING", "VERIFIED", "REVOKED"].includes(String(value.state)) || !isTimestamp(value.issuedAt) || !isTimestamp(value.expiresAt) ||
        Date.parse(value.expiresAt) <= Date.parse(value.issuedAt) || Date.parse(value.expiresAt) - Date.parse(value.issuedAt) > 900000 ||
        !isRecord(value.instructions) || value.instructions.type !== "TXT" || !isNonEmptyString(value.instructions.name) || !isNonEmptyString(value.instructions.value))
        throw invalidResponse("Invalid domain challenge");
    let ownership;
    if (value.ownership !== undefined) {
        const proof = value.ownership;
        if (!isRecord(proof) || !hasExactKeys(proof, ["observedAt", "validUntil"]) || value.state === "PENDING" ||
            !isTimestamp(proof.observedAt) || !isTimestamp(proof.validUntil) || Date.parse(proof.observedAt) < Date.parse(value.issuedAt) ||
            Date.parse(proof.validUntil) <= Date.parse(proof.observedAt) || Date.parse(proof.validUntil) - Date.parse(proof.observedAt) > 900000) {
            throw invalidResponse("Invalid domain ownership observation");
        }
        ownership = { observedAt: proof.observedAt, validUntil: proof.validUntil };
    }
    let origin;
    try {
        origin = new URL(value.origin);
    }
    catch {
        throw invalidResponse("Invalid domain challenge origin");
    }
    if (origin.protocol !== "https:" || origin.origin !== value.origin ||
        value.instructions.name !== `_mindset-verification.${origin.hostname}` ||
        !value.instructions.value.startsWith(`mindset-verification=${value.applicationId}:`) ||
        !/^[A-Za-z0-9_-]{43}$/.test(value.instructions.value.slice(`mindset-verification=${value.applicationId}:`.length)))
        throw invalidResponse("Invalid domain challenge instructions");
    return { id: value.id, applicationId: value.applicationId, origin: value.origin, state: value.state,
        issuedAt: value.issuedAt, expiresAt: value.expiresAt, ...(ownership ? { ownership } : {}),
        instructions: { type: "TXT", name: value.instructions.name, value: value.instructions.value } };
}
function readIntegrationProvisioning(value, companyId) {
    if (!isRecord(value) || value.companyId !== companyId || !isNonEmptyString(value.id) || !isNonEmptyString(value.applicationId) ||
        !["sandbox", "production"].includes(String(value.environment)) ||
        !["PENDING", "PROCESSING", "AWAITING_ACK", "COMPLETED", "FAILED", "CANCELED"].includes(String(value.state)) ||
        !isNonEmptyString(value.planKey) || value.planKey.length > 80 || typeof value.planVersion !== "number" ||
        !Number.isSafeInteger(value.planVersion) || value.planVersion < 1 || !isTimestamp(value.createdAt) || !isTimestamp(value.updatedAt)) {
        throw invalidResponse("Invalid or out-of-scope provisioning operation");
    }
    return { id: value.id, companyId, applicationId: value.applicationId,
        environment: value.environment,
        state: value.state, planKey: value.planKey,
        planVersion: value.planVersion, createdAt: value.createdAt, updatedAt: value.updatedAt };
}
function validBusinessHandleQuantity(value) {
    return typeof value === "number" && Number.isSafeInteger(value) && value >= 1 && value <= 100000;
}
function readCheckoutOperation(value, companyId) {
    if (!isRecord(value) || value.companyId !== companyId || !isNonEmptyString(value.id) || (value.environment !== "sandbox" && value.environment !== "production") ||
        !["PENDING", "READY", "COMPLETED", "EXPIRED"].includes(String(value.state)) ||
        typeof value.planKey !== "string" || !/^[a-z][a-z0-9-]{1,78}[a-z0-9]$/.test(value.planKey) ||
        typeof value.planVersion !== "number" || !Number.isSafeInteger(value.planVersion) || value.planVersion < 1 ||
        (value.businessHandleQuantity !== undefined && !validBusinessHandleQuantity(value.businessHandleQuantity)) ||
        !isTimestamp(value.createdAt) || !isTimestamp(value.updatedAt))
        throw invalidResponse("Invalid checkout operation");
    return { id: value.id, companyId, environment: value.environment, state: value.state,
        planKey: value.planKey, planVersion: value.planVersion, createdAt: value.createdAt, updatedAt: value.updatedAt,
        ...(value.businessHandleQuantity !== undefined ? { businessHandleQuantity: value.businessHandleQuantity } : {}) };
}
function readCheckoutPlan(raw) {
    const value = requireRecord(raw, "checkout plan"), price = requireRecord(value.price, "checkout price");
    const capabilities = requireRecord(value.capabilities, "checkout capabilities"), realtime = requireRecord(capabilities.realtime, "checkout realtime capabilities");
    const capabilityKeys = ["messaging", "mediaRequests", "audioCalls", "videoCalls", "callRequests", "oneTimeCallApprovals", "reusableCallApprovals"];
    const realtimeKeys = ["websocketEvents", "directPush", "androidTelecom", "iosCallKit", "liveKit"];
    if ((value.environment !== "sandbox" && value.environment !== "production") || typeof value.planKey !== "string" || !/^[a-z][a-z0-9-]{1,78}[a-z0-9]$/.test(value.planKey) ||
        typeof value.planVersion !== "number" || !Number.isSafeInteger(value.planVersion) || value.planVersion < 1 ||
        typeof price.displayName !== "string" || !price.displayName.trim() || price.displayName.length > 160 || /[\x00-\x1f\x7f]/.test(price.displayName) ||
        typeof price.unitAmount !== "number" || !Number.isSafeInteger(price.unitAmount) || price.unitAmount < 0 ||
        typeof price.currency !== "string" || !/^[a-z]{3}$/.test(price.currency) ||
        !["day", "week", "month", "year"].includes(String(price.interval)) ||
        typeof price.intervalCount !== "number" || !Number.isSafeInteger(price.intervalCount) || price.intervalCount < 1 ||
        !["inclusive", "exclusive", "unspecified"].includes(String(price.taxBehavior)) ||
        capabilityKeys.some((key) => typeof capabilities[key] !== "boolean") || realtimeKeys.some((key) => typeof realtime[key] !== "boolean"))
        throw invalidResponse("Invalid priced checkout plan");
    const commercialPricing = value.commercialPricing === undefined
        ? undefined
        : readCheckoutCommercialPricing(value.commercialPricing);
    if (value.billingModelVersion !== undefined && value.billingModelVersion !== "mindset.subscription-components/v2")
        throw invalidResponse("Invalid billing model");
    if (value.billingModelVersion === "mindset.subscription-components/v2" &&
        (commercialPricing?.businessCommunicationsWorkspace.unitAmount !== 3600 || price.unitAmount !== 4800 || price.currency !== "usd" ||
            price.interval !== "year" || price.intervalCount !== 1))
        throw invalidResponse("Invalid annual checkout price");
    if (commercialPricing?.businessCommunicationsWorkspace.unitAmount === 3600 && !value.billingModelVersion)
        throw invalidResponse("Annual billing model is required");
    return { environment: value.environment, planKey: value.planKey, planVersion: value.planVersion,
        capabilities: { ...Object.fromEntries(capabilityKeys.map((key) => [key, capabilities[key]])),
            realtime: Object.fromEntries(realtimeKeys.map((key) => [key, realtime[key]])) },
        ...(commercialPricing ? { commercialPricing } : {}),
        ...(value.billingModelVersion ? { billingModelVersion: "mindset.subscription-components/v2" } : {}),
        price: { displayName: price.displayName, unitAmount: price.unitAmount, currency: price.currency,
            interval: price.interval, intervalCount: price.intervalCount,
            taxBehavior: price.taxBehavior } };
}
function readCheckoutCommercialPricing(raw) {
    const value = requireRecord(raw, "checkout commercial pricing");
    const individuals = requireRecord(value.individuals, "checkout individual pricing");
    const identity = requireRecord(value.businessAtIdentity, "checkout Business @ pricing");
    const workspace = requireRecord(value.businessCommunicationsWorkspace, "checkout workspace pricing");
    if (individuals.unitAmount !== 0 || individuals.currency !== "usd" || individuals.cadence !== "free" ||
        identity.unitAmount !== 1200 || identity.currency !== "usd" || identity.interval !== "year" ||
        identity.intervalCount !== 1 || identity.unit !== "active Business @ identity" ||
        !((workspace.unitAmount === 3600 && workspace.interval === "year") || (workspace.unitAmount === 300 && workspace.interval === "month")) || workspace.currency !== "usd" ||
        workspace.intervalCount !== 1 || workspace.unit !== "workspace")
        throw invalidResponse("Invalid checkout commercial pricing");
    return {
        individuals: { unitAmount: 0, currency: "usd", cadence: "free" },
        businessAtIdentity: { unitAmount: 1200, currency: "usd", interval: "year", intervalCount: 1, unit: "active Business @ identity" },
        businessCommunicationsWorkspace: workspace.unitAmount === 3600
            ? { unitAmount: 3600, currency: "usd", interval: "year", intervalCount: 1, unit: "workspace" }
            : { unitAmount: 300, currency: "usd", interval: "month", intervalCount: 1, unit: "workspace" },
    };
}
/** Public-key syntax validation only; the server still verifies key strength and domain ownership. */
function parseMindsetIntegrationIdentity(value, origins) {
    try {
        return readIntegrationIdentity(value, origins);
    }
    catch {
        throw new TypeError("Invalid public identity registration");
    }
}
function readIntegrationIdentity(value, origins) {
    if (!isRecord(value) || Object.keys(value).some((key) => !["issuer", "keys"].includes(key)) ||
        typeof value.issuer !== "string" || value.issuer.length > 2048 || /[\u0000-\u0020\u007f]/.test(value.issuer) ||
        !Array.isArray(value.keys) || value.keys.length < 1 || value.keys.length > 5)
        throw invalidResponse("Invalid identity settings");
    let issuer;
    try {
        issuer = new URL(value.issuer);
    }
    catch {
        throw invalidResponse("Invalid identity issuer");
    }
    let registered = false;
    try {
        registered = origins.some((origin) => new URL(origin).origin === issuer.origin);
    }
    catch {
        throw invalidResponse("Invalid identity origin");
    }
    if (issuer.protocol !== "https:" || issuer.username || issuer.password || value.issuer.includes("?") || value.issuer.includes("#") ||
        ["localhost", "127.0.0.1", "[::1]"].includes(issuer.hostname) || !registered)
        throw invalidResponse("Invalid identity issuer");
    const seen = new Set();
    const keys = value.keys.map((key) => {
        if (!isRecord(key) || Object.keys(key).some((field) => !["kty", "alg", "use", "kid", "n", "e"].includes(field)) ||
            key.kty !== "RSA" || key.alg !== "RS256" || key.use !== "sig" || key.e !== "AQAB" ||
            typeof key.kid !== "string" || !/^[A-Za-z0-9_-]{1,80}$/.test(key.kid) || seen.has(key.kid) ||
            typeof key.n !== "string" || key.n.length < 342 || key.n.length > 683 || !/^[A-Za-z0-9_-]+$/.test(key.n))
            throw invalidResponse("Invalid public identity key");
        seen.add(key.kid);
        return { kty: "RSA", alg: "RS256", use: "sig", kid: key.kid, n: key.n, e: "AQAB" };
    });
    return { issuer: value.issuer, keys };
}
function readIntegrationApplicationDraft(value, companyId) {
    if (!isRecord(value) || value.companyId !== companyId || !isNonEmptyString(value.id) ||
        !isNonEmptyString(value.displayName) || value.displayName.length > 160 ||
        !["sandbox", "production"].includes(String(value.environment)) ||
        !isTimestamp(value.createdAt) || !isTimestamp(value.updatedAt)) {
        throw invalidResponse("Invalid or out-of-scope application draft");
    }
    for (const key of ["webOrigins", "androidApplicationIds", "iosBundleIds"]) {
        const entries = value[key];
        if (!Array.isArray(entries) || entries.length > 20 || !entries.every(isNonEmptyString)) {
            throw invalidResponse("Invalid application draft settings");
        }
    }
    return {
        id: value.id, companyId, displayName: value.displayName,
        environment: value.environment,
        webOrigins: [...value.webOrigins], androidApplicationIds: [...value.androidApplicationIds],
        iosBundleIds: [...value.iosBundleIds], createdAt: value.createdAt, updatedAt: value.updatedAt,
        ...(value.identity == null ? {} : { identity: readIntegrationIdentity(value.identity, value.webOrigins) }),
    };
}
function readCompanyTeamResponse(payload, companyId) {
    const record = requireRecord(payload, "company team response");
    const team = record.team;
    if (!isRecord(team)) {
        throw invalidResponse("Mindset returned an invalid company team response");
    }
    const company = team.company;
    if (!isRecord(company) ||
        company.id !== companyId ||
        !isNonEmptyString(company.name) ||
        !isRecord(company.seats) ||
        !isRecord(team.viewer) ||
        !Array.isArray(team.members) ||
        !Array.isArray(team.departments)) {
        throw invalidResponse("Mindset returned an invalid or out-of-scope company team");
    }
    if (!COMPANY_ROLES.includes(String(team.viewer.role))) {
        throw invalidResponse("Mindset returned an invalid company team viewer role");
    }
    for (const member of team.members) {
        if (!isRecord(member) ||
            !isNonEmptyString(member.userId) ||
            !COMPANY_ROLES.includes(String(member.role)) ||
            !isRecord(member.capabilities) ||
            typeof member.canReceiveCompanyLine !== "boolean") {
            throw invalidResponse("Mindset returned an invalid company team member");
        }
    }
    return team;
}
const COMPANY_LINE_GRANT_STATES = [
    "PENDING_APPROVAL",
    "ACTIVE",
    "REVOKED",
    "DENIED",
];
/**
 * Parses the api's `outcomes` array (services/api team.service.ts,
 * MindsetTeamBulkGrantOutcome). Every field is REQUIRED and checked: a shape
 * drift on the api side must fail here loudly rather than degrade into a list
 * of "not skipped, no state" rows that the dialog would render as success.
 * `reason` stays an open string so a NEW skip reason from a newer api reaches
 * the caller intact instead of being erased by an older client.
 */
function readCompanyDepartmentGrantOutcomes(value) {
    if (!Array.isArray(value)) {
        throw invalidResponse("Mindset returned an invalid department answer-grant outcome list");
    }
    return value.map((entry) => {
        if (!isRecord(entry) ||
            !isNonEmptyString(entry.memberUserId) ||
            typeof entry.skipped !== "boolean" ||
            !(entry.state === null || isNonEmptyString(entry.state)) ||
            !(entry.reason === null || isNonEmptyString(entry.reason))) {
            throw invalidResponse("Mindset returned an invalid department answer-grant outcome");
        }
        if (entry.state !== null &&
            !COMPANY_LINE_GRANT_STATES.includes(entry.state)) {
            throw invalidResponse("Mindset returned an unknown department answer-grant outcome state");
        }
        return {
            memberUserId: entry.memberUserId,
            state: entry.state,
            skipped: entry.skipped,
            reason: entry.reason,
        };
    });
}
function readCompanyMemberInviteResult(payload, companyId) {
    const record = requireRecord(payload, "company member invite response");
    const invite = record.invite;
    if (!isRecord(invite) ||
        !isNonEmptyString(invite.inviteId) ||
        !isNonEmptyString(invite.handle) ||
        !isNonEmptyString(invite.status)) {
        throw invalidResponse("Mindset returned an invalid company member invite");
    }
    // The clear code is returned exactly once; a response without it is a bug
    // the owner cannot recover from except by regenerating.
    if (!isNonEmptyString(record.claimCode)) {
        throw invalidResponse("Mindset returned a company member invite without its one-time claim code");
    }
    return {
        invite: invite,
        claimCode: record.claimCode,
        team: readCompanyTeamResponse(record, companyId),
    };
}
/**
 * THE CLAIM IS ALREADY COMMITTED BY THE TIME THESE BYTES ARRIVE. The rekey ran
 * inside the api's transaction, so anything this reader throws on is a claim
 * that HAPPENED being reported to the caller as a failure - with a one-time
 * code that is now spent. So strictness here is spent only where it buys
 * something:
 *
 *   - `companyId` and `userId` are REQUIRED. Without them the answer cannot say
 *     who joined what, and the phone cannot check the claim against its own
 *     session; a claim it cannot verify is worse than an error.
 *   - `companyName` and `handle` are cosmetic, so they are read leniently and
 *     surface as `null` when absent - never as `""`, which is how a field that
 *     stopped arriving hides. The api always sends both, and the contract
 *     fixture under services/api/src/companies/__contract__ FAILS THE BUILD if
 *     it ever stops - which is the right place to catch it, rather than on a
 *     new hire's first day.
 */
function readCompanyMemberInviteClaimResult(payload) {
    const record = requireRecord(payload, "company member invite claim response");
    const claim = isRecord(record.claim) ? record.claim : record;
    if (!isNonEmptyString(claim.companyId) || !isNonEmptyString(claim.userId)) {
        throw invalidResponse("Mindset returned an invalid company member invite claim result");
    }
    return {
        companyId: claim.companyId,
        userId: claim.userId,
        companyName: isNonEmptyString(claim.companyName) ? claim.companyName : null,
        handle: isNonEmptyString(claim.handle) ? claim.handle : null,
        replacedEmptyAccount: claim.replacedEmptyAccount === true,
    };
}
function readCompanyAuditPage(payload) {
    const record = requireRecord(payload, "company audit response");
    if (!Array.isArray(record.items)) {
        throw invalidResponse("Mindset returned an invalid company audit response");
    }
    for (const item of record.items) {
        if (!isRecord(item) ||
            !isNonEmptyString(item.id) ||
            !isNonEmptyString(item.action) ||
            !isNonEmptyString(item.occurredAt)) {
            throw invalidResponse("Mindset returned an invalid company audit entry");
        }
    }
    return {
        items: record.items,
        nextCursor: isNonEmptyString(record.nextCursor) ? record.nextCursor : null,
    };
}
function readV2CompanyCallPreflight(payload) {
    const record = requireRecord(payload, "v2 company call preflight response");
    const preflight = record.preflight;
    if (!isRecord(preflight) ||
        preflight.contractVersion !== sdk_1.MINDSET_ACCOUNTS_V2_CONTRACT_VERSION ||
        typeof preflight.allowed !== "boolean" ||
        !["ALLOWED", "NO_SOLICITING", "COMPANY_UNAVAILABLE"].includes(String(preflight.reason))) {
        throw invalidResponse("Mindset returned an invalid v2 company call preflight");
    }
    return preflight;
}
function readV2CompanyUsageReservation(payload, tenantId, allowNull = false) {
    const record = requireRecord(payload, "v2 company usage response");
    const reservation = record.reservation;
    if (reservation === null && allowNull)
        return null;
    if (!isRecord(reservation) ||
        reservation.contractVersion !== sdk_1.MINDSET_ACCOUNTS_V2_CONTRACT_VERSION ||
        reservation.tenantId !== tenantId ||
        typeof reservation.id !== "string" ||
        typeof reservation.companyId !== "string" ||
        typeof reservation.actorUserId !== "string" ||
        !["MESSAGE", "CALL_MINUTE", "STORAGE_BYTE"].includes(String(reservation.kind)) ||
        typeof reservation.operationKey !== "string" ||
        !Number.isSafeInteger(reservation.units) ||
        reservation.units < 1 ||
        (reservation.resourceId !== null &&
            typeof reservation.resourceId !== "string") ||
        (reservation.releasedAt !== null &&
            typeof reservation.releasedAt !== "string")) {
        throw invalidResponse("Mindset returned an invalid company usage reservation");
    }
    return reservation;
}
function readV2GroupCall(payload, tenantId, scope = {}) {
    const record = requireRecord(payload, "v2 group call response");
    if (!isV2GroupCallDetail(record.call)) {
        throw invalidResponse("Mindset returned an invalid v2 group call response");
    }
    const call = record.call;
    if (call.tenantId !== tenantId ||
        (scope.callId !== undefined && call.id !== scope.callId) ||
        (scope.conversationId !== undefined &&
            call.conversationId !== scope.conversationId) ||
        (scope.scheduledCallId !== undefined &&
            call.scheduledCallId !== scope.scheduledCallId)) {
        throw invalidResponse("Mindset returned a v2 group call outside the requested scope");
    }
    return call;
}
function readV2GroupCallJoinResult(payload, tenantId, callId, userId) {
    const record = requireRecord(payload, "v2 group call join response");
    if (!isV2GroupCallDetail(record.call) ||
        !isV2LiveKitConnection(record.connection) ||
        !isIntegerInRange(record.joinEpoch, 0)) {
        throw invalidResponse("Mindset returned an invalid v2 group call join response");
    }
    const normalizedUserId = requireIdentifier(userId, "userId");
    const participant = record.call.participants.find((candidate) => candidate.userId === normalizedUserId);
    if (record.call.tenantId !== tenantId ||
        record.call.id !== callId ||
        participant?.joinEpoch !== record.joinEpoch ||
        record.connection.roomName !== record.call.roomName ||
        record.connection.participantIdentity !== `${tenantId}:${normalizedUserId}`) {
        throw invalidResponse("Mindset returned a v2 group call join outside the requested scope");
    }
    return {
        call: record.call,
        connection: record.connection,
        joinEpoch: record.joinEpoch,
    };
}
function readV2ScheduledCall(payload, tenantId, scope = {}) {
    const record = requireRecord(payload, "v2 scheduled call response");
    if (!isV2ScheduledCallDetail(record.scheduledCall)) {
        throw invalidResponse("Mindset returned an invalid v2 scheduled call response");
    }
    const scheduledCall = record.scheduledCall;
    if (scheduledCall.tenantId !== tenantId ||
        (scope.scheduledCallId !== undefined &&
            scheduledCall.id !== scope.scheduledCallId) ||
        (scope.conversationId !== undefined &&
            scheduledCall.conversationId !== scope.conversationId)) {
        throw invalidResponse("Mindset returned a v2 scheduled call outside the requested scope");
    }
    return scheduledCall;
}
function readV2ScheduledCallList(payload, tenantId, participantUserId) {
    const record = requireRecord(payload, "v2 scheduled calls response");
    const candidates = Array.isArray(record.items)
        ? record.items
        : Array.isArray(record.scheduledCalls)
            ? record.scheduledCalls
            : null;
    if (candidates === null ||
        (record.nextCursor !== undefined &&
            record.nextCursor !== null &&
            !isNonEmptyString(record.nextCursor))) {
        throw invalidResponse("Mindset returned an invalid v2 scheduled calls response");
    }
    const normalizedUserId = requireIdentifier(participantUserId, "participantUserId");
    const items = candidates.map((candidate) => {
        if (!isV2ScheduledCallDetail(candidate) ||
            candidate.tenantId !== tenantId ||
            !candidate.participants.some(({ userId }) => userId === normalizedUserId)) {
            throw invalidResponse("Mindset returned an invalid v2 scheduled call");
        }
        return candidate;
    });
    return {
        items,
        nextCursor: record.nextCursor ?? null,
    };
}
function readV2CallReaction(payload, tenantId, callId) {
    const record = requireRecord(payload, "v2 call reaction response");
    if (!isV2CallReaction(record.reaction) ||
        record.reaction.tenantId !== tenantId ||
        record.reaction.callId !== callId) {
        throw invalidResponse("Mindset returned an invalid v2 call reaction response");
    }
    return record.reaction;
}
function readV2CallReactionPolicy(payload, tenantId, callId) {
    const record = requireRecord(payload, "v2 call reaction policy response");
    if (!isV2CallReactionPolicy(record.policy) ||
        record.policy.tenantId !== tenantId ||
        record.policy.callId !== callId) {
        throw invalidResponse("Mindset returned an invalid v2 call reaction policy response");
    }
    return record.policy;
}
function readV2CallReactionEnableRequest(payload, tenantId, callId, requestId) {
    const record = requireRecord(payload, "v2 call reaction enable request response");
    if (!isV2CallReactionEnableRequest(record.request) ||
        record.request.tenantId !== tenantId ||
        record.request.callId !== callId ||
        (requestId !== undefined && record.request.id !== requestId)) {
        throw invalidResponse("Mindset returned an invalid v2 call reaction enable request response");
    }
    return record.request;
}
function requireBoundedRecordingIdentifier(value, field) {
    const id = requireIdentifier(value, field);
    if (id.length > 255 || id === "." || id === ".." || /[\u0000-\u001f\u007f]/.test(id)) {
        throw new TypeError(`Invalid ${field}`);
    }
    return id;
}
function assertDirectRecordingInput(action, input) {
    const keys = {
        create: ["requestedByUserId", "requestedMode", "mediaKind"],
        current: ["userId"],
        respond: ["userId", "joinEpoch", "mediaKind", "consentEpoch", "action", "expectedRevision"],
        resolve: ["requestedByUserId", "resolution", "expectedRevision"],
        stop: ["actorUserId", "reason", "expectedRevision"],
    }[action];
    if (!isRecord(input) || !keys.every((key) => Object.prototype.hasOwnProperty.call(input, key)) ||
        Object.keys(input).some((key) => !keys.includes(key) &&
            !(action === "create" && ["expiresInSeconds", "idempotencyKey"].includes(key)))) {
        throw new TypeError("Invalid direct recording input");
    }
    const actor = input.userId ?? input.requestedByUserId ?? input.actorUserId;
    requireBoundedRecordingIdentifier(actor, "userId");
    if ((action === "create" && (input.requestedMode !== "FULL_CALL" ||
        (input.expiresInSeconds !== undefined && !isIntegerInRange(input.expiresInSeconds, 15, 120)) ||
        (input.idempotencyKey !== undefined && (typeof input.idempotencyKey !== "string" ||
            input.idempotencyKey.trim().length < 8 || input.idempotencyKey.trim().length > 255)))) ||
        (["create", "respond"].includes(action) && !isEnumValue(input.mediaKind, ["AUDIO", "VIDEO"])) ||
        (action !== "create" && action !== "current" && !isIntegerInRange(input.expectedRevision, 0)) ||
        (action === "respond" && (!isIntegerInRange(input.joinEpoch, 0) || !isIntegerInRange(input.consentEpoch, 0) ||
            !isEnumValue(input.action, ["APPROVE", "DECLINE", "REVOKE"]))) ||
        (action === "resolve" && !isEnumValue(input.resolution, ["CONTINUE_WITHOUT_RECORDING", "LEAVE_CALL"])) ||
        (action === "stop" && !isEnumValue(input.reason, ["REQUESTER_STOPPED", "CONSENT_REVOKED", "CALL_ENDED"]))) {
        throw new TypeError("Invalid direct recording input");
    }
}
function readDirectRecordingRequest(payload, tenantId, callId, envelope, requestId) {
    const record = requireRecord(payload, "direct recording response");
    if (!hasExactKeys(record, [envelope]))
        throw invalidResponse("Invalid direct recording response");
    const value = record[envelope];
    if (envelope === "recordingRequest" && value === null)
        return null;
    if (!isRecord(value))
        throw invalidResponse("Invalid direct recording response");
    const { source, mediaKind, consentEpoch, captureState, ...historical } = value;
    if (source !== "DIRECT_V1" || !isEnumValue(mediaKind, ["AUDIO", "VIDEO"]) ||
        !isIntegerInRange(consentEpoch, 0) || !isEnumValue(captureState, ["IDLE", "STARTING", "ACTIVE", "STOPPING"]) ||
        !isV2RecordingRequestDetail(historical) || historical.tenantId !== tenantId || historical.callId !== callId ||
        (requestId !== undefined && historical.id !== requestId) || historical.resolvedMode === "LOCAL_SIDE_ONLY" ||
        historical.status === "LOCAL_SIDE_ONLY")
        throw invalidResponse("Invalid direct recording response");
    return value;
}
function parseMindsetRecordingCaptureStatus(payload, now = Date.now()) {
    const value = requireRecord(payload, "recording capture status");
    if (value.allowed === false && (hasExactKeys(value, ["allowed"]) ||
        (hasExactKeys(value, ["allowed", "mediaKind", "roomName", "participants", "expiresAt"]) &&
            value.mediaKind === null && value.roomName === null && Array.isArray(value.participants) &&
            value.participants.length === 0 && value.expiresAt === null))) {
        return { allowed: false, mediaKind: null, roomName: null, participants: [], expiresAt: null };
    }
    const bounded = (id) => typeof id === "string" && id.length > 0 && id.length <= 255 &&
        id.trim() === id && !/[\u0000-\u001f\u007f]/.test(id);
    if (!hasExactKeys(value, ["allowed", "mediaKind", "roomName", "participants", "expiresAt"]) ||
        value.allowed !== true || !isEnumValue(value.mediaKind, ["AUDIO", "VIDEO"]) || !bounded(value.roomName) ||
        !Array.isArray(value.participants) || value.participants.length < 1 || value.participants.length > 16 ||
        !value.participants.every((row) => isRecord(row) && hasExactKeys(row, ["identity", "sid"]) && bounded(row.identity) && bounded(row.sid)) ||
        new Set(value.participants.map((row) => row.identity)).size !== value.participants.length ||
        new Set(value.participants.map((row) => row.sid)).size !== value.participants.length ||
        !isTimestamp(value.expiresAt) || Date.parse(value.expiresAt) <= now || Date.parse(value.expiresAt) > now + 2000) {
        throw invalidResponse("Recording capture is not available");
    }
    return { allowed: true, mediaKind: value.mediaKind, roomName: value.roomName,
        participants: value.participants.map(({ identity, sid }) => ({ identity, sid })), expiresAt: value.expiresAt };
}
function readV2RecordingRequest(payload, tenantId, callId, recordingRequestId) {
    const record = requireRecord(payload, "v2 recording request response");
    if (!isV2RecordingRequestDetail(record.recordingRequest) ||
        record.recordingRequest.tenantId !== tenantId ||
        record.recordingRequest.callId !== callId ||
        (recordingRequestId !== undefined &&
            record.recordingRequest.id !== recordingRequestId)) {
        throw invalidResponse("Mindset returned an invalid v2 recording request response");
    }
    return record.recordingRequest;
}
function readCurrentV2RecordingRequest(payload, tenantId, callId) {
    const record = requireRecord(payload, "current v2 recording request response");
    if (!hasExactKeys(record, ["recordingRequest"])) {
        throw invalidResponse("Mindset returned an invalid current v2 recording request response");
    }
    if (record.recordingRequest === null)
        return null;
    if (!isV2RecordingRequestDetail(record.recordingRequest) ||
        record.recordingRequest.tenantId !== tenantId ||
        record.recordingRequest.callId !== callId) {
        throw invalidResponse("Mindset returned an invalid current v2 recording request response");
    }
    return record.recordingRequest;
}
function readV2RecordingAssetList(payload, tenantId, ownerUserId) {
    const record = requireRecord(payload, "v2 recording asset list response");
    if (!hasExactKeys(record, ["contractVersion", "items"]) ||
        record.contractVersion !== sdk_1.MINDSET_V2_CONTRACT_VERSION ||
        !Array.isArray(record.items) ||
        record.items.length > 100 ||
        !record.items.every((asset) => isV2RecordingAsset(asset) &&
            asset.tenantId === tenantId &&
            asset.ownerUserId === ownerUserId)) {
        throw invalidResponse("Mindset returned an invalid recording history");
    }
    return record.items;
}
function readV2RecordingAssetDownloadGrant(payload, recordingAssetId) {
    const record = requireRecord(payload, "v2 recording download response");
    if (!hasExactKeys(record, [
        "contractVersion",
        "recordingAssetId",
        "url",
        "expiresAt",
    ]) ||
        record.contractVersion !== sdk_1.MINDSET_V2_CONTRACT_VERSION ||
        record.recordingAssetId !== recordingAssetId ||
        !isHttpsUrl(record.url) ||
        !isTimestamp(record.expiresAt)) {
        throw invalidResponse("Mindset returned an invalid recording download grant");
    }
    return record;
}
function readV2DisappearingMessagePolicy(payload, tenantId, conversationId) {
    const record = requireRecord(payload, "v2 disappearing-message policy response");
    if (!isV2DisappearingMessagePolicy(record.policy) ||
        record.policy.tenantId !== tenantId ||
        record.policy.conversationId !== conversationId) {
        throw invalidResponse("Mindset returned an invalid v2 disappearing-message policy response");
    }
    return record.policy;
}
function readV2AttachmentUploadIntent(payload, tenantId, conversationId) {
    const record = requireRecord(payload, "v2 attachment upload-intent response");
    const candidate = record.uploadIntent ?? record.intent ?? record;
    if (!isV2AttachmentUploadIntent(candidate) ||
        candidate.media.tenantId !== tenantId ||
        candidate.media.conversationId !== conversationId) {
        throw invalidResponse("Mindset returned an invalid v2 attachment upload-intent response");
    }
    return candidate;
}
function readV2AttachmentMediaResponse(payload, tenantId, mediaId) {
    const record = requireRecord(payload, "v2 attachment media response");
    if (!isV2AttachmentMedia(record.media) ||
        record.media.tenantId !== tenantId ||
        record.media.id !== mediaId) {
        throw invalidResponse("Mindset returned an invalid v2 attachment media response");
    }
    return record.media;
}
function readV2AttachmentCommit(payload, tenantId, conversationId) {
    const record = requireRecord(payload, "v2 attachment commit response");
    const candidate = record.commit ?? record.result;
    if (!isV2AttachmentCommitResult(candidate) ||
        candidate.tenantId !== tenantId ||
        candidate.conversationId !== conversationId) {
        throw invalidResponse("Mindset returned an invalid v2 attachment commit response");
    }
    return candidate;
}
function readV2AttachmentMediaList(payload, tenantId, conversationId) {
    const record = requireRecord(payload, "v2 attachment media-list response");
    const candidate = isRecord(record.mediaList) ? record.mediaList : record;
    if (!isV2AttachmentMediaList(candidate) ||
        candidate.items.some((media) => media.tenantId !== tenantId || media.conversationId !== conversationId)) {
        throw invalidResponse("Mindset returned an invalid v2 attachment media-list response");
    }
    return candidate;
}
function readV2AttachmentDownloadGrant(payload, mediaId) {
    const record = requireRecord(payload, "v2 attachment download response");
    const candidate = record.download ?? record.grant ?? record;
    if (!isV2AttachmentDownloadGrant(candidate) || candidate.mediaId !== mediaId) {
        throw invalidResponse("Mindset returned an invalid v2 attachment download response");
    }
    return candidate;
}
function isV2GroupCallParticipant(value) {
    if (!isRecord(value) ||
        !hasExactKeys(value, [
            "userId",
            "displayName",
            "avatarUrl",
            "role",
            "invitationStatus",
            "presenceStatus",
            "joinEpoch",
            "invitedAt",
            "respondedAt",
            "joinedAt",
            "leftAt",
        ])) {
        return false;
    }
    return (isNonEmptyString(value.userId) &&
        isNonEmptyString(value.displayName) &&
        value.displayName.trim().length <= 160 &&
        (value.avatarUrl === null || isHttpsUrl(value.avatarUrl)) &&
        isEnumValue(value.role, ["HOST", "COHOST", "PARTICIPANT"]) &&
        isEnumValue(value.invitationStatus, V2_GROUP_CALL_INVITATION_STATUSES) &&
        isEnumValue(value.presenceStatus, ["NOT_JOINED", "JOINED", "LEFT"]) &&
        isIntegerInRange(value.joinEpoch, 0) &&
        isTimestamp(value.invitedAt) &&
        isNullableTimestamp(value.respondedAt) &&
        isNullableTimestamp(value.joinedAt) &&
        isNullableTimestamp(value.leftAt));
}
function isV2GroupCallDetail(value) {
    if (!isRecord(value) ||
        !hasExactKeys(value, [
            "contractVersion",
            "id",
            "tenantId",
            "conversationId",
            "scheduledCallId",
            "roomName",
            "kind",
            "status",
            "hostUserId",
            "participantLimit",
            "participants",
            "reactionPolicy",
            "createdAt",
            "startedAt",
            "endedAt",
            "revision",
        ]) ||
        value.contractVersion !== sdk_1.MINDSET_V2_CONTRACT_VERSION ||
        !isNonEmptyString(value.id) ||
        !isNonEmptyString(value.tenantId) ||
        !isNonEmptyString(value.conversationId) ||
        !(value.scheduledCallId === null || isNonEmptyString(value.scheduledCallId)) ||
        !isNonEmptyString(value.roomName) ||
        !isEnumValue(value.kind, ["AUDIO", "VIDEO"]) ||
        !isEnumValue(value.status, V2_GROUP_CALL_STATUSES) ||
        !isNonEmptyString(value.hostUserId) ||
        !isIntegerInRange(value.participantLimit, 2, 16) ||
        !Array.isArray(value.participants) ||
        value.participants.length < 2 ||
        value.participants.length > 16 ||
        !value.participants.every(isV2GroupCallParticipant) ||
        !isEnumValue(value.reactionPolicy, ["ENABLED", "DISABLED"]) ||
        !isTimestamp(value.createdAt) ||
        !isNullableTimestamp(value.startedAt) ||
        !isNullableTimestamp(value.endedAt) ||
        !isIntegerInRange(value.revision, 0)) {
        return false;
    }
    const participants = value.participants;
    const participantIds = participants.map(({ userId }) => userId);
    const hosts = participants.filter(({ role }) => role === "HOST");
    if (new Set(participantIds).size !== participantIds.length ||
        hosts.length !== 1 ||
        hosts[0]?.userId !== value.hostUserId ||
        participants.length > value.participantLimit ||
        (value.status === "ACTIVE" && value.startedAt === null) ||
        (["ENDED", "CANCELLED", "EXPIRED"].includes(value.status) &&
            value.endedAt === null)) {
        return false;
    }
    return true;
}
function isV2LiveKitConnection(value) {
    if (!isRecord(value) ||
        !hasExactKeys(value, [
            "serverUrl",
            "roomName",
            "participantIdentity",
            "participantToken",
            "expiresInSeconds",
        ])) {
        return false;
    }
    return (isWebSocketUrl(value.serverUrl) &&
        isNonEmptyString(value.roomName) &&
        isNonEmptyString(value.participantIdentity) &&
        isNonEmptyString(value.participantToken) &&
        isIntegerInRange(value.expiresInSeconds, 1));
}
function isV2ScheduledCallParticipant(value) {
    if (!isRecord(value) ||
        !hasExactKeys(value, [
            "userId",
            "displayName",
            "avatarUrl",
            "role",
            "response",
            "invitedAt",
            "respondedAt",
        ])) {
        return false;
    }
    return (isNonEmptyString(value.userId) &&
        isNonEmptyString(value.displayName) &&
        value.displayName.trim().length <= 160 &&
        (value.avatarUrl === null || isHttpsUrl(value.avatarUrl)) &&
        isEnumValue(value.role, ["ORGANIZER", "INVITEE"]) &&
        isEnumValue(value.response, ["PENDING", "ACCEPTED", "DECLINED", "TENTATIVE"]) &&
        isTimestamp(value.invitedAt) &&
        isNullableTimestamp(value.respondedAt));
}
function isV2ScheduledCallDetail(value) {
    if (!isRecord(value) ||
        !hasExactKeys(value, [
            "contractVersion",
            "id",
            "tenantId",
            "conversationId",
            "organizerUserId",
            "title",
            "kind",
            "status",
            "startsAt",
            "timeZone",
            "durationMinutes",
            "reminderMinutes",
            "participants",
            "groupCallId",
            "createdAt",
            "updatedAt",
            "revision",
        ]) ||
        value.contractVersion !== sdk_1.MINDSET_V2_CONTRACT_VERSION ||
        !isNonEmptyString(value.id) ||
        !isNonEmptyString(value.tenantId) ||
        !isNonEmptyString(value.conversationId) ||
        !isNonEmptyString(value.organizerUserId) ||
        !isNonEmptyString(value.title) ||
        value.title.trim().length > 160 ||
        !isEnumValue(value.kind, ["AUDIO", "VIDEO"]) ||
        !isEnumValue(value.status, V2_SCHEDULED_CALL_STATUSES) ||
        !isTimestamp(value.startsAt) ||
        !isV2TimeZone(value.timeZone) ||
        !isIntegerInRange(value.durationMinutes, 5, 480) ||
        !isV2ReminderMinutes(value.reminderMinutes) ||
        !Array.isArray(value.participants) ||
        value.participants.length < 2 ||
        value.participants.length > 16 ||
        !value.participants.every(isV2ScheduledCallParticipant) ||
        !(value.groupCallId === null || isNonEmptyString(value.groupCallId)) ||
        !isTimestamp(value.createdAt) ||
        !isTimestamp(value.updatedAt) ||
        !isIntegerInRange(value.revision, 0)) {
        return false;
    }
    const participants = value.participants;
    const participantIds = participants.map(({ userId }) => userId);
    const organizers = participants.filter(({ role }) => role === "ORGANIZER");
    return (new Set(participantIds).size === participantIds.length &&
        organizers.length === 1 &&
        organizers[0]?.userId === value.organizerUserId);
}
function isV2CallReaction(value) {
    if (!isRecord(value) ||
        !hasExactKeys(value, [
            "contractVersion",
            "id",
            "tenantId",
            "callId",
            "userId",
            "emoji",
            "occurredAt",
            "expiresAt",
        ])) {
        return false;
    }
    return (value.contractVersion === sdk_1.MINDSET_V2_CONTRACT_VERSION &&
        isNonEmptyString(value.id) &&
        isNonEmptyString(value.tenantId) &&
        isNonEmptyString(value.callId) &&
        isNonEmptyString(value.userId) &&
        isV2ReactionEmoji(value.emoji) &&
        isTimestamp(value.occurredAt) &&
        isTimestamp(value.expiresAt) &&
        Date.parse(value.expiresAt) > Date.parse(value.occurredAt));
}
function isV2CallReactionPolicy(value) {
    if (!isRecord(value) ||
        !hasExactKeys(value, [
            "contractVersion",
            "tenantId",
            "callId",
            "state",
            "updatedByUserId",
            "updatedAt",
            "revision",
        ])) {
        return false;
    }
    return (value.contractVersion === sdk_1.MINDSET_V2_CONTRACT_VERSION &&
        isNonEmptyString(value.tenantId) &&
        isNonEmptyString(value.callId) &&
        isEnumValue(value.state, ["ENABLED", "DISABLED"]) &&
        isNonEmptyString(value.updatedByUserId) &&
        isTimestamp(value.updatedAt) &&
        isIntegerInRange(value.revision, 0));
}
function isV2CallReactionEnableRequest(value) {
    if (!isRecord(value) ||
        !hasExactKeys(value, [
            "contractVersion",
            "id",
            "tenantId",
            "callId",
            "requestedByUserId",
            "status",
            "requestedAt",
            "resolvedAt",
        ]) ||
        value.contractVersion !== sdk_1.MINDSET_V2_CONTRACT_VERSION ||
        !isNonEmptyString(value.id) ||
        !isNonEmptyString(value.tenantId) ||
        !isNonEmptyString(value.callId) ||
        !isNonEmptyString(value.requestedByUserId) ||
        !isEnumValue(value.status, ["PENDING", "APPROVED", "DECLINED", "EXPIRED"]) ||
        !isTimestamp(value.requestedAt) ||
        !isNullableTimestamp(value.resolvedAt)) {
        return false;
    }
    return value.status === "PENDING"
        ? value.resolvedAt === null
        : value.resolvedAt !== null;
}
function isV2RecordingParticipantDecision(value) {
    if (!isRecord(value) ||
        !hasExactKeys(value, ["userId", "joinEpoch", "status", "decidedAt"]) ||
        !isNonEmptyString(value.userId) ||
        !isIntegerInRange(value.joinEpoch, 0) ||
        !isEnumValue(value.status, V2_RECORDING_DECISION_STATUSES) ||
        !isNullableTimestamp(value.decidedAt)) {
        return false;
    }
    return value.status === "PENDING"
        ? value.decidedAt === null
        : value.decidedAt !== null;
}
function isV2RecordingRequestDetail(value) {
    if (!isRecord(value) ||
        !hasExactKeys(value, [
            "contractVersion",
            "id",
            "tenantId",
            "callId",
            "requestedByUserId",
            "requestedMode",
            "resolvedMode",
            "status",
            "participants",
            "aggregate",
            "requestedAt",
            "expiresAt",
            "startedAt",
            "stoppedAt",
            "revision",
        ]) ||
        value.contractVersion !== sdk_1.MINDSET_V2_CONTRACT_VERSION ||
        !isNonEmptyString(value.id) ||
        !isNonEmptyString(value.tenantId) ||
        !isNonEmptyString(value.callId) ||
        !isNonEmptyString(value.requestedByUserId) ||
        value.requestedMode !== "FULL_CALL" ||
        !(value.resolvedMode === null ||
            isEnumValue(value.resolvedMode, ["FULL_CALL", "LOCAL_SIDE_ONLY"])) ||
        !isEnumValue(value.status, V2_RECORDING_REQUEST_STATUSES) ||
        !Array.isArray(value.participants) ||
        value.participants.length > 16 ||
        !value.participants.every(isV2RecordingParticipantDecision) ||
        !isV2RecordingDecisionAggregate(value.aggregate) ||
        !isTimestamp(value.requestedAt) ||
        !isTimestamp(value.expiresAt) ||
        Date.parse(value.expiresAt) <= Date.parse(value.requestedAt) ||
        !isNullableTimestamp(value.startedAt) ||
        !isNullableTimestamp(value.stoppedAt) ||
        !isIntegerInRange(value.revision, 0)) {
        return false;
    }
    const participantKeys = value.participants.map(({ userId, joinEpoch }) => `${userId}:${joinEpoch}`);
    if (new Set(participantKeys).size !== participantKeys.length ||
        value.aggregate
            .requiredParticipantCount !== value.participants.length) {
        return false;
    }
    const aggregate = value.aggregate;
    const counts = {
        pendingCount: value.participants.filter(({ status }) => status === "PENDING").length,
        approvedCount: value.participants.filter(({ status }) => status === "APPROVED").length,
        declinedCount: value.participants.filter(({ status }) => status === "DECLINED").length,
        revokedCount: value.participants.filter(({ status }) => status === "REVOKED").length,
        expiredCount: value.participants.filter(({ status }) => status === "EXPIRED").length,
    };
    return Object.entries(counts).every(([field, count]) => aggregate[field] === count);
}
function isV2RecordingAsset(value) {
    if (!isRecord(value) ||
        !hasExactKeys(value, [
            "contractVersion",
            "id",
            "tenantId",
            "callId",
            "recordingRequestId",
            "ownerUserId",
            "mode",
            "status",
            "contentType",
            "fileName",
            "byteSize",
            "startedAt",
            "stoppedAt",
            "readyAt",
        ]) ||
        value.contractVersion !== sdk_1.MINDSET_V2_CONTRACT_VERSION ||
        !isNonEmptyString(value.id) ||
        !isNonEmptyString(value.tenantId) ||
        !isNonEmptyString(value.callId) ||
        !isNonEmptyString(value.recordingRequestId) ||
        !isNonEmptyString(value.ownerUserId) ||
        !isEnumValue(value.mode, ["FULL_CALL", "LOCAL_SIDE_ONLY"]) ||
        !isEnumValue(value.status, V2_RECORDING_ASSET_STATUSES) ||
        value.contentType !== "video/mp4" ||
        !isNonEmptyString(value.fileName) ||
        value.fileName.length > 255 ||
        !(value.byteSize === null || isIntegerInRange(value.byteSize, 1)) ||
        !isTimestamp(value.startedAt) ||
        !isNullableTimestamp(value.stoppedAt) ||
        !isNullableTimestamp(value.readyAt)) {
        return false;
    }
    if (value.status === "READY") {
        return (value.byteSize !== null &&
            value.stoppedAt !== null &&
            value.readyAt !== null);
    }
    return value.status !== "RECORDING" || value.readyAt === null;
}
function isV2RecordingDecisionAggregate(value) {
    if (!isRecord(value) ||
        !hasExactKeys(value, [
            "requiredParticipantCount",
            "pendingCount",
            "approvedCount",
            "declinedCount",
            "revokedCount",
            "expiredCount",
            "unanimousApproved",
        ]) ||
        !isIntegerInRange(value.requiredParticipantCount, 0, 16) ||
        !isIntegerInRange(value.pendingCount, 0, 16) ||
        !isIntegerInRange(value.approvedCount, 0, 16) ||
        !isIntegerInRange(value.declinedCount, 0, 16) ||
        !isIntegerInRange(value.revokedCount, 0, 16) ||
        !isIntegerInRange(value.expiredCount, 0, 16) ||
        typeof value.unanimousApproved !== "boolean") {
        return false;
    }
    const total = value.pendingCount +
        value.approvedCount +
        value.declinedCount +
        value.revokedCount +
        value.expiredCount;
    const unanimousApproved = value.approvedCount === value.requiredParticipantCount &&
        value.pendingCount === 0 &&
        value.declinedCount === 0 &&
        value.revokedCount === 0 &&
        value.expiredCount === 0;
    return (total === value.requiredParticipantCount &&
        value.unanimousApproved === unanimousApproved);
}
function isV2DisappearingMessagePolicy(value) {
    if (!isRecord(value) ||
        !hasExactKeys(value, [
            "contractVersion",
            "tenantId",
            "conversationId",
            "state",
            "mode",
            "durationSeconds",
            "enabledByUserId",
            "enabledAt",
            "lockedOffByUserId",
            "lockedOffAt",
            "revision",
        ]) ||
        value.contractVersion !== sdk_1.MINDSET_V2_CONTRACT_VERSION ||
        !isNonEmptyString(value.tenantId) ||
        !isNonEmptyString(value.conversationId) ||
        !isEnumValue(value.state, ["OFF", "ENABLED", "LOCKED_OFF"]) ||
        !(value.mode === null ||
            isEnumValue(value.mode, ["AFTER_SEND", "AFTER_READ"])) ||
        !(value.durationSeconds === null ||
            isIntegerInRange(value.durationSeconds, 60, 31536000)) ||
        !(value.enabledByUserId === null || isNonEmptyString(value.enabledByUserId)) ||
        !isNullableTimestamp(value.enabledAt) ||
        !(value.lockedOffByUserId === null || isNonEmptyString(value.lockedOffByUserId)) ||
        !isNullableTimestamp(value.lockedOffAt) ||
        !isIntegerInRange(value.revision, 0)) {
        return false;
    }
    const hasEnabledFields = value.mode !== null &&
        value.durationSeconds !== null &&
        value.enabledByUserId !== null &&
        value.enabledAt !== null;
    const hasLockedFields = value.lockedOffByUserId !== null && value.lockedOffAt !== null;
    if (value.state === "ENABLED")
        return hasEnabledFields && !hasLockedFields;
    if (value.state === "LOCKED_OFF") {
        return (!hasEnabledFields &&
            value.mode === null &&
            value.durationSeconds === null &&
            value.enabledByUserId === null &&
            value.enabledAt === null &&
            hasLockedFields);
    }
    return (!hasEnabledFields &&
        !hasLockedFields &&
        value.mode === null &&
        value.durationSeconds === null &&
        value.enabledByUserId === null &&
        value.enabledAt === null &&
        value.lockedOffByUserId === null &&
        value.lockedOffAt === null);
}
function isV2AttachmentRecipientConsent(value) {
    if (!isRecord(value) ||
        !hasExactKeys(value, ["userId", "status", "decidedAt"]) ||
        !isNonEmptyString(value.userId) ||
        !isEnumValue(value.status, ["PENDING", "APPROVED", "DECLINED"]) ||
        !isNullableTimestamp(value.decidedAt)) {
        return false;
    }
    return value.status === "PENDING"
        ? value.decidedAt === null
        : value.decidedAt !== null;
}
function isV2AttachmentConsentSummary(value) {
    if (!isRecord(value) ||
        !hasExactKeys(value, [
            "recipientCount",
            "pendingCount",
            "approvedCount",
            "declinedCount",
        ]) ||
        !isIntegerInRange(value.recipientCount, 0, 15) ||
        !isIntegerInRange(value.pendingCount, 0, 15) ||
        !isIntegerInRange(value.approvedCount, 0, 15) ||
        !isIntegerInRange(value.declinedCount, 0, 15)) {
        return false;
    }
    return (value.pendingCount + value.approvedCount + value.declinedCount ===
        value.recipientCount);
}
function isV2AttachmentMedia(value) {
    if (!isRecord(value) ||
        !hasExactKeys(value, [
            "contractVersion",
            "id",
            "tenantId",
            "conversationId",
            "ownerUserId",
            "messageId",
            "kind",
            "fileName",
            "contentType",
            "byteSize",
            "sha256",
            "status",
            "recipientConsents",
            "consentSummary",
            "thumbnailAvailable",
            "createdAt",
            "updatedAt",
            "revision",
        ]) ||
        value.contractVersion !== sdk_1.MINDSET_V2_CONTRACT_VERSION ||
        !isNonEmptyString(value.id) ||
        !isNonEmptyString(value.tenantId) ||
        !isNonEmptyString(value.conversationId) ||
        !isNonEmptyString(value.ownerUserId) ||
        !(value.messageId === null || isNonEmptyString(value.messageId)) ||
        !isEnumValue(value.kind, V2_ATTACHMENT_KINDS) ||
        !isV2AttachmentFileName(value.fileName) ||
        !isNonEmptyString(value.contentType) ||
        !isIntegerInRange(value.byteSize, 1) ||
        !/^[a-f0-9]{64}$/u.test(String(value.sha256)) ||
        !isEnumValue(value.status, V2_ATTACHMENT_STATUSES) ||
        !Array.isArray(value.recipientConsents) ||
        value.recipientConsents.length > 15 ||
        !value.recipientConsents.every(isV2AttachmentRecipientConsent) ||
        !isV2AttachmentConsentSummary(value.consentSummary) ||
        typeof value.thumbnailAvailable !== "boolean" ||
        !isTimestamp(value.createdAt) ||
        !isTimestamp(value.updatedAt) ||
        !isIntegerInRange(value.revision, 0)) {
        return false;
    }
    const recipientIds = value.recipientConsents.map(({ userId }) => userId);
    const contentType = value.contentType;
    const consentSummary = value.consentSummary;
    const expectedCounts = {
        recipientCount: value.recipientConsents.length,
        pendingCount: value.recipientConsents.filter(({ status }) => status === "PENDING").length,
        approvedCount: value.recipientConsents.filter(({ status }) => status === "APPROVED").length,
        declinedCount: value.recipientConsents.filter(({ status }) => status === "DECLINED").length,
    };
    return (new Set(recipientIds).size === recipientIds.length &&
        value.byteSize <= V2_ATTACHMENT_BYTE_LIMITS[value.kind] &&
        V2_ATTACHMENT_CONTENT_TYPES[value.kind].some((allowedContentType) => allowedContentType === contentType.toLowerCase()) &&
        Object.entries(expectedCounts).every(([field, count]) => consentSummary[field] === count));
}
function isV2AttachmentUploadIntent(value) {
    if (!isRecord(value) ||
        !hasExactKeys(value, ["contractVersion", "media", "upload"]) ||
        value.contractVersion !== sdk_1.MINDSET_V2_CONTRACT_VERSION ||
        !isV2AttachmentMedia(value.media) ||
        !isRecord(value.upload) ||
        !hasExactKeys(value.upload, ["method", "url", "requiredHeaders", "expiresAt"]) ||
        value.upload.method !== "PUT" ||
        !isHttpsUrl(value.upload.url) ||
        !isStringRecord(value.upload.requiredHeaders) ||
        !isTimestamp(value.upload.expiresAt)) {
        return false;
    }
    return true;
}
function isV2AttachmentCommitResult(value) {
    if (!isRecord(value) ||
        !hasExactKeys(value, [
            "contractVersion",
            "tenantId",
            "conversationId",
            "messageId",
            "media",
            "committedAt",
        ])) {
        return false;
    }
    return (value.contractVersion === sdk_1.MINDSET_V2_CONTRACT_VERSION &&
        isNonEmptyString(value.tenantId) &&
        isNonEmptyString(value.conversationId) &&
        isNonEmptyString(value.messageId) &&
        Array.isArray(value.media) &&
        value.media.length >= 1 &&
        value.media.length <= 10 &&
        value.media.every(isV2AttachmentMedia) &&
        isTimestamp(value.committedAt));
}
function isV2AttachmentMediaList(value) {
    if (!isRecord(value) ||
        !hasExactKeys(value, ["contractVersion", "items", "nextCursor"])) {
        return false;
    }
    return (value.contractVersion === sdk_1.MINDSET_V2_CONTRACT_VERSION &&
        Array.isArray(value.items) &&
        value.items.length <= 100 &&
        value.items.every(isV2AttachmentMedia) &&
        (value.nextCursor === null || isNonEmptyString(value.nextCursor)));
}
function isV2AttachmentDownloadGrant(value) {
    if (!isRecord(value) ||
        !hasExactKeys(value, [
            "contractVersion",
            "mediaId",
            "rendition",
            "url",
            "contentType",
            "fileName",
            "byteSize",
            "expiresAt",
        ])) {
        return false;
    }
    return (value.contractVersion === sdk_1.MINDSET_V2_CONTRACT_VERSION &&
        isNonEmptyString(value.mediaId) &&
        isEnumValue(value.rendition, ["ORIGINAL", "THUMBNAIL"]) &&
        isHttpsUrl(value.url) &&
        isNonEmptyString(value.contentType) &&
        isV2AttachmentFileName(value.fileName) &&
        isIntegerInRange(value.byteSize, 1, 80 * 1024 * 1024) &&
        isTimestamp(value.expiresAt));
}
function readJoinToken(payload) {
    const record = requireRecord(payload, "call join-token response");
    const candidate = isRecord(record.join)
        ? record.join
        : isRecord(record.connection)
            ? record.connection
            : record;
    if (!isNonEmptyString(candidate.serverUrl) ||
        !isNonEmptyString(candidate.roomName) ||
        !isNonEmptyString(candidate.participantIdentity) ||
        !isNonEmptyString(candidate.participantToken) ||
        typeof candidate.expiresInSeconds !== "number" ||
        !Number.isFinite(candidate.expiresInSeconds) ||
        candidate.expiresInSeconds <= 0) {
        throw invalidResponse("Mindset returned an invalid call join-token response");
    }
    return candidate;
}
function readConversation(payload) {
    const record = requireRecord(payload, "conversation response");
    if (!(0, sdk_1.isMindsetConversation)(record.conversation)) {
        throw invalidResponse("Mindset returned an invalid conversation response");
    }
    return record.conversation;
}
function readConversations(payload) {
    const record = requireRecord(payload, "conversations response");
    if (!Array.isArray(record.conversations)) {
        throw invalidResponse("Mindset returned an invalid conversations response");
    }
    return record.conversations.map((conversation) => {
        if (!(0, sdk_1.isMindsetConversation)(conversation)) {
            throw invalidResponse("Mindset returned an invalid conversation");
        }
        return conversation;
    });
}
function readMessageFolder(payload) {
    const record = requireRecord(payload, "message folder response");
    if (!(0, sdk_1.isMindsetMessageFolder)(record.messageFolder)) {
        throw invalidResponse("Mindset returned an invalid message folder response");
    }
    return record.messageFolder;
}
function readMessageFolders(payload) {
    const record = requireRecord(payload, "message folders response");
    if (!Array.isArray(record.messageFolders) ||
        !record.messageFolders.every(sdk_1.isMindsetMessageFolder)) {
        throw invalidResponse("Mindset returned invalid message folders");
    }
    return record.messageFolders;
}
function readConversationPresenceEvent(payload) {
    const record = requireRecord(payload, "conversation presence response");
    if (!(0, sdk_1.isMindsetConversationPresenceEvent)(record.event)) {
        throw invalidResponse("Mindset returned an invalid conversation presence response");
    }
    return record.event;
}
function legacyConversationTypingLeaseId(conversationId, actorUserId) {
    return `legacy:${conversationId.trim()}:${actorUserId.trim()}`;
}
function readMessage(payload) {
    const record = requireRecord(payload, "message response");
    if (!(0, sdk_1.isMindsetMessage)(record.message)) {
        throw invalidResponse("Mindset returned an invalid message response");
    }
    return record.message;
}
function readMessages(payload) {
    const record = requireRecord(payload, "messages response");
    if (!Array.isArray(record.messages)) {
        throw invalidResponse("Mindset returned an invalid messages response");
    }
    return record.messages.map((message) => {
        if (!(0, sdk_1.isMindsetMessage)(message)) {
            throw invalidResponse("Mindset returned an invalid message");
        }
        return message;
    });
}
function readMessageAttachments(payload) {
    const record = requireRecord(payload, "message attachments response");
    if (!Array.isArray(record.attachments)) {
        throw invalidResponse("Mindset returned an invalid message attachments response");
    }
    return record.attachments.map((attachment) => {
        if (!(0, sdk_1.isMindsetMessageAttachment)(attachment)) {
            throw invalidResponse("Mindset returned an invalid message attachment");
        }
        return attachment;
    });
}
function readMessageAttachmentUploadReadiness(payload) {
    const record = requireRecord(payload, "message attachment upload readiness response");
    if (!(0, sdk_1.isMindsetMessageAttachmentUploadReadiness)(record.readiness)) {
        throw invalidResponse("Mindset returned an invalid message attachment upload readiness response");
    }
    return record.readiness;
}
function readMessageReceipt(payload) {
    const record = requireRecord(payload, "message receipt response");
    if (!(0, sdk_1.isMindsetMessageReceipt)(record.receipt)) {
        throw invalidResponse("Mindset returned an invalid message receipt response");
    }
    return record.receipt;
}
function readMessageReceipts(payload) {
    const record = requireRecord(payload, "message receipts response");
    if (!Array.isArray(record.receipts)) {
        throw invalidResponse("Mindset returned an invalid message receipts response");
    }
    return record.receipts.map((receipt) => {
        if (!(0, sdk_1.isMindsetMessageReceipt)(receipt)) {
            throw invalidResponse("Mindset returned an invalid message receipt");
        }
        return receipt;
    });
}
const CONSENT_REQUEST_STATUSES = new Set([
    "PENDING",
    "APPROVED",
    "DENIED",
    "EXPIRED",
    "REVOKED",
    "CONSUMED",
]);
const CONSENT_REQUEST_KINDS = new Set([
    "VOICE_CALL",
    "VIDEO_CALL",
    "PHOTO_MESSAGE",
    "VIDEO_MESSAGE",
]);
const CONSENT_APPROVAL_MODES = new Set([
    "ONE_TIME",
    "STANDING",
]);
const VOICEMAIL_STATUSES = new Set([
    "PENDING_UPLOAD",
    "READY",
    "FAILED",
    "EXPIRED",
    "DELETED",
]);
function readMessageReactionSnapshot(payload) {
    const record = requireRecord(payload, "message reaction snapshot response");
    if (!Array.isArray(record.reactions)) {
        throw invalidResponse("Mindset returned an invalid message reaction snapshot response");
    }
    return record.reactions.map((entry) => {
        if (!isRecord(entry) ||
            !isNonEmptyString(entry.userId) ||
            !isNonEmptyString(entry.emoji) ||
            !isNonEmptyString(entry.updatedAt)) {
            throw invalidResponse("Mindset returned an invalid message reaction snapshot entry");
        }
        return {
            userId: entry.userId,
            emoji: entry.emoji,
            updatedAt: entry.updatedAt,
        };
    });
}
function readLiveReactionEvent(payload) {
    const record = requireRecord(payload, "live reaction response");
    const event = record.event;
    if (!isRecord(event) ||
        event.type !== "LIVE_REACTION" ||
        !isNonEmptyString(event.id) ||
        !isNonEmptyString(event.conversationId) ||
        !isNonEmptyString(event.actorUserId) ||
        !isRecord(event.payload) ||
        !isNonEmptyString(event.payload.emoji)) {
        throw invalidResponse("Mindset returned an invalid live reaction response");
    }
    return event;
}
function readConsentSettingValue(value) {
    if (!isRecord(value) ||
        !isNonEmptyString(value.ownerUserId) ||
        (value.contactUserId !== null && !isNonEmptyString(value.contactUserId)) ||
        !isNonEmptyString(value.updatedAt)) {
        throw invalidResponse("Mindset returned an invalid consent setting");
    }
    return value;
}
function readConsentSettingsResult(payload) {
    const record = requireRecord(payload, "consent settings response");
    if ((record.global !== null && !isRecord(record.global)) ||
        !Array.isArray(record.contacts)) {
        throw invalidResponse("Mindset returned an invalid consent settings response");
    }
    return {
        global: record.global === null ? null : readConsentSettingValue(record.global),
        contacts: record.contacts.map(readConsentSettingValue),
    };
}
function readConsentSetting(payload) {
    const record = requireRecord(payload, "consent setting response");
    return readConsentSettingValue(record.setting);
}
function readNullableConsentSetting(payload) {
    const record = requireRecord(payload, "consent setting response");
    if (record.setting === null || record.setting === undefined)
        return null;
    return readConsentSettingValue(record.setting);
}
function readConsentRequestValue(value) {
    if (!isRecord(value) ||
        !isNonEmptyString(value.id) ||
        !isNonEmptyString(value.conversationId) ||
        !isNonEmptyString(value.requesterUserId) ||
        !isNonEmptyString(value.ownerUserId) ||
        !CONSENT_REQUEST_KINDS.has(value.kind) ||
        !CONSENT_REQUEST_STATUSES.has(value.status) ||
        !CONSENT_APPROVAL_MODES.has(value.approvalMode) ||
        !isNonEmptyString(value.expiresAt)) {
        throw invalidResponse("Mindset returned an invalid consent request");
    }
    return value;
}
function readConsentRequest(payload) {
    const record = requireRecord(payload, "consent request response");
    return readConsentRequestValue(record.request);
}
function readNullableConsentRequest(payload) {
    const record = requireRecord(payload, "consent request response");
    if (record.request === null || record.request === undefined)
        return null;
    return readConsentRequestValue(record.request);
}
function readConsentRequests(payload) {
    const record = requireRecord(payload, "consent requests response");
    if (!Array.isArray(record.requests)) {
        throw invalidResponse("Mindset returned an invalid consent requests response");
    }
    return record.requests.map(readConsentRequestValue);
}
function readVoicemailValue(value) {
    if (!isRecord(value) ||
        !isNonEmptyString(value.id) ||
        !isNonEmptyString(value.callId) ||
        !isNonEmptyString(value.conversationId) ||
        !isNonEmptyString(value.callerUserId) ||
        !isNonEmptyString(value.recipientUserId) ||
        !VOICEMAIL_STATUSES.has(value.status) ||
        !isNonEmptyString(value.expiresAt) ||
        !isNonEmptyString(value.createdAt)) {
        throw invalidResponse("Mindset returned an invalid voicemail");
    }
    return value;
}
function readVoicemail(payload) {
    const record = requireRecord(payload, "voicemail response");
    return readVoicemailValue(record.voicemail);
}
function readVoicemailList(payload) {
    const record = requireRecord(payload, "voicemails response");
    if (!Array.isArray(record.voicemails)) {
        throw invalidResponse("Mindset returned an invalid voicemails response");
    }
    return record.voicemails.map((entry) => {
        const voicemail = readVoicemailValue(entry);
        const download = entry.download;
        if (download !== null &&
            download !== undefined &&
            (!isRecord(download) ||
                !isNonEmptyString(download.url) ||
                !isNonEmptyString(download.expiresAt))) {
            throw invalidResponse("Mindset returned an invalid voicemail download grant");
        }
        return {
            ...voicemail,
            download: (download ?? null),
        };
    });
}
function readVoicemailOffer(payload) {
    const record = requireRecord(payload, "voicemail offer response");
    const voicemail = readVoicemailValue(record.voicemail);
    const greeting = record.greeting;
    if (greeting !== null &&
        greeting !== undefined &&
        (!isRecord(greeting) ||
            !isNonEmptyString(greeting.downloadUrl) ||
            typeof greeting.durationMs !== "number")) {
        throw invalidResponse("Mindset returned an invalid voicemail offer greeting");
    }
    const uploadPolicy = record.uploadPolicy;
    if (!isRecord(uploadPolicy) ||
        typeof uploadPolicy.maxDurationMs !== "number" ||
        typeof uploadPolicy.maxByteSize !== "number") {
        throw invalidResponse("Mindset returned an invalid voicemail upload policy");
    }
    return {
        voicemail,
        greeting: (greeting ?? null),
        uploadPolicy: uploadPolicy,
    };
}
function readVoicemailGreetingValue(value) {
    if (!isRecord(value) ||
        !isNonEmptyString(value.id) ||
        !isNonEmptyString(value.ownerUserId) ||
        !isNonEmptyString(value.label) ||
        typeof value.durationMs !== "number" ||
        typeof value.isActive !== "boolean") {
        throw invalidResponse("Mindset returned an invalid voicemail greeting");
    }
    return value;
}
function readVoicemailGreeting(payload) {
    const record = requireRecord(payload, "voicemail greeting response");
    return readVoicemailGreetingValue(record.greeting);
}
function readVoicemailGreetings(payload) {
    const record = requireRecord(payload, "voicemail greetings response");
    if (!Array.isArray(record.greetings)) {
        throw invalidResponse("Mindset returned an invalid voicemail greetings response");
    }
    return record.greetings.map(readVoicemailGreetingValue);
}
function readMessageReport(payload) {
    const record = requireRecord(payload, "message report response");
    if (!(0, sdk_1.isMindsetMessageReport)(record.report)) {
        throw invalidResponse("Mindset returned an invalid message report response");
    }
    return record.report;
}
function readMessageReports(payload) {
    const record = requireRecord(payload, "message reports response");
    if (!Array.isArray(record.reports) ||
        !record.reports.every(sdk_1.isMindsetMessageReport)) {
        throw invalidResponse("Mindset returned invalid message report results");
    }
    return record.reports;
}
function readContactDiscoveryReport(payload) {
    const record = requireRecord(payload, "contact discovery report response");
    if (!(0, sdk_1.isMindsetContactDiscoveryReport)(record.report)) {
        throw invalidResponse("Mindset returned an invalid contact discovery report response");
    }
    return record.report;
}
function readContactDiscoveryReports(payload) {
    const record = requireRecord(payload, "contact discovery reports response");
    if (!Array.isArray(record.reports) ||
        !record.reports.every(sdk_1.isMindsetContactDiscoveryReport)) {
        throw invalidResponse("Mindset returned invalid contact discovery report results");
    }
    return record.reports;
}
function safetyReportListRequest(input) {
    const { limitPerKind, ...request } = input;
    return {
        ...request,
        ...(limitPerKind === undefined ? {} : { limit: limitPerKind }),
    };
}
function createSafetyReportQueue(messageReports, contactDiscoveryReports) {
    return [
        ...messageReports.map((report) => ({ kind: "message", report })),
        ...contactDiscoveryReports.map((report) => ({
            kind: "contactDiscovery",
            report,
        })),
    ].sort(compareSafetyReportQueueItems);
}
function compareSafetyReportQueueItems(left, right) {
    const leftTime = Date.parse(left.report.createdAt);
    const rightTime = Date.parse(right.report.createdAt);
    if (leftTime !== rightTime)
        return leftTime - rightTime;
    return left.report.id.localeCompare(right.report.id);
}
function readUserProfile(payload) {
    const record = requireRecord(payload, "user profile response");
    if (!(0, sdk_1.isMindsetUserProfile)(record.profile)) {
        throw invalidResponse("Mindset returned an invalid user profile response");
    }
    return record.profile;
}
function readAccountSettings(payload) {
    const record = requireRecord(payload, "account settings response");
    if (!(0, sdk_1.isMindsetAccountSettings)(record.settings)) {
        throw invalidResponse("Mindset returned an invalid account settings response");
    }
    return record.settings;
}
function readConversationNotificationSettings(payload) {
    const record = requireRecord(payload, "conversation notification settings response");
    if (!(0, sdk_1.isMindsetConversationNotificationSettings)(record.conversationNotificationSettings)) {
        throw invalidResponse("Mindset returned an invalid conversation notification settings response");
    }
    return record.conversationNotificationSettings;
}
function readContactDiscoverySettings(payload) {
    const record = requireRecord(payload, "contact discovery response");
    if (!(0, sdk_1.isMindsetContactDiscoverySettings)(record.contactDiscovery)) {
        throw invalidResponse("Mindset returned an invalid contact discovery response");
    }
    return record.contactDiscovery;
}
function readContactMatches(payload) {
    const record = requireRecord(payload, "contact matches response");
    if (!Array.isArray(record.matches)) {
        throw invalidResponse("Mindset returned an invalid contact matches response");
    }
    return record.matches.map((match) => {
        if (!(0, sdk_1.isMindsetContactMatch)(match)) {
            throw invalidResponse("Mindset returned an invalid contact match");
        }
        return match;
    });
}
function uniqueContactDiscoveryHandles(handles) {
    if (!Array.isArray(handles)) {
        throw new TypeError("handles must be an array of hashed contact handles");
    }
    const seen = new Set();
    const unique = [];
    for (const handle of handles) {
        if (!(0, sdk_1.isMindsetContactHandle)(handle)) {
            throw new TypeError("handles must contain valid hashed contact handles");
        }
        const key = `${handle.kind}:${handle.hash}`;
        if (seen.has(key))
            continue;
        seen.add(key);
        unique.push({ kind: handle.kind, hash: handle.hash });
    }
    return unique;
}
function readContactDiscoveryBatchSize(batchSize = 100) {
    if (!Number.isInteger(batchSize) ||
        batchSize < 1 ||
        batchSize > 100) {
        throw new TypeError("batchSize must be an integer from 1 to 100");
    }
    return batchSize;
}
function readDeviceRegistration(payload) {
    const record = requireRecord(payload, "device registration response");
    const device = requireRecord(record.device, "device registration response");
    if (typeof device.id !== "string" ||
        typeof device.tenantId !== "string" ||
        typeof device.userId !== "string" ||
        typeof device.deviceId !== "string" ||
        (device.provider !== "fcm" &&
            device.provider !== "apns" &&
            device.provider !== "apns-voip") ||
        typeof device.appId !== "string" ||
        (device.environment !== "sandbox" && device.environment !== "production") ||
        typeof device.updatedAt !== "string") {
        throw invalidResponse("Mindset returned an invalid device registration response");
    }
    return {
        id: device.id,
        tenantId: device.tenantId,
        userId: device.userId,
        deviceId: device.deviceId,
        provider: device.provider,
        appId: device.appId,
        environment: device.environment,
        updatedAt: device.updatedAt,
        ...(typeof device.replacedDeviceId === "string"
            ? { replacedDeviceId: device.replacedDeviceId }
            : {}),
    };
}
function readHttpError(status, headerRequestId, payload, sensitiveValues) {
    const error = isRecord(payload) && isRecord(payload.error) ? payload.error : null;
    const code = typeof error?.code === "string" && /^[A-Za-z0-9_.:-]{1,100}$/.test(error.code)
        ? error.code
        : "HTTP_ERROR";
    const rawMessage = typeof error?.message === "string" && error.message.trim().length > 0
        ? error.message
        : `Mindset API request failed with status ${status}`;
    const message = redactString(rawMessage, sensitiveValues);
    const requestId = typeof error?.requestId === "string" ? error.requestId : headerRequestId;
    return new MindsetApiError({
        kind: "http",
        code,
        message,
        status,
        requestId,
        retryable: RETRYABLE_HTTP_STATUSES.has(status) &&
            !NON_RETRYABLE_HTTP_ERROR_CODES.has(code),
        ...(error && "details" in error
            ? { details: redactSensitiveValue(error.details, sensitiveValues) }
            : {}),
    });
}
function invalidResponse(message, status = null, requestId = null) {
    return new MindsetApiError({
        kind: "invalid-response",
        code: "INVALID_RESPONSE",
        message,
        status,
        requestId,
    });
}
function timeoutError(timeoutMs, attempts = 1, retryable = false) {
    return new MindsetApiError({
        kind: "timeout",
        code: "REQUEST_TIMEOUT",
        message: `Mindset API request timed out after ${timeoutMs}ms`,
        attempts: Math.max(1, attempts),
        retryable,
    });
}
function abortedError(attempts = 1) {
    return new MindsetApiError({
        kind: "aborted",
        code: "REQUEST_ABORTED",
        message: "Mindset API request was aborted",
        attempts: Math.max(1, attempts),
    });
}
function normalizeBaseUrl(value) {
    if (typeof value !== "string" || value.trim().length === 0) {
        throw new TypeError("baseUrl must be a non-empty absolute URL");
    }
    // React Native's URL shim never throws for single-argument construction,
    // so structural validation cannot rely on the try/catch below. Decide
    // acceptance from the string itself; the decisions are identical under
    // WHATWG URL and under the shim.
    const checked = parseAbsoluteUrlString(value);
    if (checked === null) {
        throw new TypeError("baseUrl must be a non-empty absolute URL");
    }
    if (checked.scheme !== "http" && checked.scheme !== "https") {
        throw new TypeError("baseUrl must use http or https");
    }
    if (checked.hasUserinfo) {
        throw new TypeError("baseUrl must not contain embedded credentials");
    }
    if (checked.scheme === "http" && !isLoopbackHostname(checked.hostname)) {
        throw new TypeError("baseUrl must use https outside local development");
    }
    let parsed;
    try {
        parsed = new URL(value.trim());
    }
    catch {
        throw new TypeError("baseUrl must be a non-empty absolute URL");
    }
    // Hermes/React Native's global URL exposes getter-only properties, so
    // assigning to `hash`/`search` throws (`Cannot assign to property 'hash'
    // which has only a getter`). Rebuild the normalized URL from getters
    // instead of mutating the parsed URL; getters are safe on both WHATWG URL
    // and React Native's URL shim. `host` already excludes default ports in
    // WHATWG URL; the explicit check below also strips them on engines whose
    // URL keeps an explicit `:443`/`:80` in `host`.
    const host = (parsed.protocol === "https:" && parsed.port === "443") ||
        (parsed.protocol === "http:" && parsed.port === "80")
        ? parsed.hostname
        : parsed.host;
    const pathname = parsed.pathname.replace(/\/$/, "");
    return `${parsed.protocol}//${host}${pathname}`;
}
function normalizeTimeout(value) {
    if (!Number.isFinite(value) || value <= 0) {
        throw new TypeError("timeoutMs must be a positive finite number");
    }
    return Math.floor(value);
}
function positiveInteger(value, field) {
    if (!Number.isSafeInteger(value) || value <= 0) {
        throw new TypeError(`${field} must be a positive integer`);
    }
    return value;
}
function boundedInteger(value, field, minimum, maximum) {
    if (!Number.isInteger(value) || value < minimum || value > maximum) {
        throw new TypeError(`${field} must be an integer from ${minimum} to ${maximum}`);
    }
    return value;
}
function requireIdentifier(value, field) {
    if (typeof value !== "string" || value.trim().length === 0) {
        throw new TypeError(`${field} must be a non-empty string`);
    }
    return value.trim();
}
function requireCallKind(value) {
    if (value !== "AUDIO" && value !== "VIDEO") {
        throw new TypeError("kind must be AUDIO or VIDEO");
    }
    return value;
}
function readGroupCallInviteCandidates(candidates) {
    if (!Array.isArray(candidates) || candidates.length < 1 || candidates.length > 24) {
        throw new TypeError("candidates must contain 1 to 24 invite candidates");
    }
    return candidates.map((candidate, index) => {
        if (!isRecord(candidate)) {
            throw new TypeError(`candidates[${index}] must be an object`);
        }
        const userId = requireIdentifier(candidate.userId, `candidates[${index}].userId`);
        const result = { userId };
        if (candidate.displayName !== undefined) {
            if (typeof candidate.displayName !== "string" || !candidate.displayName.trim()) {
                throw new TypeError(`candidates[${index}].displayName must be a non-empty string`);
            }
            result.displayName = candidate.displayName.trim();
        }
        if (candidate.avatarUrl !== undefined) {
            if (candidate.avatarUrl !== null && typeof candidate.avatarUrl !== "string") {
                throw new TypeError(`candidates[${index}].avatarUrl must be a string or null`);
            }
            if (typeof candidate.avatarUrl === "string") {
                assertHttpsUrl(candidate.avatarUrl, `candidates[${index}].avatarUrl`);
            }
            result.avatarUrl = candidate.avatarUrl;
        }
        return result;
    });
}
function assertHttpsUrl(value, field) {
    let parsed;
    try {
        parsed = new URL(value);
    }
    catch {
        throw new TypeError(`${field} must be a valid URL`);
    }
    if (parsed.protocol !== "https:") {
        throw new TypeError(`${field} must use https`);
    }
}
function encodeIdentifier(value, field) {
    return encodeURIComponent(requireIdentifier(value, field));
}
function requireIdempotencyKey(value) {
    const normalized = requireIdentifier(value, "idempotencyKey");
    if (normalized.length > 200 ||
        !/^[A-Za-z0-9._~:/+-]+$/.test(normalized)) {
        throw new TypeError("idempotencyKey must contain at most 200 URL-safe characters");
    }
    return normalized;
}
async function resolveCredentialValue(credential, label) {
    if (credential === undefined)
        return undefined;
    let value;
    try {
        value = typeof credential === "function" ? await credential() : credential;
    }
    catch {
        throw new MindsetApiError({
            kind: "credential",
            code: "CREDENTIAL_ERROR",
            message: `Unable to resolve the ${label}`,
        });
    }
    if (typeof value !== "string" || value.trim().length === 0) {
        throw new MindsetApiError({
            kind: "credential",
            code: "CREDENTIAL_ERROR",
            message: `${label} must be a non-empty string`,
        });
    }
    const normalized = value.trim();
    if (/[\u0000-\u001F\u007F]/.test(normalized)) {
        throw new MindsetApiError({
            kind: "credential",
            code: "CREDENTIAL_ERROR",
            message: `${label} contains invalid control characters`,
        });
    }
    return normalized;
}
function requireRecord(value, responseName) {
    if (!isRecord(value)) {
        throw invalidResponse(`Mindset returned an invalid ${responseName}`);
    }
    return value;
}
function isRecord(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}
function isNonEmptyString(value) {
    return typeof value === "string" && value.trim().length > 0;
}
const LOGIN_PROFILE_KINDS = [
    "PERSONAL",
    "COMPANY",
    "EXTRA_PERSONAL",
];
const PROFILE_NOTIFICATION_TYPES = [
    "VOICE_CALL",
    "VIDEO_CALL",
    "MESSAGE",
    "VOICEMAIL",
];
function readLoginProfile(value) {
    const record = requireRecord(value, "login profile response");
    if (!isNonEmptyString(record.profileUserId) ||
        !LOGIN_PROFILE_KINDS.includes(record.kind) ||
        typeof record.displayName !== "string" ||
        typeof record.isActive !== "boolean") {
        throw invalidResponse("Mindset returned an invalid login profile response");
    }
    return {
        profileUserId: record.profileUserId,
        kind: record.kind,
        displayName: record.displayName,
        handle: isNonEmptyString(record.handle) ? record.handle : null,
        avatarUrl: isNonEmptyString(record.avatarUrl) ? record.avatarUrl : null,
        companyId: isNonEmptyString(record.companyId) ? record.companyId : null,
        companyName: isNonEmptyString(record.companyName)
            ? record.companyName
            : null,
        isActive: record.isActive,
        position: Number.isInteger(record.position)
            ? record.position
            : 0,
        notificationSettings: isRecord(record.notificationSettings)
            ? readProfileNotificationSettings(record.notificationSettings)
            : { ringerEnabled: true, notificationOnly: false, disabledTypes: [] },
    };
}
function readProfileNotificationSettings(record) {
    if (typeof record.ringerEnabled !== "boolean" ||
        typeof record.notificationOnly !== "boolean" ||
        !Array.isArray(record.disabledTypes) ||
        record.disabledTypes.some((entry) => !PROFILE_NOTIFICATION_TYPES.includes(entry))) {
        throw invalidResponse("Mindset returned an invalid notification settings response");
    }
    return {
        ringerEnabled: record.ringerEnabled,
        notificationOnly: record.notificationOnly,
        disabledTypes: record.disabledTypes,
    };
}
function hasExactKeys(value, keys) {
    const actualKeys = Object.keys(value);
    return (actualKeys.length === keys.length &&
        keys.every((key) => Object.prototype.hasOwnProperty.call(value, key)));
}
function isEnumValue(value, values) {
    return typeof value === "string" && values.some((candidate) => candidate === value);
}
function isTimestamp(value) {
    return isNonEmptyString(value) && Number.isFinite(Date.parse(value));
}
function isNullableTimestamp(value) {
    return value === null || isTimestamp(value);
}
function isIntegerInRange(value, minimum, maximum = Number.MAX_SAFE_INTEGER) {
    return (typeof value === "number" &&
        Number.isSafeInteger(value) &&
        value >= minimum &&
        value <= maximum);
}
function isHttpsUrl(value) {
    if (!isNonEmptyString(value))
        return false;
    return parseAbsoluteUrlString(value)?.scheme === "https";
}
function isWebSocketUrl(value) {
    if (!isNonEmptyString(value))
        return false;
    const parsed = parseAbsoluteUrlString(value);
    if (parsed === null)
        return false;
    return (parsed.scheme === "wss" ||
        (parsed.scheme === "ws" && isLoopbackHostname(parsed.hostname)));
}
function isV2TimeZone(value) {
    return (isNonEmptyString(value) &&
        value.length <= 64 &&
        /^(?:UTC|[A-Za-z_]+(?:\/[A-Za-z0-9_+.-]+)+)$/u.test(value));
}
function isV2ReminderMinutes(value) {
    return (Array.isArray(value) &&
        value.length <= 8 &&
        value.every((minutes) => isIntegerInRange(minutes, 0, 10080)) &&
        new Set(value).size === value.length);
}
function isV2ReactionEmoji(value) {
    return (isNonEmptyString(value) &&
        value.trim().length <= 32 &&
        !/[\u0000-\u001F\u007F]/u.test(value));
}
function isV2AttachmentFileName(value) {
    return (isNonEmptyString(value) &&
        value.trim().length <= 255 &&
        !/[\u0000-\u001F\u007F/\\]/u.test(value));
}
function isStringRecord(value) {
    return (isRecord(value) &&
        Object.entries(value).every(([key, entry]) => key.trim().length >= 1 &&
            key.trim().length <= 128 &&
            isNonEmptyString(entry) &&
            entry.trim().length <= 2048));
}
function normalizeRequestError(error, phase, response) {
    if (error instanceof MindsetApiError)
        return error;
    if (phase === "credential") {
        return new MindsetApiError({
            kind: "credential",
            code: "CREDENTIAL_ERROR",
            message: "Unable to resolve the Mindset tenant credential",
        });
    }
    if (phase === "response") {
        return new MindsetApiError({
            kind: "network",
            code: "NETWORK_ERROR",
            message: "Unable to read the Mindset API response",
            status: response?.status,
            requestId: response?.headers.get("x-request-id"),
            retryable: true,
        });
    }
    return new MindsetApiError({
        kind: "network",
        code: "NETWORK_ERROR",
        message: "Unable to reach the Mindset API",
        retryable: true,
    });
}
function isRetryableFailure(error) {
    return error.retryable;
}
function withAttemptMetadata(error, attempts, retryable) {
    return new MindsetApiError({
        kind: error.kind,
        code: error.code,
        message: error.message,
        status: error.status,
        requestId: error.requestId,
        details: error.details,
        attempts,
        retryable,
    });
}
function normalizeRetry(input) {
    const result = { ...DEFAULT_RETRY, ...input };
    result.maxAttempts = positiveInteger(result.maxAttempts, "retry.maxAttempts");
    if (result.maxAttempts > 10) {
        throw new TypeError("retry.maxAttempts must not exceed 10");
    }
    result.initialDelayMs = nonNegativeInteger(result.initialDelayMs, "retry.initialDelayMs");
    result.maxDelayMs = nonNegativeInteger(result.maxDelayMs, "retry.maxDelayMs");
    if (result.maxDelayMs < result.initialDelayMs) {
        throw new TypeError("retry.maxDelayMs must be greater than or equal to retry.initialDelayMs");
    }
    if (!Number.isFinite(result.multiplier) || result.multiplier < 1) {
        throw new TypeError("retry.multiplier must be at least 1");
    }
    if (!Number.isFinite(result.jitterRatio) ||
        result.jitterRatio < 0 ||
        result.jitterRatio > 1) {
        throw new TypeError("retry.jitterRatio must be between 0 and 1");
    }
    return result;
}
function resolveRetry(defaults, override, retryableOperation) {
    if (!retryableOperation || override === false) {
        return { ...defaults, maxAttempts: 1 };
    }
    return normalizeRetry({ ...defaults, ...override });
}
function nonNegativeInteger(value, field) {
    if (!Number.isSafeInteger(value) || value < 0) {
        throw new TypeError(`${field} must be a non-negative integer`);
    }
    return value;
}
function retryDelay(retry, attempt) {
    const exponential = Math.min(retry.maxDelayMs, retry.initialDelayMs * retry.multiplier ** Math.max(0, attempt - 1));
    const jitter = exponential * retry.jitterRatio * (Math.random() * 2 - 1);
    return Math.max(0, Math.round(exponential + jitter));
}
function parseRetryAfter(value) {
    if (!value)
        return null;
    const seconds = Number(value);
    if (Number.isFinite(seconds) && seconds >= 0) {
        return Math.round(seconds * 1000);
    }
    const timestamp = Date.parse(value);
    if (!Number.isFinite(timestamp))
        return null;
    return Math.max(0, timestamp - Date.now());
}
function readContentLength(headers) {
    const raw = headers.get("content-length");
    if (!raw)
        return null;
    const value = Number(raw);
    return Number.isSafeInteger(value) && value >= 0 ? value : null;
}
function utf8Length(value) {
    if (typeof TextEncoder === "function") {
        return new TextEncoder().encode(value).byteLength;
    }
    // JSC-based React Native hosts lack TextEncoder (Hermes has it). Count
    // UTF-8 bytes directly; lone surrogates count as U+FFFD (3 bytes), which
    // matches TextEncoder's replacement behavior.
    let bytes = 0;
    for (let index = 0; index < value.length; index += 1) {
        const code = value.charCodeAt(index);
        if (code < 0x80) {
            bytes += 1;
        }
        else if (code < 0x800) {
            bytes += 2;
        }
        else if (code >= 0xd800 && code <= 0xdbff) {
            const next = index + 1 < value.length ? value.charCodeAt(index + 1) : 0;
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                index += 1;
            }
            else {
                bytes += 3;
            }
        }
        else {
            bytes += 3;
        }
    }
    return bytes;
}
function collectSensitiveValues(value) {
    if (!isRecord(value))
        return [];
    const result = [];
    for (const [key, candidate] of Object.entries(value)) {
        if ((isSensitiveKey(key) || key === "code") && typeof candidate === "string" && candidate) {
            result.push(candidate);
        }
        else if (isRecord(candidate)) {
            result.push(...collectSensitiveValues(candidate));
        }
    }
    return result;
}
function redactSensitiveValue(value, sensitiveValues, depth = 0) {
    if (value === undefined || value === null)
        return value;
    if (depth > 8)
        return "[REDACTED]";
    if (typeof value === "string")
        return redactString(value, sensitiveValues);
    if (Array.isArray(value)) {
        return value.map((item) => redactSensitiveValue(item, sensitiveValues, depth + 1));
    }
    if (!isRecord(value))
        return value;
    return Object.fromEntries(Object.entries(value).map(([key, candidate]) => [
        key,
        isSensitiveKey(key)
            ? "[REDACTED]"
            : redactSensitiveValue(candidate, sensitiveValues, depth + 1),
    ]));
}
function redactString(value, sensitiveValues) {
    let result = value;
    for (const sensitiveValue of sensitiveValues) {
        if (sensitiveValue.length >= 4) {
            result = result.split(sensitiveValue).join("[REDACTED]");
        }
    }
    return result;
}
function isSensitiveKey(key) {
    return /authorization|credential|password|private.?key|secret|ticket|token/i.test(key);
}
/**
 * Scheme-agnostic absolute-URL parser used instead of `new URL(...)` for
 * security-relevant validation. React Native's URL shim
 * (react-native/Libraries/Blob/URL.js) never throws for single-argument
 * construction and its host/hostname/username/password getters are anchored
 * to `^https?://`, returning "" for ws:/wss: URLs, so credential checks fail
 * open and loopback checks fail closed on device. Parsing the string directly
 * yields identical accept/reject decisions and identical returned strings
 * under WHATWG URL (Node, browsers) and under the shim.
 *
 * Duplicated per package by design (each package packs independently); see
 * the sibling copies in @mindset/calling-client, @mindset/customer-adapter,
 * and @mindset/react-native.
 */
function parseAbsoluteUrlString(value) {
    const input = value.trim();
    if (input.length === 0 || /[\s\u0000-\u001f\u007f]/.test(input)) {
        return null;
    }
    const match = /^([A-Za-z][A-Za-z0-9+.-]*):\/\/([^/?#]*)([/?#].*)?$/.exec(input);
    if (match === null)
        return null;
    const scheme = match[1].toLowerCase();
    const authority = match[2];
    const rest = match[3] ?? "";
    if (authority.length === 0 || authority.includes("\\"))
        return null;
    const atIndex = authority.lastIndexOf("@");
    const hasUserinfo = atIndex !== -1;
    const hostPort = hasUserinfo ? authority.slice(atIndex + 1) : authority;
    if (hostPort.length === 0)
        return null;
    let host = hostPort;
    let port = "";
    if (hostPort.startsWith("[")) {
        const closing = hostPort.indexOf("]");
        if (closing === -1)
            return null;
        host = hostPort.slice(0, closing + 1);
        const after = hostPort.slice(closing + 1);
        if (after.startsWith(":")) {
            port = after.slice(1);
        }
        else if (after.length > 0) {
            return null;
        }
        if (!/^\[[0-9A-Fa-f:.]+\]$/.test(host))
            return null;
    }
    else {
        const colonIndex = hostPort.lastIndexOf(":");
        if (colonIndex !== -1) {
            host = hostPort.slice(0, colonIndex);
            port = hostPort.slice(colonIndex + 1);
        }
        if (host.length === 0 || /[[\]:%<>^|"'`{}]/.test(host))
            return null;
    }
    if (port !== "" && (!/^\d+$/.test(port) || Number(port) > 65535)) {
        return null;
    }
    const hostname = host.toLowerCase();
    return {
        scheme,
        hasUserinfo,
        hostname,
        port,
        href: `${scheme}://${hostname}${port === "" ? "" : `:${port}`}${rest}`,
    };
}
function isLoopbackHostname(hostname) {
    const normalized = hostname.toLowerCase();
    return (normalized === "localhost" ||
        normalized === "127.0.0.1" ||
        normalized === "[::1]" ||
        normalized === "::1");
}
function abortableDelay(delayMs, signal) {
    if (signal.aborted)
        return Promise.reject(new Error("Request aborted"));
    if (delayMs <= 0)
        return Promise.resolve();
    return new Promise((resolve, reject) => {
        const timeout = setTimeout(() => {
            signal.removeEventListener("abort", abort);
            resolve();
        }, delayMs);
        const abort = () => {
            clearTimeout(timeout);
            reject(new Error("Request aborted"));
        };
        signal.addEventListener("abort", abort, { once: true });
    });
}
function waitForAbort(promise, signal) {
    if (signal.aborted)
        return Promise.reject(new Error("Request aborted"));
    return new Promise((resolve, reject) => {
        const abort = () => reject(new Error("Request aborted"));
        signal.addEventListener("abort", abort, { once: true });
        promise.then((value) => {
            signal.removeEventListener("abort", abort);
            resolve(value);
        }, (error) => {
            signal.removeEventListener("abort", abort);
            reject(error);
        });
    });
}
//# sourceMappingURL=index.js.map